// Blog posts data - Separated for better maintainability
// Last updated: 2026-05-12
// Contains 11 blog posts with full Turkish content, SEO metadata, and multi-language slugs

const LOGO_ICON = "https://customer-assets.emergentagent.com/job_event-booking-pro-7/artifacts/6r7gbjry_logo%20800x800.png";

// Blog posts data with multi-language slugs
export const blogPosts = {
  'non-lucrative-vize': {
    id: 'non-lucrative-vize',
    slugs: {
      tr: 'non-lucrative-vize',
      en: 'non-lucrative-visa',
      es: 'visa-no-lucrativa'
    },
    tag: { tr: 'Vize', en: 'Visa', es: 'Visa' },
    title: {
      tr: '<em>Non-Lucrative Vize:</em> Türkiye\'den İspanya\'ya En Kısa Yol',
      en: '<em>Non-Lucrative Visa:</em> The Shortest Route from Turkey to Spain',
      es: '<em>Visa No Lucrativa:</em> La Ruta Más Corta de Turquía a España'
    },
    excerpt: {
      tr: 'Çalışmadan İspanya\'da yaşamak isteyenler için Non-Lucrative vize en doğrudan yoldur. Detaylı rehberimizi okuyun.',
      en: 'For those who want to live in Spain without working, the Non-Lucrative visa is the most direct route. Read our detailed guide.',
      es: 'Para quienes quieren vivir en España sin trabajar, el visado No Lucrativo es la ruta más directa. Lea nuestra guía detallada.'
    },
    date: '2026-03-20',
    readTime: { tr: '3 dk okuma', en: '3 min read', es: '3 min lectura' },
    content: {
      tr: `
<h2><em>Non-Lucrative Vize</em> Nedir?</h2>
<p><strong>Non-Lucrative vize</strong>, İspanya'da çalışmadan yaşamak isteyen kişiler için tasarlanmış bir oturum iznidir. Bu vize türü, yeterli <strong>pasif gelire</strong> sahip olan ve İspanya'da aktif olarak çalışmayı planlamayan kişiler için idealdir.</p>

<h2>Kimler Başvurabilir?</h2>
<ul>
  <li><strong>Emekliler</strong> - Emekli maaşı ile yaşamak isteyenler</li>
  <li><strong>Uzaktan çalışanlar</strong> - İspanya dışından gelir elde edenler</li>
  <li><strong>Yatırımcılar</strong> - Yatırım geliri olanlar</li>
  <li><strong>Mülk sahipleri</strong> - Kira geliri olanlar</li>
</ul>

<h2>Gelir Gereksinimleri</h2>
<p>2026 yılı için güncel gereksinimler:</p>
<ul>
  <li><strong>Ana başvurucu:</strong> Yıllık <em>€28.800</em> (aylık ~€2.400)</li>
  <li><strong>Her ek aile üyesi için:</strong> Yıllık <em>€7.200</em></li>
</ul>

<h2>Gerekli Belgeler</h2>
<ol>
  <li>Geçerli pasaport <em>(minimum 1 yıl geçerlilik)</em></li>
  <li>Sabıka kaydı belgesi <em>(Apostilli)</em></li>
  <li>Sağlık sigortası <em>(İspanyol sigorta şirketinden)</em></li>
  <li>Gelir belgesi <em>(banka ekstreleri, yatırım portföyü vb.)</em></li>
  <li>Konaklama kanıtı</li>
  <li>Başvuru formu ve fotoğraflar</li>
</ol>

<h2>Süreç Nasıl İşler?</h2>
<ol>
  <li><strong>Belgelerin hazırlanması</strong> - 2-4 hafta</li>
  <li><strong>Konsolosluk randevusu</strong> - 1-2 hafta bekleme</li>
  <li><strong>Başvuru değerlendirmesi</strong> - 45-90 gün</li>
  <li><strong>İspanya'ya giriş</strong> ve TIE kartı başvurusu</li>
</ol>

<h2><em>Nova Iberian</em> Nasıl Yardımcı Olur?</h2>
<p>Uzman ekibimiz tüm süreçte yanınızda:</p>
<ul>
  <li><strong>Belge hazırlığı</strong> ve tercüme</li>
  <li><strong>Konsolosluk</strong> başvuru koordinasyonu</li>
  <li><strong>İspanya'da yerleşim</strong> desteği</li>
  <li><strong>NIE ve TIE</strong> süreç takibi</li>
</ul>
      `,
      en: `
<h2>What is a <em>Non-Lucrative Visa</em>?</h2>
<p>The <strong>Non-Lucrative visa</strong> is a residence permit designed for people who want to live in Spain without working. This visa type is ideal for those with sufficient <strong>passive income</strong> who do not plan to work actively in Spain.</p>

<h2>Who Can Apply?</h2>
<ul>
  <li><strong>Retirees</strong> - Those who want to live on pension</li>
  <li><strong>Remote workers</strong> - Earning income from outside Spain</li>
  <li><strong>Investors</strong> - Those with investment income</li>
  <li><strong>Property owners</strong> - Those with rental income</li>
</ul>

<h2>Income Requirements</h2>
<p>Current requirements for 2026:</p>
<ul>
  <li><strong>Main applicant:</strong> Annual <em>€28,800</em> (monthly ~€2,400)</li>
  <li><strong>Each additional family member:</strong> Annual <em>€7,200</em></li>
</ul>

<h2>Required Documents</h2>
<ol>
  <li>Valid passport <em>(minimum 1 year validity)</em></li>
  <li>Criminal record certificate <em>(Apostilled)</em></li>
  <li>Health insurance <em>(from Spanish insurance company)</em></li>
  <li>Proof of income <em>(bank statements, investment portfolio, etc.)</em></li>
  <li>Proof of accommodation</li>
  <li>Application form and photos</li>
</ol>

<h2>How Does the Process Work?</h2>
<ol>
  <li><strong>Document preparation</strong> - 2-4 weeks</li>
  <li><strong>Consulate appointment</strong> - 1-2 weeks waiting</li>
  <li><strong>Application review</strong> - 45-90 days</li>
  <li><strong>Entry to Spain</strong> and TIE card application</li>
</ol>

<h2>How Does <em>Nova Iberian</em> Help?</h2>
<p>Our expert team is with you throughout the process:</p>
<ul>
  <li><strong>Document preparation</strong> and translation</li>
  <li><strong>Consulate</strong> application coordination</li>
  <li><strong>Settlement in Spain</strong> support</li>
  <li><strong>NIE and TIE</strong> process tracking</li>
</ul>
      `,
      es: `
<h2>¿Qué es la <em>Visa No Lucrativa</em>?</h2>
<p>La <strong>visa No Lucrativa</strong> es un permiso de residencia diseñado para personas que desean vivir en España sin trabajar. Este tipo de visa es ideal para quienes tienen <strong>ingresos pasivos</strong> suficientes y no planean trabajar activamente en España.</p>

<h2>¿Quién Puede Solicitar?</h2>
<ul>
  <li><strong>Jubilados</strong> - Aquellos que quieren vivir de su pensión</li>
  <li><strong>Trabajadores remotos</strong> - Que obtienen ingresos fuera de España</li>
  <li><strong>Inversores</strong> - Aquellos con ingresos de inversión</li>
  <li><strong>Propietarios</strong> - Aquellos con ingresos por alquiler</li>
</ul>

<h2>Requisitos de Ingresos</h2>
<p>Requisitos actuales para 2026:</p>
<ul>
  <li><strong>Solicitante principal:</strong> Anual <em>€28.800</em> (mensual ~€2.400)</li>
  <li><strong>Por cada miembro adicional:</strong> Anual <em>€7.200</em></li>
</ul>

<h2>Documentos Requeridos</h2>
<ol>
  <li>Pasaporte válido <em>(mínimo 1 año de validez)</em></li>
  <li>Certificado de antecedentes penales <em>(Apostillado)</em></li>
  <li>Seguro médico <em>(de compañía aseguradora española)</em></li>
  <li>Prueba de ingresos <em>(extractos bancarios, cartera de inversiones, etc.)</em></li>
  <li>Prueba de alojamiento</li>
  <li>Formulario de solicitud y fotos</li>
</ol>

<h2>¿Cómo Funciona el Proceso?</h2>
<ol>
  <li><strong>Preparación de documentos</strong> - 2-4 semanas</li>
  <li><strong>Cita en el consulado</strong> - 1-2 semanas de espera</li>
  <li><strong>Revisión de solicitud</strong> - 45-90 días</li>
  <li><strong>Entrada a España</strong> y solicitud de tarjeta TIE</li>
</ol>

<h2>¿Cómo Ayuda <em>Nova Iberian</em>?</h2>
<p>Nuestro equipo de expertos está contigo durante todo el proceso:</p>
<ul>
  <li><strong>Preparación de documentos</strong> y traducción</li>
  <li>Coordinación de solicitud en el <strong>Consulado</strong></li>
  <li>Apoyo de <strong>establecimiento en España</strong></li>
  <li>Seguimiento del proceso de <strong>NIE y TIE</strong></li>
</ul>
      `
    }
  },
  'beckham-yasasi': {
    id: 'beckham-yasasi',
    slugs: {
      tr: 'beckham-yasasi',
      en: 'beckham-law',
      es: 'ley-beckham'
    },
    tag: { tr: 'Vergi', en: 'Tax', es: 'Impuestos' },
    title: {
      tr: '<em>Beckham Yasası</em> Nedir? 2026 Güncel Rehber',
      en: 'What is <em>Beckham Law</em>? 2026 Updated Guide',
      es: '¿Qué es la <em>Ley Beckham</em>? Guía Actualizada 2026'
    },
    excerpt: {
      tr: 'İspanya\'ya taşınan yabancı uyrukluların ilk 6 yıl %24 sabit vergi oranından yararlanmasını sağlayan Beckham Yasası hakkında bilmeniz gereken her şey.',
      en: 'Everything you need to know about the Beckham Law, which allows foreign nationals moving to Spain to benefit from a flat 24% tax rate for the first 6 years.',
      es: 'Todo lo que necesita saber sobre la Ley Beckham, que permite a los extranjeros que se mudan a España beneficiarse de una tasa impositiva fija del 24% durante los primeros 6 años.'
    },
    date: '2026-03-15',
    readTime: { tr: '2 dk okuma', en: '2 min read', es: '2 min lectura' },
    content: {
      tr: `
<h2><em>Beckham Yasası</em> Nedir?</h2>
<p><strong>Beckham Yasası</strong> (Régimen Especial para Trabajadores Desplazados), ünlü futbolcu <em>David Beckham</em>'ın Real Madrid'e transferi sırasında uygulanmasıyla bu ismi almıştır. Bu özel vergi rejimi, İspanya'ya taşınan yabancı uyruklulara önemli <strong>vergi avantajları</strong> sunar.</p>

<h2>Temel Avantajlar</h2>
<ul>
  <li><strong>Sabit %24 Vergi Oranı:</strong> Normal artan oranlı vergi yerine düz <em>%24</em></li>
  <li><strong>6 Yıl Geçerlilik:</strong> İlk yıl + sonraki 5 yıl</li>
  <li><strong>Sadece İspanya Geliri:</strong> Dünya çapındaki geliriniz değil, sadece İspanya'dan elde ettiğiniz gelir vergilendirilir</li>
</ul>

<h2>Kimler Yararlanabilir?</h2>
<ul>
  <li>Son <strong>5 yıl</strong> İspanya'da vergi mukimi olmayan kişiler</li>
  <li><strong>İş sözleşmesi</strong> ile İspanya'ya taşınanlar</li>
  <li><strong>Şirket yöneticileri</strong> (%25'ten az hisse sahipliği ile)</li>
  <li><strong>Digital Nomad vizesi</strong> sahipleri</li>
</ul>

<h2>Vergi Karşılaştırması</h2>
<div class="blog-table">
  <table>
    <thead>
      <tr><th>Yıllık Gelir</th><th>Normal IRPF</th><th>Beckham Yasası</th></tr>
    </thead>
    <tbody>
      <tr><td><em>€60.000</em></td><td>~%37</td><td><strong>%24</strong></td></tr>
      <tr><td><em>€100.000</em></td><td>~%45</td><td><strong>%24</strong></td></tr>
      <tr><td><em>€200.000</em></td><td>~%47</td><td><strong>%24</strong></td></tr>
    </tbody>
  </table>
</div>

<h2>Başvuru Süreci</h2>
<ol>
  <li>İspanya'ya taşındıktan sonra <strong>6 ay içinde</strong> başvuru</li>
  <li><strong>Model 149</strong> formu doldurulması</li>
  <li>Vergi dairesine belgeler ile başvuru</li>
  <li>Onay alındıktan sonra <strong>6 yıl</strong> boyunca geçerli</li>
</ol>

<h2><em>Nova Iberian</em> Nasıl Yardımcı Olur?</h2>
<ul>
  <li><strong>Uygunluk değerlendirmesi</strong></li>
  <li><strong>Başvuru belgelerinin</strong> hazırlanması</li>
  <li><strong>Vergi danışmanlığı</strong> ve planlama</li>
  <li><strong>Yıllık vergi beyannamesi</strong> desteği</li>
</ul>
      `,
      en: `
<h2>What is <em>Beckham Law</em>?</h2>
<p>The <strong>Beckham Law</strong> (Régimen Especial para Trabajadores Desplazados) got its name when it was applied during famous footballer <em>David Beckham</em>'s transfer to Real Madrid. This special tax regime offers significant <strong>tax advantages</strong> to foreign nationals moving to Spain.</p>

<h2>Key Benefits</h2>
<ul>
  <li><strong>Flat 24% Tax Rate:</strong> Instead of progressive tax rates, a flat <em>24%</em></li>
  <li><strong>6 Years Validity:</strong> First year + following 5 years</li>
  <li><strong>Only Spanish Income:</strong> Only income from Spain is taxed, not your worldwide income</li>
</ul>

<h2>Who Can Benefit?</h2>
<ul>
  <li>Individuals who have not been tax residents in Spain for the last <strong>5 years</strong></li>
  <li>Those moving to Spain with an <strong>employment contract</strong></li>
  <li><strong>Company directors</strong> (with less than 25% shareholding)</li>
  <li><strong>Digital Nomad visa</strong> holders</li>
</ul>

<h2>Tax Comparison</h2>
<div class="blog-table">
  <table>
    <thead>
      <tr><th>Annual Income</th><th>Normal IRPF</th><th>Beckham Law</th></tr>
    </thead>
    <tbody>
      <tr><td><em>€60,000</em></td><td>~37%</td><td><strong>24%</strong></td></tr>
      <tr><td><em>€100,000</em></td><td>~45%</td><td><strong>24%</strong></td></tr>
      <tr><td><em>€200,000</em></td><td>~47%</td><td><strong>24%</strong></td></tr>
    </tbody>
  </table>
</div>

<h2>Application Process</h2>
<ol>
  <li>Apply within <strong>6 months</strong> of moving to Spain</li>
  <li>Complete <strong>Model 149</strong> form</li>
  <li>Submit documents to the tax office</li>
  <li>Valid for <strong>6 years</strong> after approval</li>
</ol>

<h2>How Does <em>Nova Iberian</em> Help?</h2>
<ul>
  <li><strong>Eligibility assessment</strong></li>
  <li><strong>Application document</strong> preparation</li>
  <li><strong>Tax consulting</strong> and planning</li>
  <li><strong>Annual tax return</strong> support</li>
</ul>
      `,
      es: `
<h2>¿Qué es la <em>Ley Beckham</em>?</h2>
<p>La <strong>Ley Beckham</strong> (Régimen Especial para Trabajadores Desplazados) obtuvo su nombre cuando se aplicó durante el fichaje del famoso futbolista <em>David Beckham</em> por el Real Madrid. Este régimen fiscal especial ofrece importantes <strong>ventajas fiscales</strong> a los extranjeros que se trasladan a España.</p>

<h2>Beneficios Clave</h2>
<ul>
  <li><strong>Tasa Fija del 24%:</strong> En lugar de tasas impositivas progresivas, un <em>24%</em> fijo</li>
  <li><strong>6 Años de Validez:</strong> Primer año + siguientes 5 años</li>
  <li><strong>Solo Ingresos Españoles:</strong> Solo se gravan los ingresos de España, no los ingresos mundiales</li>
</ul>

<h2>¿Quién Puede Beneficiarse?</h2>
<ul>
  <li>Personas que no han sido residentes fiscales en España durante los últimos <strong>5 años</strong></li>
  <li>Aquellos que se trasladan a España con un <strong>contrato de trabajo</strong></li>
  <li><strong>Directores de empresa</strong> (con menos del 25% de participación)</li>
  <li>Titulares de <strong>visado de Nómada Digital</strong></li>
</ul>

<h2>Comparación de Impuestos</h2>
<div class="blog-table">
  <table>
    <thead>
      <tr><th>Ingresos Anuales</th><th>IRPF Normal</th><th>Ley Beckham</th></tr>
    </thead>
    <tbody>
      <tr><td><em>€60.000</em></td><td>~37%</td><td><strong>24%</strong></td></tr>
      <tr><td><em>€100.000</em></td><td>~45%</td><td><strong>24%</strong></td></tr>
      <tr><td><em>€200.000</em></td><td>~47%</td><td><strong>24%</strong></td></tr>
    </tbody>
  </table>
</div>

<h2>Proceso de Solicitud</h2>
<ol>
  <li>Solicitar dentro de los <strong>6 meses</strong> posteriores a la mudanza</li>
  <li>Completar el formulario <strong>Modelo 149</strong></li>
  <li>Presentar documentos en la oficina de impuestos</li>
  <li>Válido por <strong>6 años</strong> tras la aprobación</li>
</ol>

<h2>¿Cómo Ayuda <em>Nova Iberian</em>?</h2>
<ul>
  <li><strong>Evaluación de elegibilidad</strong></li>
  <li>Preparación de <strong>documentos de solicitud</strong></li>
  <li><strong>Asesoría fiscal</strong> y planificación</li>
  <li>Apoyo en la <strong>declaración anual</strong></li>
</ul>
      `
    }
  },
  'barcelona-ev-kiralamak': {
    id: 'barcelona-ev-kiralamak',
    slugs: {
      tr: 'barcelona-ev-kiralamak',
      en: 'renting-apartment-in-barcelona',
      es: 'alquilar-piso-en-barcelona'
    },
    tag: { tr: 'Yaşam', en: 'Life', es: 'Vida' },
    title: {
      tr: '<em>Barcelona\'da Ev Kiralamak:</em> Adım Adım Rehber',
      en: 'Renting a House in <em>Barcelona:</em> Step by Step Guide',
      es: 'Alquilar una Casa en <em>Barcelona:</em> Guía Paso a Paso'
    },
    excerpt: {
      tr: 'Barcelona\'da ev ararken nelere dikkat etmelisiniz? Bölge seçiminden kira sözleşmesine tüm detaylar bu rehberde.',
      en: 'What should you pay attention to when looking for a house in Barcelona? All details from neighborhood selection to rental contract in this guide.',
      es: '¿A qué debe prestar atención al buscar casa en Barcelona? Todos los detalles desde la selección del barrio hasta el contrato de alquiler en esta guía.'
    },
    date: '2026-03-10',
    readTime: { tr: '3 dk okuma', en: '3 min read', es: '3 min lectura' },
    content: {
      tr: `
<h2><em>Barcelona'da</em> Ev Kiralamak</h2>
<p><strong>Barcelona</strong>, Akdeniz iklimi, zengin kültürü ve canlı yaşam tarzıyla İspanya'nın en popüler şehirlerinden biri. Ancak ev bulmak, özellikle yabancılar için <strong>zorlayıcı</strong> olabilir.</p>

<h2>Bölge Seçimi</h2>

<h3><em>Eixample</em></h3>
<ul>
  <li><strong>Modernist mimari</strong> - Gaudí eserleri</li>
  <li><strong>Merkezi konum</strong> - Her yere kolay ulaşım</li>
  <li>Aylık kira: <em>€1.200-2.000</em></li>
</ul>

<h3><em>Gràcia</em></h3>
<ul>
  <li><strong>Bohem atmosfer</strong> - Sanatçılar ve gençler</li>
  <li><strong>Yerel dükkanlar</strong> ve kafeler</li>
  <li>Aylık kira: <em>€1.000-1.600</em></li>
</ul>

<h3><em>Poblenou</em></h3>
<ul>
  <li><strong>Teknoloji hub'ı</strong> - Startup'lar ve dijital göçebeler</li>
  <li><strong>Plaja yakın</strong> - Deniz keyfi</li>
  <li>Aylık kira: <em>€1.100-1.800</em></li>
</ul>

<h3><em>El Born / Gótico</em></h3>
<ul>
  <li><strong>Tarihi merkez</strong> - Gotik mimari</li>
  <li><strong>Canlı gece hayatı</strong> - Restoranlar ve barlar</li>
  <li>Aylık kira: <em>€1.300-2.200</em></li>
</ul>

<h2>Gerekli Belgeler</h2>
<ol>
  <li><strong>NIE numarası</strong> - Yabancı kimlik numarası</li>
  <li><strong>İş sözleşmesi</strong> veya gelir belgesi</li>
  <li><strong>Banka ekstreleri</strong> <em>(son 3 ay)</em></li>
  <li><strong>Pasaport</strong> kopyası</li>
  <li>Referans mektupları <em>(varsa)</em></li>
</ol>

<h2>Kira Süreci</h2>
<ol>
  <li><strong>Arama:</strong> Idealista, Fotocasa, Habitaclia gibi siteleri kullanın</li>
  <li><strong>Görüntüleme:</strong> En az <em>5-10 daire</em> görün</li>
  <li><strong>Başvuru:</strong> Belgelerinizi hazırlayın</li>
  <li><strong>Depozito:</strong> Genellikle <em>2 aylık kira</em></li>
  <li><strong>Sözleşme:</strong> Avukat kontrolü önerilir</li>
</ol>

<h2>Dikkat Edilmesi Gerekenler</h2>
<ul>
  <li><strong>Sıcak su</strong> için garaj/caldera kontrol edin</li>
  <li><strong>Topluluk giderlerini</strong> (gastos de comunidad) sorun</li>
  <li><strong>Mobilyalı/mobilyasız</strong> seçenekleri karşılaştırın</li>
  <li><strong>Minimum kira süresi</strong> genellikle <em>1 yıl</em></li>
</ul>

<h2><em>Nova Iberian</em> Nasıl Yardımcı Olur?</h2>
<ul>
  <li><strong>Güvenilir emlak acenteleriyle</strong> bağlantı</li>
  <li><strong>Sözleşme inceleme</strong> ve tercüme</li>
  <li><strong>Empadronamiento</strong> (adres kaydı) desteği</li>
  <li><strong>Hizmet bağlantıları</strong> (elektrik, su, internet)</li>
</ul>
      `,
      en: `
<h2>Renting in <em>Barcelona</em></h2>
<p><strong>Barcelona</strong> is one of Spain's most popular cities with its Mediterranean climate, rich culture and vibrant lifestyle. However, finding a home can be <strong>challenging</strong>, especially for foreigners.</p>

<h2>Choosing a Neighborhood</h2>

<h3><em>Eixample</em></h3>
<ul>
  <li><strong>Modernist architecture</strong> - Gaudí's works</li>
  <li><strong>Central location</strong> - Easy access everywhere</li>
  <li>Monthly rent: <em>€1,200-2,000</em></li>
</ul>

<h3><em>Gràcia</em></h3>
<ul>
  <li><strong>Bohemian atmosphere</strong> - Artists and young people</li>
  <li><strong>Local shops</strong> and cafes</li>
  <li>Monthly rent: <em>€1,000-1,600</em></li>
</ul>

<h3><em>Poblenou</em></h3>
<ul>
  <li><strong>Technology hub</strong> - Startups and digital nomads</li>
  <li><strong>Close to beach</strong> - Sea enjoyment</li>
  <li>Monthly rent: <em>€1,100-1,800</em></li>
</ul>

<h3><em>El Born / Gothic</em></h3>
<ul>
  <li><strong>Historic center</strong> - Gothic architecture</li>
  <li><strong>Lively nightlife</strong> - Restaurants and bars</li>
  <li>Monthly rent: <em>€1,300-2,200</em></li>
</ul>

<h2>Required Documents</h2>
<ol>
  <li><strong>NIE number</strong> - Foreign ID number</li>
  <li><strong>Employment contract</strong> or proof of income</li>
  <li><strong>Bank statements</strong> <em>(last 3 months)</em></li>
  <li><strong>Passport</strong> copy</li>
  <li>Reference letters <em>(if available)</em></li>
</ol>

<h2>Rental Process</h2>
<ol>
  <li><strong>Search:</strong> Use sites like Idealista, Fotocasa, Habitaclia</li>
  <li><strong>Viewing:</strong> View at least <em>5-10 apartments</em></li>
  <li><strong>Application:</strong> Prepare your documents</li>
  <li><strong>Deposit:</strong> Usually <em>2 months rent</em></li>
  <li><strong>Contract:</strong> Lawyer review recommended</li>
</ol>

<h2>Things to Watch Out For</h2>
<ul>
  <li>Check <strong>hot water</strong> system (garage/boiler)</li>
  <li>Ask about <strong>community fees</strong> (gastos de comunidad)</li>
  <li>Compare <strong>furnished/unfurnished</strong> options</li>
  <li><strong>Minimum rental period</strong> usually <em>1 year</em></li>
</ul>

<h2>How Does <em>Nova Iberian</em> Help?</h2>
<ul>
  <li>Connection with <strong>reliable real estate agents</strong></li>
  <li><strong>Contract review</strong> and translation</li>
  <li><strong>Empadronamiento</strong> (address registration) support</li>
  <li><strong>Service connections</strong> (electricity, water, internet)</li>
</ul>
      `,
      es: `
<h2>Alquilar en <em>Barcelona</em></h2>
<p><strong>Barcelona</strong> es una de las ciudades más populares de España con su clima mediterráneo, rica cultura y estilo de vida vibrante. Sin embargo, encontrar una casa puede ser <strong>desafiante</strong>, especialmente para los extranjeros.</p>

<h2>Elegir un Barrio</h2>

<h3><em>Eixample</em></h3>
<ul>
  <li><strong>Arquitectura modernista</strong> - Obras de Gaudí</li>
  <li><strong>Ubicación central</strong> - Fácil acceso a todo</li>
  <li>Alquiler mensual: <em>€1.200-2.000</em></li>
</ul>

<h3><em>Gràcia</em></h3>
<ul>
  <li><strong>Atmósfera bohemia</strong> - Artistas y jóvenes</li>
  <li><strong>Tiendas locales</strong> y cafeterías</li>
  <li>Alquiler mensual: <em>€1.000-1.600</em></li>
</ul>

<h3><em>Poblenou</em></h3>
<ul>
  <li><strong>Hub tecnológico</strong> - Startups y nómadas digitales</li>
  <li><strong>Cerca de la playa</strong> - Disfrute del mar</li>
  <li>Alquiler mensual: <em>€1.100-1.800</em></li>
</ul>

<h3><em>El Born / Gótico</em></h3>
<ul>
  <li><strong>Centro histórico</strong> - Arquitectura gótica</li>
  <li><strong>Vida nocturna animada</strong> - Restaurantes y bares</li>
  <li>Alquiler mensual: <em>€1.300-2.200</em></li>
</ul>

<h2>Documentos Requeridos</h2>
<ol>
  <li><strong>Número NIE</strong> - Número de identificación extranjero</li>
  <li><strong>Contrato de trabajo</strong> o prueba de ingresos</li>
  <li><strong>Extractos bancarios</strong> <em>(últimos 3 meses)</em></li>
  <li>Copia del <strong>pasaporte</strong></li>
  <li>Cartas de referencia <em>(si están disponibles)</em></li>
</ol>

<h2>Proceso de Alquiler</h2>
<ol>
  <li><strong>Búsqueda:</strong> Use sitios como Idealista, Fotocasa, Habitaclia</li>
  <li><strong>Visitas:</strong> Vea al menos <em>5-10 apartamentos</em></li>
  <li><strong>Solicitud:</strong> Prepare sus documentos</li>
  <li><strong>Depósito:</strong> Generalmente <em>2 meses de alquiler</em></li>
  <li><strong>Contrato:</strong> Se recomienda revisión de abogado</li>
</ol>

<h2>Cosas a Tener en Cuenta</h2>
<ul>
  <li>Verificar sistema de <strong>agua caliente</strong> (caldera)</li>
  <li>Preguntar sobre <strong>gastos de comunidad</strong></li>
  <li>Comparar opciones <strong>amueblado/sin amueblar</strong></li>
  <li><strong>Período mínimo</strong> de alquiler generalmente <em>1 año</em></li>
</ul>

<h2>¿Cómo Ayuda <em>Nova Iberian</em>?</h2>
<ul>
  <li>Conexión con <strong>agentes inmobiliarios confiables</strong></li>
  <li><strong>Revisión de contrato</strong> y traducción</li>
  <li>Apoyo de <strong>Empadronamiento</strong> (registro de dirección)</li>
  <li><strong>Conexiones de servicios</strong> (electricidad, agua, internet)</li>
</ul>
      `
    }
  },
  'ees-sistemi-schengen-2026': {
    id: 'ees-sistemi-schengen-2026',
    slugs: {
      tr: 'ees-sistemi-schengen-2026',
      en: 'ees-system-schengen-2026',
      es: 'sistema-ees-schengen-2026'
    },
    tag: { tr: 'Vize & Seyahat', en: 'Visa & Travel', es: 'Visa y Viaje' },
    title: {
      tr: '<em>EES Sistemi Devrede:</em> Türk Yolcular İçin Schengen\'de Artık Hiçbir Şey Eskisi Gibi Değil',
      en: '<em>EES System Active:</em> Nothing in Schengen is the Same for Turkish Travelers',
      es: '<em>Sistema EES Activo:</em> Nada en Schengen es Igual para los Viajeros Turcos'
    },
    excerpt: {
      tr: '10 Nisan 2026\'da Schengen\'de her şey değişti. 600 kaçırılan uçuş, 3 saatlik kuyruklar ve biyometrik kayıt zorunluluğu. Türk vatandaşları için kapsamlı EES rehberi.',
      en: 'Everything changed in Schengen on April 10, 2026. 600 missed flights, 3-hour queues and mandatory biometric registration. Comprehensive EES guide for Turkish citizens.',
      es: 'Todo cambió en Schengen el 10 de abril de 2026. 600 vuelos perdidos, colas de 3 horas y registro biométrico obligatorio. Guía completa de EES para ciudadanos turcos.'
    },
    date: '2026-03-27',
    readTime: { tr: '9 dk okuma', en: '9 min read', es: '9 min lectura' },
    content: {
      tr: `
<p>Eğer:</p>
<ul>
  <li>Yakın zamanda <strong>Avrupa'ya seyahat</strong> planınız varsa</li>
  <li>EES'in <strong>Türk pasaportunu</strong> nasıl etkilediğini merak ediyorsanız</li>
  <li><em>"90 gün yeterliydi, artık yeterli mi?"</em> sorusunu soruyorsanız</li>
  <li><strong>İspanya'ya taşınmayı</strong> ya da uzun süreli kalmayı düşünüyorsanız</li>
</ul>
<p><strong>Bu yazıyı mutlaka okuyun!!</strong></p>

<p>Mart 2026'nın son haftasında <strong>Brüksel Havalimanı</strong> resmi bir açıklama yaptı: Dört gün içinde <em>600 uçuş kaçırıldı</em>, toplam 21 saat gecikme yaşandı ve bu gecikmelerin tek nedeni yeni sınır kontrol sistemiydi. Söz konusu sistem, Avrupa Birliği'nin yıllardır ertelediği <strong>EES — Entry / Exit System</strong>, Türkçesiyle <em>Giriş/Çıkış Sistemi</em>.</p>

<p><strong>10 Nisan 2026</strong> itibarıyla 29 Schengen ülkesinin tamamında tam kapasite devreye girdi. Pasaport damgası tarihe karıştı, yerine <strong>parmak izi</strong> ve <strong>yüz taraması</strong> geldi.</p>

<div class="blog-stats-box">
  <div class="stat-item"><span class="stat-number">600</span><span class="stat-label">Brüksel'de 4 günde kaçırılan uçuş</span></div>
  <div class="stat-item"><span class="stat-number">%70</span><span class="stat-label">ACI'ye göre sınır işlem süresi artışı</span></div>
  <div class="stat-item"><span class="stat-number">4 saat</span><span class="stat-label">Bazı havalimanlarında bekleme süresi</span></div>
</div>

<h2>1. <em>EES</em> Nedir?</h2>
<p>EES, kısaca şu anlama geliyor: Bundan böyle <strong>Schengen'e her girişinizde ve çıkışınızda</strong> verileriniz dijital olarak kaydediliyor. İlk girişte <strong>parmak iziniz</strong> ve <strong>yüz görüntünüz</strong> alınıyor; bu veriler AB'nin merkezi veri tabanında <em>üç yıl boyunca</em> saklanıyor.</p>

<p>Sistemin bir diğer temel değişikliği şu: <em>"180 günde 90 gün kalış"</em> kuralı artık sınır görevlisinin ya da sizin manuel olarak saydığı bir kural değil. <strong>EES bu süreyi otomatik takip ediyor.</strong> Sürenizi aştığınız an, sınır birimlerine otomatik bildirim gönderiliyor.</p>

<p><strong>Pratikte bu ne demek?</strong> Artık <em>"kim sayar ki"</em> ya da <em>"fark etmez"</em> gibi bir güvenli alan yok. <strong>Sistem sayıyor.</strong></p>

<h2>2. 10 Nisan'dan İtibaren Schengen'de Ne Değişti?</h2>

<h3><em>Değişiklik 1</em> — Biyometrik Kayıt Artık Zorunlu</h3>
<p>İlk Schengen girişinizde pasaport kontrol görevlisi <strong>dört parmak izinizi</strong> ve <strong>yüz görüntünüzü</strong> sisteme kaydeder. Bu işlem <em>45–50 saniye</em> sürüyor. Kayıtlı olmak size bir öncelik tanımıyor.</p>

<h3><em>Değişiklik 2</em> — Pasaport Damgası Bitti</h3>
<p>10 Nisan'dan itibaren pasaportlara <strong>fiziksel giriş/çıkış damgası vurulmuyor</strong>. Tüm kayıtlar dijital ortamda tutuluyor.</p>

<h3><em>Değişiklik 3</em> — 90 Gün Kuralı Otomatik Takipte</h3>
<p><strong>180 gün içinde en fazla 90 gün</strong> Schengen'de kalabilirsiniz. Bu kural değişmedi; ama artık sistemi atlayamazsınız. EES her girişinizi ve çıkışınızı milisaniyeler içinde güncelliyor.</p>

<h2>3. <em>Türk Vatandaşları</em> EES'ten Nasıl Etkileniyor?</h2>
<p>EES, AB dışından gelen herkesi kapsıyor. Türk vatandaşları — vize almış olsun ya da olmasın — bu sistemin içinde.</p>

<ul>
  <li><strong>Vize alan da EES'ten muaf değil</strong> — Schengen vizesi almak biyometrik kayıt yükümlülüğünü kaldırmıyor.</li>
  <li><strong>Yeşil pasaport da kapsam içinde</strong> — Tek istisna diplomatik pasaport sahipleri.</li>
  <li><strong>Konsolosluk biyometrisi geçersiz</strong> — Vize başvurusunda verdiğiniz parmak izi EES için geçerli sayılmıyor.</li>
  <li><strong>İlk kayıt zaman alıyor</strong> — Yoğun havalimanlarında bu süre <em>4 saate</em> ulaştı.</li>
  <li><strong>90 gün aşımı anında tespit ediliyor</strong> — Gelecekteki vize başvurularında da olumsuz kayıt oluşturuyor.</li>
</ul>

<h2>4. Havalimanlarında Gerçekte Ne Yaşandı?</h2>

<h3><em>Brüksel Havalimanı</em></h3>
<p>EES testinin ilk dört gününde <strong>600 uçuş kaçırıldı</strong> ve toplam <em>21 saatlik gecikme</em> yaşandı. Varışta bekleme süresi <strong>üç saati</strong>, kalkışta <strong>iki saati</strong> aştı.</p>

<h3><em>Portekiz: Lizbon, Porto ve Faro</em></h3>
<p>11 Nisan 2026 sabahı — yani 10 Nisan'dan yalnızca bir gün sonra — bu havalimanları aşırı bekleme süreleri gerekçesiyle EES biyometrik kayıt uygulamasını <strong>geçici olarak durdurdu</strong>.</p>

<h3><em>ACI Europe ve A4E</em></h3>
<p>EES'nin uygulandığı noktalarda kişi başı işlem süresinin <strong>%70'e kadar arttığını</strong> gösteriyor. Her iki kuruluş da Avrupa Komisyonu'ndan yaz sezonu boyunca EES'i tamamen askıya alabilme yetkisi talep etti.</p>

<h2>5. Havalimanında Ne Yapmalısınız? <em>Pratik Rehber</em></h2>
<ol>
  <li><strong>En az 4 saat erken gelin.</strong> Brüksel Havalimanı'nın resmi tavsiyesi 3 saat; uzmanlar buna 1 saat daha ekliyor.</li>
  <li><strong>Aktarmalı uçuşlarda bağlantı süresini en az 3–4 saate çıkarın.</strong></li>
  <li><strong>Bağlantılı (tek bilet) uçuş tercih edin.</strong> EES kuyruğu nedeniyle aktarma uçuşunuzu kaçırırsanız, havayolu size bir sonraki uçuşta yer açmak zorunda.</li>
  <li><strong>"Travel to Europe" uygulamasını indirin.</strong> Frontex'in sunduğu bu uygulama sınırda geçirilen süreyi kısaltabiliyor.</li>
  <li><strong>Biyometrik pasaportunuz varsa yanınızda olsun.</strong> Self-servis kiosklardan yararlanabilirsiniz.</li>
</ol>

<h2>6. <em>EES ve Oturum İzni:</em> Asıl Önemli Bağlantı</h2>
<p>Bu bölüm, <strong>Nova Iberian</strong> olarak size en çok söylemek istediğimiz yer. EES sistemiyle birlikte <em>"90 günlük turist olarak gelirim, giderim"</em> modeli hem çok daha zahmetli hem de çok daha riskli bir hal aldı.</p>

<p>Öte yandan, sistemin kendisi bir <strong>istisna grubu</strong> tanımlıyor. <em>AB ülkelerinden geçerli uzun süreli vize ya da oturum iznine sahip kişiler EES kapsamı dışında.</em></p>

<p><strong>Bir başka deyişle:</strong> İspanya'da geçerli bir <em>TIE kartınız</em> (oturum izni belgesi) varsa Schengen sınırında AB vatandaşlarıyla aynı hattan geçiyorsunuz. <strong>EES kuyruğu yok. 90 günlük sınır yok. Biyometrik kayıt yükümlülüğü yok.</strong></p>

<p>İspanya, bu oturum iznine ulaşmak için çeşitli yollar sunuyor:</p>
<ul>
  <li><strong>Dijital Göçmen Vizesi</strong> (uzaktan çalışanlar için)</li>
  <li><strong>Non Lucrativa</strong> (pasif gelir sahipleri için)</li>
  <li><strong>Girişimci Vizesi</strong> (startup ve SL sahipleri için)</li>
  <li><strong>Şirket İçi Transfer Vizesi</strong></li>
</ul>

<h2>7. <em>EES ile ETIAS</em> Aynı Şey Değil</h2>
<p>Sosyal medyada <em>"yeşil pasaportlulara da ETIAS geliyor"</em> türünden haberler dolaşıyor. <strong>Bu bilgi yanlış.</strong> AB'nin Türkiye'deki resmi delegasyonu bu konuyu açıkça netleştirdi: <em>Türkiye ETIAS kapsamı dışında.</em></p>

<h2>8. Sık Sorulan Sorular</h2>

<h3>EES'e kayıtlıysam bir sonraki seyahatimde kuyruk olmaz, değil mi?</h3>
<p><strong>Maalesef yanlış.</strong> Kayıtlı olmak öncelikli geçiş hakkı tanımıyor. Her seyahatte aynı manuel kontrol sıralarında beklemeniz gerekiyor.</p>

<h3>Vize aldım, yine de biyometrik kayıt yaptırmam gerekiyor mu?</h3>
<p><strong>Evet.</strong> Konsolosluğa vize başvurusu sırasında verdiğiniz biyometrik veri EES için geçerli sayılmıyor.</p>

<h3>90 günlük süremi geçersem ne olur?</h3>
<p>EES sistemi süre aşımını <strong>otomatik olarak</strong> sınır birimlerine bildiriyor. Bu durum hem mevcut hem de gelecekteki vize başvurularında olumsuz kayıt olarak kalabiliyor.</p>

<h3>İspanya'da oturum iznine sahipsem EES'ten nasıl etkilenirim?</h3>
<p>Geçerli bir İspanya oturum izni (TIE kartı) varsa <strong>EES sizi kapsamıyor</strong>. Schengen sınırında AB vatandaşlarıyla aynı hattan geçiyorsunuz.</p>

<h2>9. Sonuç: <em>EES Avrupa'da Turist Olmayı Daha Zor, Yerleşmeyi Daha Mantıklı Kılıyor</em></h2>
<p>10 Nisan 2026 yalnızca bir teknik güncelleme değil; <strong>Schengen bölgesinde seyahat etme biçimimizin köklü bir dönüşümüydü.</strong> Pasaport damgası bitti. Biyometrik veriler zorunlu hale geldi. 90 gün kuralı artık otomatik takipte.</p>

<p>Öte yandan <strong>İspanya'da yasal oturum izni</strong>, sizi bu tablonun dışına çıkarıyor. <em>EES kuyruğu yok. 90 gün sınırı yok. Biyometrik bekleme yok.</em></p>

<p><strong>Hangi oturum izninin size uygun olduğunu ücretsiz ön değerlendirmemizle birlikte konuşabiliriz.</strong></p>
      `,
      en: `
<p>If you:</p>
<ul>
  <li>Have <strong>travel plans to Europe</strong> soon</li>
  <li>Wonder how EES affects <strong>Turkish passport</strong> holders</li>
  <li>Ask yourself <em>"90 days was enough, is it still enough?"</em></li>
  <li>Consider <strong>moving to Spain</strong> or staying long-term</li>
</ul>
<p><strong>You must read this article!!</strong></p>

<p>In the last week of March 2026, <strong>Brussels Airport</strong> made an official announcement: <em>600 flights were missed</em> in four days, with a total of 21 hours of delays, all due to the new border control system. This system is the <strong>EES — Entry / Exit System</strong> that the European Union had been postponing for years.</p>

<p>As of <strong>April 10, 2026</strong>, it became fully operational across all 29 Schengen countries. Passport stamps became history, replaced by <strong>fingerprints</strong> and <strong>facial scans</strong>.</p>

<h2>1. What is <em>EES</em>?</h2>
<p>EES simply means: From now on, your data is digitally recorded <strong>every time you enter and exit Schengen</strong>. On your first entry, your <strong>fingerprints</strong> and <strong>facial image</strong> are taken; this data is stored in the EU's central database for <em>three years</em>.</p>

<p>Another key change: The <em>"90 days in 180 days"</em> rule is no longer manually counted by border officers or yourself. <strong>EES automatically tracks this period.</strong> The moment you exceed your time, automatic notification is sent to border authorities.</p>

<h2>2. What Changed in Schengen After April 10?</h2>

<h3><em>Change 1</em> — Biometric Registration is Now Mandatory</h3>
<p>On your first Schengen entry, the passport control officer records your <strong>four fingerprints</strong> and <strong>facial image</strong>. This process takes <em>45-50 seconds</em>. Being registered doesn't give you priority.</p>

<h3><em>Change 2</em> — Passport Stamps Ended</h3>
<p>From April 10, <strong>physical entry/exit stamps are no longer placed</strong> in passports. All records are kept digitally.</p>

<h3><em>Change 3</em> — 90-Day Rule is Automatically Tracked</h3>
<p>You can stay in Schengen for <strong>maximum 90 days within 180 days</strong>. This rule hasn't changed; but you can no longer bypass the system.</p>

<h2>3. How Does EES Affect <em>Turkish Citizens</em>?</h2>
<ul>
  <li><strong>Having a visa doesn't exempt you from EES</strong> — Getting a Schengen visa doesn't remove your biometric registration obligation.</li>
  <li><strong>Green passport is also included</strong> — The only exception is diplomatic passport holders.</li>
  <li><strong>Consulate biometrics are invalid</strong> — Fingerprints given during visa application don't count for EES.</li>
  <li><strong>First registration takes time</strong> — At busy airports, this time reached <em>4 hours</em>.</li>
</ul>

<h2>4. <em>EES and Residence Permit:</em> The Important Connection</h2>
<p>The system defines an <strong>exception group</strong>. <em>People with valid long-term visas or residence permits from EU countries are exempt from EES.</em></p>

<p><strong>In other words:</strong> If you have a valid <em>TIE card</em> (residence permit) in Spain, you pass through the same lane as EU citizens at Schengen borders. <strong>No EES queue. No 90-day limit. No biometric registration requirement.</strong></p>

<h2>5. Conclusion: <em>EES Makes Being a Tourist in Europe Harder, Settling Down More Sensible</em></h2>
<p>April 10, 2026 was not just a technical update; it was a <strong>fundamental transformation in how we travel in the Schengen area.</strong> Passport stamps ended. Biometric data became mandatory. The 90-day rule is now automatically tracked.</p>

<p>On the other hand, <strong>legal residence in Spain</strong> takes you outside this picture. <em>No EES queue. No 90-day limit. No biometric waiting.</em></p>
      `,
      es: `
<p>Si usted:</p>
<ul>
  <li>Tiene <strong>planes de viaje a Europa</strong> próximamente</li>
  <li>Se pregunta cómo afecta el EES a los titulares de <strong>pasaporte turco</strong></li>
  <li>Se pregunta <em>"90 días eran suficientes, ¿todavía lo son?"</em></li>
  <li>Considera <strong>mudarse a España</strong> o quedarse a largo plazo</li>
</ul>
<p><strong>¡Debe leer este artículo!!</strong></p>

<p>En la última semana de marzo de 2026, el <strong>Aeropuerto de Bruselas</strong> hizo un anuncio oficial: <em>600 vuelos se perdieron</em> en cuatro días, con un total de 21 horas de retrasos, todo debido al nuevo sistema de control fronterizo. Este sistema es el <strong>EES — Sistema de Entrada/Salida</strong> que la Unión Europea había estado posponiendo durante años.</p>

<p>A partir del <strong>10 de abril de 2026</strong>, entró en pleno funcionamiento en los 29 países Schengen. Los sellos de pasaporte pasaron a la historia, reemplazados por <strong>huellas dactilares</strong> y <strong>escaneos faciales</strong>.</p>

<h2>1. ¿Qué es <em>EES</em>?</h2>
<p>EES simplemente significa: De ahora en adelante, sus datos se registran digitalmente <strong>cada vez que entra y sale de Schengen</strong>. En su primera entrada, se toman sus <strong>huellas dactilares</strong> e <strong>imagen facial</strong>; estos datos se almacenan en la base de datos central de la UE durante <em>tres años</em>.</p>

<h2>2. ¿Qué Cambió en Schengen Después del 10 de Abril?</h2>

<h3><em>Cambio 1</em> — El Registro Biométrico es Ahora Obligatorio</h3>
<p>En su primera entrada a Schengen, el oficial de control de pasaportes registra sus <strong>cuatro huellas dactilares</strong> e <strong>imagen facial</strong>. Este proceso toma <em>45-50 segundos</em>.</p>

<h3><em>Cambio 2</em> — Los Sellos de Pasaporte Terminaron</h3>
<p>Desde el 10 de abril, <strong>ya no se colocan sellos físicos de entrada/salida</strong> en los pasaportes.</p>

<h3><em>Cambio 3</em> — La Regla de 90 Días se Rastrea Automáticamente</h3>
<p>Puede permanecer en Schengen un <strong>máximo de 90 días dentro de 180 días</strong>. Esta regla no ha cambiado; pero ya no puede evadir el sistema.</p>

<h2>3. <em>EES y Permiso de Residencia:</em> La Conexión Importante</h2>
<p>El sistema define un <strong>grupo de excepción</strong>. <em>Las personas con visas de larga duración válidas o permisos de residencia de países de la UE están exentas del EES.</em></p>

<p><strong>En otras palabras:</strong> Si tiene una <em>tarjeta TIE</em> (permiso de residencia) válida en España, pasa por el mismo carril que los ciudadanos de la UE en las fronteras Schengen. <strong>Sin cola EES. Sin límite de 90 días. Sin requisito de registro biométrico.</strong></p>

<h2>4. Conclusión: <em>EES Hace que Ser Turista en Europa sea Más Difícil, Establecerse Más Sensato</em></h2>
<p>El 10 de abril de 2026 no fue solo una actualización técnica; fue una <strong>transformación fundamental en cómo viajamos en el área Schengen.</strong></p>

<p>Por otro lado, <strong>la residencia legal en España</strong> lo saca de este panorama. <em>Sin cola EES. Sin límite de 90 días. Sin espera biométrica.</em></p>
      `
    }
  },
  'ispanya-girisimci-vizesi': {
    id: 'ispanya-girisimci-vizesi',
    slugs: {
      tr: 'ispanya-girisimci-vizesi',
      en: 'spain-entrepreneur-visa',
      es: 'visa-emprendedor-espana'
    },
    tag: { tr: 'Girişimcilik', en: 'Entrepreneurship', es: 'Emprendimiento' },
    title: {
      tr: '<em>İspanya Girişimci Vizesi</em> 2026: Başvuru Rehberi',
      en: '<em>Spain Entrepreneur Visa</em> 2026: Application Guide',
      es: '<em>Visa de Emprendedor España</em> 2026: Guía de Solicitud'
    },
    excerpt: {
      tr: 'İspanya\'da startup kurmak veya yenilikçi bir iş projesi başlatmak istiyorsanız Girişimci Vizesi tam size göre. ENISA değerlendirmesi, gerekli belgeler ve başvuru süreci hakkında bilmeniz gereken her şey.',
      en: 'If you want to start a startup or innovative business project in Spain, the Entrepreneur Visa is perfect for you. Everything you need to know about ENISA evaluation, required documents and application process.',
      es: 'Si desea iniciar una startup o un proyecto empresarial innovador en España, la Visa de Emprendedor es perfecta para usted. Todo lo que necesita saber sobre la evaluación ENISA, documentos requeridos y proceso de solicitud.'
    },
    date: '2026-04-10',
    readTime: { tr: '8 dk okuma', en: '8 min read', es: '8 min lectura' },
    content: {
      tr: `
<p>İspanya, Avrupa'nın en dinamik girişimcilik ekosistemlerinden birine ev sahipliği yapıyor. Barselona ve Madrid gibi şehirler, her yıl binlerce uluslararası girişimciyi kendine çekiyor. Eğer siz de İspanya'da kendi işinizi kurmak, yenilikçi bir startup hayata geçirmek ya da dijital bir işletme yönetmek istiyorsanız, <strong>İspanya Girişimci Vizesi (Visa de Emprendedor)</strong> tam da aradığınız çözüm olabilir.</p>

<h2>İspanya Girişimci Vizesi Nedir?</h2>
<p>İspanya Girişimci Vizesi, ülke dışından gelen profesyonellerin İspanya'da yenilikçi bir iş projesi başlatmasına olanak tanıyan bir oturma izni türüdür. 2013 yılında yürürlüğe giren <strong>Girişimci Destek Yasası (Ley 14/2013)</strong> kapsamında düzenlenen bu vize, özellikle teknoloji, dijital hizmetler ve yenilikçi iş modelleri odaklı projelere sahip kişilere hitap eder.</p>

<p>Bu vize türü, İspanya'nın uluslararası yeteneği çekmek ve ekonomik çeşitliliğini artırmak amacıyla oluşturduğu <strong>Startup Yasası (Ley de Startups – Ley 28/2022)</strong> ile birlikte daha da güçlenmiştir.</p>

<h2>Kimler Başvurabilir?</h2>
<ul>
  <li><strong>AB/AEA vatandaşı olmamak:</strong> Bu vize, Avrupa Birliği ve Avrupa Ekonomik Alanı dışındaki ülke vatandaşlarına yöneliktir.</li>
  <li><strong>Yenilikçi bir iş planına sahip olmak:</strong> Projenizin İspanya ekonomisine katkı sağlayacak, yenilikçi ve uygulanabilir olduğunu kanıtlamanız beklenir.</li>
  <li><strong>Yeterli mali kaynağa sahip olmak:</strong> İspanya'da kendinizi ve varsa ailenizi geçindirebilecek düzeyde finansal güce sahip olmalısınız.</li>
  <li><strong>Adli sicil kaydınızın temiz olması:</strong> Son beş yılda sabıka kaydınız bulunmamalıdır.</li>
  <li><strong>Geçerli sağlık sigortasına sahip olmak:</strong> İspanya'da geçerli, tam kapsamlı bir özel sağlık sigortası zorunludur.</li>
</ul>

<h2>Başvuru İçin Gerekli Belgeler</h2>
<ol>
  <li><strong>Detaylı iş planı:</strong> Projenizin amacı, hedef pazarı, gelir modeli, rekabet avantajı ve büyüme stratejisini içeren kapsamlı bir doküman.</li>
  <li><strong>ENISA veya ilgili kurumdan olumlu rapor:</strong> İş planınızın yenilikçi ve uygulanabilir olduğuna dair resmi bir değerlendirme raporu.</li>
  <li><strong>Pasaport fotokopisi:</strong> En az bir yıl geçerli olmalıdır.</li>
  <li><strong>Mali yeterlilik belgesi:</strong> Banka hesap dökümü, yatırım kanıtları veya sponsor mektubu.</li>
  <li><strong>Adli sicil belgesi:</strong> Apostil ve yeminli tercüme ile birlikte sunulmalıdır.</li>
  <li><strong>Sağlık sigortası poliçesi:</strong> İspanya genelinde geçerli, tam kapsamlı bir özel sigorta.</li>
  <li><strong>Başvuru formu (EX-07):</strong> Eksiksiz ve imzalı olarak doldurulmalıdır.</li>
</ol>

<h2>Başvuru Süreci Nasıl İşler?</h2>

<h3>1. İş Planı Hazırlığı</h3>
<p>Öncelikle İspanya pazarına uygun, yenilikçi ve sürdürülebilir bir iş planı hazırlamanız gerekir. Bu aşamada profesyonel danışmanlık almak süreci önemli ölçüde kolaylaştırır.</p>

<h3>2. ENISA Değerlendirmesi</h3>
<p>Hazırladığınız iş planını <strong>ENISA'ya (Empresa Nacional de Innovación)</strong> veya yetkili bir kuruma sunarsınız. Kurum, projenizin yenilikçilik düzeyini, ekonomik etkisini ve uygulanabilirliğini değerlendirir.</p>

<h3>3. Belge Toplama ve Tercüme</h3>
<p>Tüm belgelerinizi İspanyolca'ya yeminli tercüman aracılığıyla çevirtmeniz ve gerekli olanları apostil ile onaylatmanız gerekir.</p>

<h3>4. Konsolosluk Başvurusu</h3>
<p>Belgeleriniz tamamlandığında, bulunduğunuz ülkedeki İspanya Konsolosluğu'na başvurunuzu yaparsınız. Türkiye'deki başvurular İstanbul veya Ankara'daki İspanya Konsoloslukları üzerinden gerçekleştirilir.</p>

<h3>5. Vize Onayı ve İspanya'ya Giriş</h3>
<p>Başvurunuz onaylandığında bir yıl süreli girişimci vizesi alırsınız. İspanya'ya girdikten sonra oturma izninizi uzatmak için NIE başvurusu yapmanız gerekir.</p>

<h2>İspanya Girişimci Vizesinin Avantajları</h2>
<ul>
  <li>İspanya'da yasal olarak yaşama ve çalışma hakkı</li>
  <li>Schengen bölgesinde serbest dolaşım imkânı</li>
  <li>Ailenizi de yanınıza getirebilme olanağı (aile birleşimi)</li>
  <li>İspanya'nın güçlü girişimcilik ekosistemine doğrudan erişim</li>
  <li>İki yıl sonra oturma izni uzatma ve ilerleyen dönemde kalıcı oturma izni başvurusu yapabilme hakkı</li>
  <li>Startup Yasası kapsamında vergi avantajları ve teşvikler</li>
</ul>

<h2>Sık Sorulan Sorular</h2>

<h3>İspanya Girişimci Vizesi başvurusu ne kadar sürer?</h3>
<p>Başvuru süreci, belge hazırlığı dahil ortalama <strong>2-4 ay</strong> sürmektedir. ENISA değerlendirmesi genellikle 20 iş günü içinde sonuçlanır.</p>

<h3>Girişimci vizesi ile hangi sektörlerde iş kurabilirim?</h3>
<p>Teknoloji, yazılım, dijital pazarlama, e-ticaret, biyoteknoloji, yenilenebilir enerji ve danışmanlık gibi yenilikçi sektörler öne çıkmaktadır.</p>

<h3>Ailem de benimle gelebilir mi?</h3>
<p>Evet. Girişimci vizesi kapsamında eşiniz ve 18 yaş altındaki çocuklarınız için aile birleşimi başvurusu yapabilirsiniz.</p>

<h3>Girişimci vizesi kaç yıl geçerlidir?</h3>
<p>İlk vize bir yıl geçerlidir. Ardından İspanya'da iki yıllık oturma izni uzatması yapabilirsiniz. Beş yıl sonunda kalıcı oturma izni başvurusu hakkınız doğar.</p>

<h3>Türkiye'den başvurabilir miyim?</h3>
<p>Evet. Türkiye'deki İspanya Konsoloslukları (İstanbul ve Ankara) üzerinden başvurunuzu gerçekleştirebilirsiniz.</p>

<p><strong>Nova Iberian olarak İspanya'da yaşamak ve iş kurmak isteyen Türk girişimcilere uçtan uca danışmanlık hizmeti sunuyoruz.</strong></p>
      `,
      en: `
<p>Spain is home to one of Europe's most dynamic entrepreneurship ecosystems. Cities like Barcelona and Madrid attract thousands of international entrepreneurs every year. If you want to start your own business in Spain, launch an innovative startup, or run a digital business, the <strong>Spain Entrepreneur Visa (Visa de Emprendedor)</strong> might be exactly what you're looking for.</p>

<h2>What is the Spain Entrepreneur Visa?</h2>
<p>The Spain Entrepreneur Visa is a type of residence permit that allows professionals from outside the country to start an innovative business project in Spain. Regulated under the <strong>Entrepreneur Support Law (Ley 14/2013)</strong> enacted in 2013, this visa is aimed particularly at people with projects focused on technology, digital services, and innovative business models.</p>

<h2>Who Can Apply?</h2>
<ul>
  <li><strong>Non-EU/EEA citizens:</strong> This visa is aimed at citizens from countries outside the European Union and European Economic Area.</li>
  <li><strong>Have an innovative business plan:</strong> You need to prove that your project will contribute to the Spanish economy and is innovative and feasible.</li>
  <li><strong>Have sufficient financial resources:</strong> You must have enough financial means to support yourself and your family in Spain.</li>
  <li><strong>Clean criminal record:</strong> No criminal record in the last five years.</li>
  <li><strong>Valid health insurance:</strong> Comprehensive private health insurance valid in Spain is mandatory.</li>
</ul>

<h2>Advantages of the Spain Entrepreneur Visa</h2>
<ul>
  <li>Right to live and work legally in Spain</li>
  <li>Freedom to travel within the Schengen area</li>
  <li>Ability to bring your family (family reunification)</li>
  <li>Direct access to Spain's strong entrepreneurship ecosystem</li>
  <li>Right to extend residence permit after two years</li>
  <li>Tax advantages and incentives under the Startup Law</li>
</ul>
      `,
      es: `
<p>España alberga uno de los ecosistemas de emprendimiento más dinámicos de Europa. Ciudades como Barcelona y Madrid atraen a miles de emprendedores internacionales cada año. Si desea iniciar su propio negocio en España, lanzar una startup innovadora o dirigir un negocio digital, la <strong>Visa de Emprendedor de España</strong> podría ser exactamente lo que está buscando.</p>

<h2>¿Qué es la Visa de Emprendedor de España?</h2>
<p>La Visa de Emprendedor de España es un tipo de permiso de residencia que permite a profesionales de fuera del país iniciar un proyecto empresarial innovador en España. Regulada bajo la <strong>Ley de Apoyo a los Emprendedores (Ley 14/2013)</strong> promulgada en 2013, esta visa está dirigida especialmente a personas con proyectos enfocados en tecnología, servicios digitales y modelos de negocio innovadores.</p>

<h2>¿Quién Puede Solicitar?</h2>
<ul>
  <li><strong>No ser ciudadano de la UE/EEE:</strong> Esta visa está dirigida a ciudadanos de países fuera de la Unión Europea y el Espacio Económico Europeo.</li>
  <li><strong>Tener un plan de negocios innovador:</strong> Debe demostrar que su proyecto contribuirá a la economía española y es innovador y viable.</li>
  <li><strong>Tener recursos financieros suficientes:</strong> Debe tener medios financieros suficientes para mantenerse a sí mismo y a su familia en España.</li>
  <li><strong>Antecedentes penales limpios:</strong> Sin antecedentes penales en los últimos cinco años.</li>
  <li><strong>Seguro de salud válido:</strong> Es obligatorio un seguro de salud privado integral válido en España.</li>
</ul>

<h2>Ventajas de la Visa de Emprendedor de España</h2>
<ul>
  <li>Derecho a vivir y trabajar legalmente en España</li>
  <li>Libertad para viajar dentro del área Schengen</li>
  <li>Posibilidad de traer a su familia (reagrupación familiar)</li>
  <li>Acceso directo al fuerte ecosistema de emprendimiento de España</li>
  <li>Derecho a extender el permiso de residencia después de dos años</li>
  <li>Ventajas fiscales e incentivos bajo la Ley de Startups</li>
</ul>
      `
    }
  },
  'ispanya-sl-sirket-kurma': {
    id: 'ispanya-sl-sirket-kurma',
    slugs: {
      tr: 'ispanya-sl-sirket-kurma',
      en: 'setting-up-sl-company-spain',
      es: 'constituir-sociedad-limitada-espana'
    },
    tag: { tr: 'Şirket Kurulumu', en: 'Company Formation', es: 'Constitución de Empresa' },
    title: {
      tr: '<em>İspanya\'da SL Şirket</em> Kurma Rehberi',
      en: '<em>Guide to Setting Up</em> an SL Company in Spain',
      es: '<em>Guía para Constituir</em> una Sociedad Limitada en España'
    },
    excerpt: {
      tr: 'İspanya\'da en çok tercih edilen şirket türü SL (Sociedad Limitada) hakkında bilmeniz gereken her şey. Kuruluş adımları, maliyetler, vergi yükümlülükleri ve SSS.',
      en: 'Everything you need to know about SL (Sociedad Limitada), the most preferred company type in Spain. Formation steps, costs, tax obligations and FAQ.',
      es: 'Todo lo que necesita saber sobre la SL (Sociedad Limitada), el tipo de empresa más preferido en España. Pasos de constitución, costos, obligaciones fiscales y FAQ.'
    },
    date: '2026-04-03',
    readTime: { tr: '10 dk okuma', en: '10 min read', es: '10 min lectura' },
    content: {
      tr: `
<p>İspanya, Avrupa'nın en büyük ekonomilerinden biri olarak uluslararası girişimciler için cazip bir iş kurma destinasyonu olmaya devam ediyor. İspanya'da faaliyet göstermek isteyen yabancı yatırımcıların en çok tercih ettiği şirket türü ise <strong>SL (Sociedad Limitada)</strong>, yani limited şirkettir.</p>

<h2>SL (Sociedad Limitada) Nedir?</h2>
<p>Sociedad Limitada, İspanya hukuk sisteminde en yaygın kullanılan ticari şirket türüdür. Ortakların sorumluluğu koydukları sermaye ile sınırlıdır; kişisel varlıkları şirket borçlarından etkilenmez. Tek kişilik ortaklıktan çok ortaklı yapılara kadar esnek bir şekilde kurulabilir. Tek ortaklı SL şirketleri <strong>SLU (Sociedad Limitada Unipersonal)</strong> olarak adlandırılır.</p>

<h2>İspanya'da SL Şirket Kurmanın Avantajları</h2>
<ul>
  <li><strong>Düşük asgari sermaye:</strong> SL kuruluşu için gereken minimum sermaye sadece 1 Euro'dur (2023 Startup Yasası güncellemesiyle). Ancak pratikte 3.000 Euro ile kuruluş yapmak tavsiye edilir.</li>
  <li><strong>Sınırlı sorumluluk:</strong> Ortaklar yalnızca taahhüt ettikleri sermaye kadar sorumludur.</li>
  <li><strong>Esnek yönetim:</strong> Şirket tek bir yönetici veya yönetim kurulu tarafından yönetilebilir.</li>
  <li><strong>Schengen bölgesine erişim:</strong> İspanya'da kurulan şirket, AB pazarına doğrudan açılma imkânı sunar.</li>
  <li><strong>Vergi avantajları:</strong> Startup Yasası kapsamında yeni kurulan şirketler için ilk dört yılda kurumlar vergisi oranı %15'e düşürülmüştür.</li>
  <li><strong>Dijital nomad ve girişimci vizesi uyumu:</strong> SL şirket kurmak, oturma izni başvurularını destekler.</li>
</ul>

<h2>SL Şirket Kuruluş Adımları</h2>

<h3>1. Şirket İsmi Onayı (Certificado de Denominación Social)</h3>
<p>İlk adım, kullanmak istediğiniz şirket isminin başka bir firma tarafından kullanılmadığını doğrulamaktır. Bunun için <strong>Merkezi Ticaret Sicili'ne (Registro Mercantil Central)</strong> başvurarak isim onay belgesi almanız gerekir.</p>

<h3>2. NIE Numarası Alma</h3>
<p>İspanya'da herhangi bir ticari veya mali işlem yapabilmeniz için <strong>NIE (Número de Identidad de Extranjero)</strong> numarasına sahip olmanız zorunludur.</p>

<h3>3. Banka Hesabı Açma ve Sermaye Yatırma</h3>
<p>Şirket adına bir İspanyol bankasında hesap açmanız ve asgari sermayeyi bu hesaba yatırmanız gerekir. Banka, sermaye yatırıldığına dair bir <strong>sertifika (certificado de ingreso)</strong> düzenler.</p>

<h3>4. Şirket Ana Sözleşmesinin Hazırlanması</h3>
<p>Şirketin faaliyet alanı, ortaklık yapısı, sermaye dağılımı, yönetim şekli ve kâr paylaşım esaslarını belirleyen ana sözleşme <strong>(estatutos sociales)</strong> hazırlanır.</p>

<h3>5. Noter Önünde Kuruluş İşlemi (Escritura Pública)</h3>
<p>Tüm ortaklar veya vekilleri noter huzurunda bir araya gelerek kuruluş senedini imzalar.</p>

<h3>6. Vergi Kimlik Numarası (CIF) Alma</h3>
<p>Noter işleminin ardından İspanya Vergi Dairesi'ne başvurarak şirketiniz için <strong>CIF (Código de Identificación Fiscal)</strong> numarası alırsınız.</p>

<h3>7. Ticaret Siciline Tescil</h3>
<p>Son adım olarak şirketinizi bulunduğunuz ilin <strong>Ticaret Sicili'ne (Registro Mercantil Provincial)</strong> tescil ettirirsiniz.</p>

<h2>Kuruluş Maliyetleri</h2>
<ul>
  <li><strong>Şirket ismi onayı:</strong> 15-20 Euro</li>
  <li><strong>Noter masrafları:</strong> 300-600 Euro</li>
  <li><strong>Ticaret Sicili tescili:</strong> 150-300 Euro</li>
  <li><strong>Hukuki danışmanlık ve muhasebe:</strong> 500-1.500 Euro</li>
  <li><strong>Toplam tahmini maliyet:</strong> 1.000-2.500 Euro arasında</li>
</ul>

<h2>Vergi Yükümlülükleri</h2>
<ul>
  <li><strong>Kurumlar Vergisi (Impuesto de Sociedades):</strong> Standart oran %25'tir. Startup Yasası kapsamındaki yeni şirketler için ilk dört yılda %15 uygulanır.</li>
  <li><strong>KDV (IVA):</strong> Genel oran %21'dir.</li>
  <li><strong>Kişisel Gelir Vergisi (IRPF):</strong> Şirket yöneticisinin maaşından kesilir.</li>
  <li><strong>Üç aylık beyannameler:</strong> KDV, stopaj ve avans kurumlar vergisi beyannameleri üçer aylık dönemlerde verilir.</li>
</ul>

<h2>Sık Sorulan Sorular</h2>

<h3>İspanya'da SL şirket kurmak için İspanya'da bulunmam gerekiyor mu?</h3>
<p>Hayır. Vekâletname ile İspanya'da bulunmadan şirket kurmanız mümkündür.</p>

<h3>SL şirket kuruluşu ne kadar sürer?</h3>
<p>Tüm belgeler hazır olduğunda kuruluş süreci ortalama <strong>2-4 hafta</strong> içinde tamamlanır.</p>

<h3>Tek kişi olarak SL kurabilir miyim?</h3>
<p>Evet. Tek ortaklı SL şirketleri <strong>SLU (Sociedad Limitada Unipersonal)</strong> olarak kurulabilir.</p>

<h3>SL şirket kurmak oturma izni almamı sağlar mı?</h3>
<p>Doğrudan değil, ancak İspanya'da aktif bir şirketinizin olması girişimci vizesi başvurunuzu önemli ölçüde güçlendirir.</p>

<h3>Asgari sermaye ne kadar olmalı?</h3>
<p>Yasal olarak 1 Euro ile SL kurulabilir. Ancak pratikte <strong>3.000 Euro</strong> ile kuruluş yapmak bankalar nezdinde güvenilirlik açısından tercih edilmektedir.</p>

<h3>Türkiye'den İspanya'ya fatura kesebilir miyim?</h3>
<p>Evet. İspanya'daki SL şirketiniz ile uluslararası ticaret yapabilir, Türkiye dahil herhangi bir ülkeye fatura kesebilirsiniz.</p>

<p><strong>Nova Iberian olarak İspanya'da şirket kurmak isteyen Türk girişimcilere baştan sona profesyonel danışmanlık sunuyoruz.</strong></p>
      `,
      en: `
<p>Spain continues to be an attractive business destination for international entrepreneurs as one of Europe's largest economies. The most preferred company type for foreign investors who want to operate in Spain is <strong>SL (Sociedad Limitada)</strong>, the limited liability company.</p>

<h2>What is SL (Sociedad Limitada)?</h2>
<p>Sociedad Limitada is the most commonly used commercial company type in the Spanish legal system. Partners' liability is limited to their capital contribution; personal assets are not affected by company debts. Single-partner SL companies are called <strong>SLU (Sociedad Limitada Unipersonal)</strong>.</p>

<h2>Advantages of Setting Up an SL Company in Spain</h2>
<ul>
  <li><strong>Low minimum capital:</strong> The minimum capital required for SL formation is only 1 Euro (with the 2023 Startup Law update). However, forming with 3,000 Euro is recommended in practice.</li>
  <li><strong>Limited liability:</strong> Partners are only liable for the capital they committed.</li>
  <li><strong>Flexible management:</strong> The company can be managed by a single administrator or board of directors.</li>
  <li><strong>Access to Schengen area:</strong> A company established in Spain offers direct access to the EU market.</li>
  <li><strong>Tax advantages:</strong> Corporate tax rate reduced to 15% for the first four years for new companies under the Startup Law.</li>
</ul>

<h2>SL Company Formation Steps</h2>
<ol>
  <li>Company Name Approval</li>
  <li>Obtaining NIE Number</li>
  <li>Opening Bank Account and Depositing Capital</li>
  <li>Preparing Articles of Association</li>
  <li>Notary Formation Process</li>
  <li>Obtaining Tax ID (CIF)</li>
  <li>Commercial Registry Registration</li>
</ol>

<h2>Formation Costs</h2>
<ul>
  <li><strong>Company name approval:</strong> 15-20 Euro</li>
  <li><strong>Notary fees:</strong> 300-600 Euro</li>
  <li><strong>Commercial Registry registration:</strong> 150-300 Euro</li>
  <li><strong>Legal and accounting consultancy:</strong> 500-1,500 Euro</li>
  <li><strong>Total estimated cost:</strong> Between 1,000-2,500 Euro</li>
</ul>
      `,
      es: `
<p>España sigue siendo un destino empresarial atractivo para emprendedores internacionales como una de las economías más grandes de Europa. El tipo de empresa más preferido por los inversores extranjeros que desean operar en España es la <strong>SL (Sociedad Limitada)</strong>.</p>

<h2>¿Qué es la SL (Sociedad Limitada)?</h2>
<p>La Sociedad Limitada es el tipo de empresa comercial más utilizado en el sistema legal español. La responsabilidad de los socios está limitada a su aportación de capital; los activos personales no se ven afectados por las deudas de la empresa. Las SL de un solo socio se denominan <strong>SLU (Sociedad Limitada Unipersonal)</strong>.</p>

<h2>Ventajas de Constituir una Sociedad Limitada en España</h2>
<ul>
  <li><strong>Bajo capital mínimo:</strong> El capital mínimo requerido para la constitución de una SL es solo 1 Euro (con la actualización de la Ley de Startups 2023). Sin embargo, se recomienda constituir con 3.000 Euro en la práctica.</li>
  <li><strong>Responsabilidad limitada:</strong> Los socios solo son responsables del capital que aportaron.</li>
  <li><strong>Gestión flexible:</strong> La empresa puede ser gestionada por un solo administrador o consejo de administración.</li>
  <li><strong>Acceso al área Schengen:</strong> Una empresa establecida en España ofrece acceso directo al mercado de la UE.</li>
  <li><strong>Ventajas fiscales:</strong> Tasa del impuesto de sociedades reducida al 15% durante los primeros cuatro años para nuevas empresas bajo la Ley de Startups.</li>
</ul>

<h2>Pasos para Constituir una SL</h2>
<ol>
  <li>Aprobación del Nombre de la Empresa</li>
  <li>Obtención del Número NIE</li>
  <li>Apertura de Cuenta Bancaria y Depósito de Capital</li>
  <li>Preparación de los Estatutos Sociales</li>
  <li>Proceso de Constitución ante Notario</li>
  <li>Obtención del CIF</li>
  <li>Inscripción en el Registro Mercantil</li>
</ol>

<h2>Costos de Constitución</h2>
<ul>
  <li><strong>Aprobación del nombre:</strong> 15-20 Euro</li>
  <li><strong>Gastos de notaría:</strong> 300-600 Euro</li>
  <li><strong>Inscripción en el Registro Mercantil:</strong> 150-300 Euro</li>
  <li><strong>Asesoría legal y contable:</strong> 500-1.500 Euro</li>
  <li><strong>Costo total estimado:</strong> Entre 1.000-2.500 Euro</li>
</ul>
      `
    }
  },
  'ispanyada-sirket-turleri-sl-sa-autonomo-karsilastirmasi': {
    id: 'ispanyada-sirket-turleri-sl-sa-autonomo-karsilastirmasi',
    slugs: {
      tr: 'ispanyada-sirket-turleri-sl-sa-autonomo-karsilastirmasi',
      en: 'company-types-spain-sl-sa-autonomo-comparison',
      es: 'tipos-empresa-espana-sl-sa-autonomo-comparacion'
    },
    tag: { tr: 'Şirket Kurulumu', en: 'Company Formation', es: 'Constitución de Empresa' },
    title: {
      tr: '<em>İspanya\'da Şirket Türleri:</em> SL, SA, Autónomo Karşılaştırması',
      en: '<em>Company Types in Spain:</em> SL, SA, Autónomo Comparison',
      es: '<em>Tipos de Empresa en España:</em> Comparación SL, SA, Autónomo'
    },
    metaTitle: {
      tr: 'İspanya\'da Şirket Türleri: SL, SA, Autónomo – Hangisi Size Uygun? | Nova Iberian',
      en: 'Company Types in Spain: SL, SA, Autónomo – Which One is Right for You? | Nova Iberian',
      es: 'Tipos de Empresa en España: SL, SA, Autónomo – ¿Cuál es Adecuado para Usted? | Nova Iberian'
    },
    metaDescription: {
      tr: 'İspanya\'da şirket kurmak isteyenler için SL (Sociedad Limitada), SA (Sociedad Anónima) ve Autónomo karşılaştırması. Sermaye, vergi, sorumluluk ve kuruluş süreçlerini detaylı inceleyin.',
      en: 'Comparison of SL (Sociedad Limitada), SA (Sociedad Anónima) and Autónomo for those who want to start a company in Spain. Examine capital, tax, liability and formation processes in detail.',
      es: 'Comparación de SL (Sociedad Limitada), SA (Sociedad Anónima) y Autónomo para quienes quieren crear una empresa en España.'
    },
    category: { tr: 'İspanya\'da Şirket Kurma', en: 'Starting a Company in Spain', es: 'Crear Empresa en España' },
    tags: ['İspanya şirket türleri', 'SL şirket', 'SA şirket', 'Autónomo İspanya', 'İspanya\'da iş kurma', 'Sociedad Limitada', 'Sociedad Anónima', 'İspanya serbest meslek'],
    excerpt: {
      tr: 'İspanya\'da iş kurarken hangi şirket türünü seçmelisiniz? SL, SA ve Autónomo arasındaki farkları, avantajları ve dezavantajları detaylı olarak inceliyoruz.',
      en: 'Which company type should you choose when starting a business in Spain? We examine the differences, advantages and disadvantages between SL, SA and Autónomo.',
      es: '¿Qué tipo de empresa elegir al iniciar un negocio en España? Examinamos las diferencias, ventajas y desventajas entre SL, SA y Autónomo.'
    },
    date: '2026-04-13',
    readTime: { tr: '15 dk okuma', en: '15 min read', es: '15 min lectura' },
    content: {
      tr: `
<p>İspanya, Avrupa'nın en dinamik ekonomilerinden birine sahip ve her yıl binlerce yabancı girişimci bu ülkede iş kurma kararı alıyor. Ancak İspanya'da faaliyet gösterebilmek için önce doğru şirket türünü seçmek gerekiyor. Bu karar; vergi yükünüzü, kişisel sorumluluğunuzu, sermaye gereksinimlerinizi ve hatta günlük operasyonlarınızı doğrudan etkiler.</p>

<p>İspanya hukuk sisteminde en yaygın üç yapı <strong>Sociedad Limitada (SL)</strong>, <strong>Sociedad Anónima (SA)</strong> ve <strong>Autónomo (Trabajador Autónomo)</strong> statüsüdür. Bu rehberde her birini detaylı inceleyecek, avantaj ve dezavantajlarını karşılaştıracak ve hangi durumda hangisinin size uygun olduğunu açıklayacağız.</p>

<h2>1. Autónomo (Serbest Meslek – Trabajador Autónomo)</h2>

<h3>Autónomo Nedir?</h3>
<p>Autónomo, İspanya'da bireysel olarak ticari faaliyet yürütmenin en basit yoludur. Türkiye'deki "şahıs şirketi" kavramına benzer şekilde, kişi kendi adına fatura keser ve vergi öder. Tüzel kişilik oluşturulmaz; kişinin kendisi işletmenin ta kendisidir.</p>

<h3>Kuruluş Süreci ve Maliyetler</h3>
<p>Autónomo olarak kaydolmak, İspanya'daki en hızlı ve en ucuz iş kurma yöntemidir. Süreç genellikle birkaç gün içinde tamamlanabilir. Temel adımlar şunlardır:</p>

<p>İlk olarak İspanya Vergi Dairesi olan Agencia Tributaria'ya başvurarak Modelo 036 veya Modelo 037 formu ile vergi kaydı yaptırmanız gerekir. Bu formda faaliyet alanınızı belirten IAE (Impuesto sobre Actividades Económicas) kodunu seçersiniz. Ardından Sosyal Güvenlik Kurumu'na (Seguridad Social) RETA (Régimen Especial de Trabajadores Autónomos) kaydı yapılır.</p>

<p>Kuruluş için noter veya ticaret sicili işlemine gerek yoktur. Minimum sermaye şartı bulunmaz. Başlangıç maliyetleri, bir muhasebeci (gestoría) ile çalışırsanız yaklaşık 100-300 Euro arasında olacaktır.</p>

<h3>Vergilendirme</h3>
<p>Autónomo olarak gelir vergisi (IRPF – Impuesto sobre la Renta de las Personas Físicas) ödersiniz. Bu vergi artan oranlı bir yapıya sahiptir ve gelir arttıkça oran da yükselir. 2024-2025 yıllarında geçerli olan genel oranlar yüzde 19 ile yüzde 47 arasında değişmektedir.</p>

<p>Her üç ayda bir Modelo 130 ile gelir vergisi ön ödemesi yapılır. Ayrıca KDV (IVA) mükellefi olarak her üç ayda bir Modelo 303, yıl sonunda ise Modelo 390 beyannamesi verilir. Standart KDV oranı yüzde 21'dir ancak bazı sektörlerde indirimli oranlar uygulanır.</p>

<p>Sosyal güvenlik primleri aylık olarak ödenir. 2023 yılından itibaren gelire dayalı kademeli bir prim sistemi (cotización por ingresos reales) uygulanmaya başlanmıştır. Aylık prim, gelir düzeyine bağlı olarak yaklaşık 230 Euro'dan başlayıp 500 Euro'nun üzerine çıkabilir. Yeni kayıt yaptıran autónomolar için "tarifa plana" adı verilen indirimli prim uygulaması mevcuttur; bu kapsamda ilk 12 ay boyunca aylık yaklaşık 80 Euro ödenir.</p>

<h3>Sorumluluk</h3>
<p>Autónomo statüsünün en kritik dezavantajı sınırsız kişisel sorumluluktur. İşletmenin borçlarından kişisel varlıklarınızla (ev, araba, banka hesabı) sorumlu olursunuz. Bu durum, yüksek riskli sektörlerde faaliyet gösteren girişimciler için ciddi bir risk oluşturur.</p>

<h3>Autónomo Kimler İçin Uygun?</h3>
<p>Autónomo statüsü, düşük riskli ve düşük-orta gelirli bireysel faaliyetler için idealdir. Serbest danışmanlar, freelance çalışanlar, küçük ölçekli e-ticaret yapanlar, dil öğretmenleri, grafik tasarımcılar ve benzeri bireysel hizmet sağlayıcılar için en mantıklı tercihtir. Yıllık geliri belirli bir eşiğin altında kalanlar için vergi yükü SL'ye kıyasla daha düşük olabilir.</p>

<h2>2. Sociedad Limitada (SL) – Limited Şirket</h2>

<h3>SL Nedir?</h3>
<p>Sociedad de Responsabilidad Limitada, kısaca SL, İspanya'da en yaygın kullanılan şirket türüdür. Türkiye'deki limited şirkete (Ltd. Şti.) benzer yapıdadır. Tüzel kişiliğe sahiptir, yani şirket ile ortaklar ayrı hukuki varlıklardır.</p>

<h3>Kuruluş Süreci ve Sermaye</h3>
<p>SL kurmak autónomo olmaktan daha karmaşık ve maliyetlidir, ancak İspanya standartlarında nispeten basit sayılır. Süreç şu adımlardan oluşur:</p>

<p>Öncelikle Merkez Ticaret Sicili'nden (Registro Mercantil Central) şirket adı onayı (Certificación Negativa de Denominación Social) almanız gerekir. Bu işlem, seçtiğiniz şirket adının daha önce alınmadığını teyit eder. Ardından bir İspanya bankasında şirket hesabı açılır ve minimum sermaye olan 3.000 Euro bu hesaba yatırılır.</p>

<p>Noterde şirket ana sözleşmesi (escritura de constitución) düzenlenir. Bu sözleşmede şirketin faaliyet alanı, sermaye yapısı, ortaklık oranları ve yönetim şekli belirlenir. Noter işleminden sonra vergi dairesine CIF (şirket vergi kimlik numarası) başvurusu yapılır. Son olarak şirket, yerel Ticaret Sicili'ne (Registro Mercantil Provincial) tescil edilir.</p>

<p>Tüm süreç genellikle 2 ila 6 hafta sürer. Toplam kuruluş maliyeti, noter, sicil, avukat ve muhasebeci ücretleri dahil yaklaşık 1.500 ila 3.500 Euro arasındadır. Hızlandırılmış kuruluş (constitución telemática) seçeneği ile süre birkaç güne indirilebilir ancak bu durumda standart ana sözleşme kullanılması gerekir.</p>

<p>Minimum sermaye 3.000 Euro'dur ve bu tutar şirket kuruluşunda bankaya yatırılmalıdır. Bu sermaye şirket kurulduktan sonra işletme faaliyetlerinde kullanılabilir.</p>

<h3>Vergilendirme</h3>
<p>SL, kurumlar vergisine (Impuesto sobre Sociedades) tabidir. Genel kurumlar vergisi oranı yüzde 25'tir. Ancak yeni kurulan şirketler için ilk iki yılda kâr edilen dönemlerde yüzde 15 oranında indirimli vergi uygulanır.</p>

<p>Şirket ortaklarına dağıtılan kâr payları (dividendos) ayrıca kişisel gelir vergisine tabidir. Bu durum "çifte vergilendirme" olarak adlandırılır ve toplam vergi yükünü artırabilir. Kâr payı üzerinden yüzde 19 ila yüzde 26 arasında vergi kesilir.</p>

<p>Şirketin yöneticisi (administrador) aynı zamanda ortaksa ve şirketin yüzde 25'inden fazlasına sahipse, autónomo kaydı yaptırması ve sosyal güvenlik primi ödemesi zorunludur. Bu detay çoğu yabancı girişimcinin gözden kaçırdığı önemli bir maliyet kalemidir.</p>

<p>KDV (IVA) yükümlülükleri autónomo ile aynıdır: üç aylık Modelo 303 ve yıllık Modelo 390 beyannameleri verilir. Bunlara ek olarak yıllık kurumlar vergisi beyannamesi (Modelo 200) ve muhasebe defterlerinin tutulması zorunludur.</p>

<h3>Sorumluluk</h3>
<p>SL'nin en büyük avantajı sınırlı sorumluluktur. Ortaklar, şirkete koydukları sermaye ile sınırlı olarak sorumludur. Kişisel varlıklar, şirketin borçlarından etkilenmez. Ancak bu koruma, yönetici olarak kişisel kusur veya hile durumlarında kalkabilir.</p>

<h3>SL Kimler İçin Uygun?</h3>
<p>SL, orta ve büyük ölçekli işletmeler, birden fazla ortağı olan girişimler, yabancı yatırımcılar, risk yönetimi önemli olan sektörler ve profesyonel bir kurumsal imaj gereksinimi olan işletmeler için idealdir. Yıllık kârı yaklaşık 40.000-50.000 Euro'yu aşan girişimciler için vergisel açıdan autónomo yerine SL daha avantajlı hale gelir.</p>

<h2>3. Sociedad Anónima (SA) – Anonim Şirket</h2>

<h3>SA Nedir?</h3>
<p>Sociedad Anónima, İspanya'daki en büyük ve en resmi şirket türüdür. Türkiye'deki anonim şirkete (A.Ş.) karşılık gelir. Halka açık şirketler, büyük holdinglerin İspanya operasyonları ve borsada işlem görmek isteyen şirketler için tasarlanmıştır.</p>

<h3>Kuruluş Süreci ve Sermaye</h3>
<p>SA kuruluş süreci SL'ye benzer ancak daha katı düzenlemelere tabidir. Minimum sermaye 60.000 Euro'dur ve kuruluş aşamasında bu tutarın en az yüzde 25'inin (15.000 Euro) ödenmesi gerekir. Kalan kısım sonradan tamamlanabilir.</p>

<p>Kuruluş adımları SL ile büyük ölçüde aynıdır: şirket adı onayı, banka hesabı açılması, noter işlemleri ve ticaret sicili tescili. Ancak SA için ana sözleşme daha detaylı olmalı ve yönetim kurulu yapısı açıkça tanımlanmalıdır.</p>

<p>SA'lar, zorunlu olarak yönetim kurulu (consejo de administración) ile yönetilir. Yönetim kurulunda en az üç üye bulunmalıdır. Bu yapı, karar alma süreçlerini daha resmi ve bürokratik hale getirir.</p>

<p>Kuruluş maliyetleri SL'ye göre daha yüksektir. Noter, sicil, avukat ve diğer masraflar dahil toplam maliyet 5.000 ila 10.000 Euro arasında değişebilir.</p>

<h3>Vergilendirme</h3>
<p>SA'lar da SL'ler gibi yüzde 25 oranında kurumlar vergisine tabidir. Vergisel yükümlülükler büyük ölçüde aynıdır. Fark, muhasebe ve raporlama gereksinimlerinin daha kapsamlı olmasıdır. Belirli büyüklükteki SA'lar bağımsız denetim (auditoría) yaptırmak zorundadır.</p>

<h3>Sorumluluk</h3>
<p>SL'de olduğu gibi ortakların sorumluluğu sermaye payları ile sınırlıdır. Hisse senetleri (acciones) serbestçe devredilebilir; bu durum yatırımcı çekmeyi kolaylaştırır. SL'de pay devri daha kısıtlıdır ve diğer ortakların ön alım hakkı bulunur.</p>

<h3>SA Kimler İçin Uygun?</h3>
<p>SA, büyük ölçekli yatırımlar, halka arz planları, çok ortaklı uluslararası yapılar ve belirli sektörlerde (bankacılık, sigortacılık gibi) yasal zorunluluk olan durumlarda tercih edilir. Küçük ve orta ölçekli işletmeler için genellikle gereksiz derecede karmaşık ve maliyetlidir.</p>

<h2>Karşılaştırma Tablosu</h2>

<p>Üç yapıyı temel kriterler üzerinden karşılaştıralım:</p>

<div class="blog-stats-box">
  <div class="stat-item"><span class="stat-number">Autónomo</span><span class="stat-label">Sermaye: 0€ | Sorumluluk: Sınırsız | Vergi: %19-47 | Kuruluş: Birkaç gün</span></div>
  <div class="stat-item"><span class="stat-number">SL</span><span class="stat-label">Sermaye: 3.000€ | Sorumluluk: Sınırlı | Vergi: %25 | Kuruluş: 2-6 hafta</span></div>
  <div class="stat-item"><span class="stat-number">SA</span><span class="stat-label">Sermaye: 60.000€ | Sorumluluk: Sınırlı | Vergi: %25 | Kuruluş: 4-8 hafta</span></div>
</div>

<h2>Hangi Yapıyı Seçmelisiniz?</h2>

<p>Doğru şirket türünü seçerken birkaç temel soruyu yanıtlamanız gerekir.</p>

<p>Eğer tek başınıza küçük ölçekli bir iş yapıyorsanız, riskiniz düşükse ve yıllık geliriniz 40.000-50.000 Euro'nun altındaysa, autónomo en pratik ve en ekonomik seçenektir. Özellikle İspanya'daki ilk yılınızda tarifa plana indiriminden yararlanarak aylık sosyal güvenlik maliyetinizi minimumda tutabilirsiniz.</p>

<p>Orta ölçekli bir işletme kuruyorsanız, ortaklarınız varsa, kişisel varlıklarınızı korumak istiyorsanız veya kurumsal müşterilerle çalışacaksanız, SL doğru tercihtir. İspanya'da kurulan şirketlerin büyük çoğunluğu SL yapısındadır ve bunun iyi bir nedeni vardır: esneklik, sınırlı sorumluluk ve makul maliyet arasında ideal dengeyi sunar.</p>

<p>SA ise büyük ölçekli projeler, uluslararası yatırım yapıları veya yasal zorunluluk olan sektörler dışında genellikle tercih edilmez. 60.000 Euro minimum sermaye ve yönetim kurulu zorunluluğu, çoğu girişimci için gereksiz bir yüktür.</p>

<h2>Vergisel Kırılma Noktası: Ne Zaman SL'ye Geçmeli?</h2>

<p>Autónomo ile SL arasındaki vergisel karşılaştırma, yıllık gelir düzeyine göre belirgin bir kırılma noktası gösterir. Autónomo olarak ödenen gelir vergisi (IRPF) artan oranlı olduğundan, gelir yükseldikçe vergi oranı da artar. Yüzde 37 ile yüzde 47 arasındaki üst dilimler, yüksek gelirli autónomoları ciddi şekilde etkiler.</p>

<p>SL'de ise kurumlar vergisi sabit yüzde 25 oranındadır (yeni şirketlerde ilk iki yıl yüzde 15). Bu sabit oran, belirli bir gelir düzeyinin üzerinde SL'yi avantajlı kılar. Genel kabul, yıllık net kârın yaklaşık 40.000-50.000 Euro'yu aşması durumunda SL yapısının vergisel olarak daha avantajlı hale geldiği yönündedir.</p>

<p>Ancak bu hesaplama basitleştirilmiş bir yaklaşımdır. SL'de kâr payı dağıtımında ek vergi ödenmesi, yönetici olarak autónomo kaydı zorunluluğu ve daha yüksek muhasebe maliyetleri gibi faktörler toplam yükü etkiler. Bu nedenle geçiş kararı, bir vergi danışmanı ile birlikte kişisel durumunuza özel olarak analiz edilmelidir.</p>

<h2>Sık Sorulan Sorular</h2>

<h3>İspanya'da en çok tercih edilen şirket türü hangisidir?</h3>
<p>SL (Sociedad Limitada) açık ara en çok tercih edilen şirket türüdür. İspanya'da aktif şirketlerin büyük çoğunluğu SL yapısındadır. Makul sermaye gereksinimi, sınırlı sorumluluk ve esnek yönetim yapısı bu tercihinin temel nedenleridir.</p>

<h3>Autónomo olarak başlayıp sonra SL'ye geçebilir miyim?</h3>
<p>Evet, bu çok yaygın bir uygulamadır. Birçok girişimci düşük maliyetlerle autónomo olarak başlar ve işi büyüdükçe SL'ye geçiş yapar. Teknik olarak bu bir dönüşüm değil, yeni şirket kuruluşu ve faaliyetlerin devridir.</p>

<h3>Yabancılar İspanya'da autónomo olabilir mi?</h3>
<p>Evet, ancak autónomo olmak için İspanya'da geçerli bir ikamet ve çalışma iznine sahip olmak gerekir. Sadece NIE numarası yeterli değildir; sosyal güvenlik kaydı için ikamet izni zorunludur.</p>

<h3>SL kurmak için İspanya'da yaşamak zorunlu mu?</h3>
<p>Hayır. SL ortağı veya yöneticisi olmak için İspanya'da ikamet etmek zorunlu değildir. Ancak yönetici olarak bazı işlemler için İspanya'da fiziksel bulunmak veya vekil atamak gerekebilir.</p>

<h2>Autónomo'dan SL'ye Geçiş</h2>

<p>Birçok girişimci İspanya'da işe autónomo olarak başlar ve işleri büyüdükçe SL'ye geçiş yapar. Bu geçiş tamamen mümkündür ve oldukça yaygın bir uygulamadır. Geçişte dikkat edilmesi gereken noktalar şunlardır:</p>

<p>Geçiş bir "dönüşüm" değil, yeni bir şirket kurulması ve mevcut faaliyetlerin devredilmesi şeklinde gerçekleşir. Mevcut müşteri sözleşmeleri, çalışan ilişkileri ve varlıklar yeni şirkete aktarılmalıdır. Vergi ve sosyal güvenlik kayıtları ayrı ayrı yapılmalıdır. Autónomo kaydının kapatılması ve SL yöneticisi olarak yeniden autónomo kaydı açılması gerekebilir.</p>

<p>Bu süreçte profesyonel bir danışmanlık almak, hukuki ve mali açıdan doğru adımların atılmasını sağlar.</p>

<h2>Sonuç</h2>

<p>İspanya'da şirket türü seçimi, iş planınız, risk toleransınız, sermayeniz ve büyüme hedeflerinizle doğrudan ilişkilidir. Autónomo hızlı ve ucuz bir başlangıç sunar ancak kişisel risk taşır. SL, çoğu girişimci için altın standarttır ve profesyonel bir yapı sağlar. SA ise büyük ölçekli operasyonlar için tasarlanmıştır.</p>

<p>Nova Iberian olarak İspanya'da şirket kurma sürecinizin her aşamasında yanınızdayız. Şirket türü seçiminden kuruluş işlemlerine, vergi planlamasından günlük operasyonlara kadar uzman ekibimizle size rehberlik ediyoruz.</p>

<p><strong>Ücretsiz ön değerlendirme için bizimle iletişime geçin:</strong> İş planınızı ve hedeflerinizi anlattığınızda, size en uygun şirket yapısını önerelim.</p>

<p><em>Bu içerik genel bilgilendirme amaçlıdır ve hukuki danışmanlık yerine geçmez. Güncel mevzuat değişiklikleri için profesyonel destek almanızı öneririz.</em></p>
      `,
      en: `
<h2>Company Types in Spain</h2>
<p>For foreign investors planning to start a business in Spain, one of the most critical decisions is <strong>choosing the right company type</strong>. Each structure has its own advantages, disadvantages, capital requirements, and tax obligations.</p>

<h2>1. Autónomo (Self-Employed / Freelancer)</h2>
<p><strong>Autónomo</strong> is the simplest and fastest way to start for those who want to conduct individual business activities in Spain. Similar to sole proprietorship, the person invoices and pays taxes under their own name.</p>

<h3>Advantages:</h3>
<ul>
  <li>Fast setup: Can start operating within a few days</li>
  <li>Low startup cost: No minimum capital requirement</li>
  <li>Simple accounting: Less bureaucratic burden</li>
  <li>Discounted social security in first years: Tarifa plana with premiums starting at €80/month</li>
</ul>

<h3>Disadvantages:</h3>
<ul>
  <li>Unlimited personal liability: Your personal assets can be affected by business debts</li>
  <li>Progressive income tax: 19% to 47%</li>
</ul>

<h2>2. SL (Sociedad Limitada - Limited Company)</h2>
<p><strong>Sociedad Limitada</strong> is the most commonly used company type in Spain, similar to a limited liability company. It has legal personality, meaning the company and partners are separate legal entities.</p>

<h3>Advantages:</h3>
<ul>
  <li>Limited liability: Partners are only liable for their capital contribution</li>
  <li>Low minimum capital: €3,000</li>
  <li>Corporate tax: Fixed 25% rate (15% for first two years for new companies)</li>
  <li>Professional image: Reliable structure for corporate clients</li>
</ul>

<h2>3. SA (Sociedad Anónima - Public Limited Company)</h2>
<p><strong>Sociedad Anónima</strong> is the largest and most formal company type in Spain, equivalent to a public limited company. It's designed for publicly traded companies and large holding operations.</p>

<h3>Key Features:</h3>
<ul>
  <li>Minimum capital: €60,000</li>
  <li>Board of directors required with at least 3 members</li>
  <li>Shares can be freely transferred</li>
</ul>

<h2>Which Structure Should You Choose?</h2>
<ul>
  <li><strong>Autónomo:</strong> Low-risk, individual service providers (consultants, freelancers)</li>
  <li><strong>SL:</strong> SMEs, partnership structures, foreign investors - ideal choice</li>
  <li><strong>SA:</strong> Large-scale projects, investment rounds, IPO targets</li>
</ul>

<p><em>At Nova Iberian, we guide you in determining the most suitable company structure for your business model and goals. Contact us for a free consultation.</em></p>
      `,
      es: `
<h2>Tipos de Empresa en España</h2>
<p>Para los inversores extranjeros que planean iniciar un negocio en España, una de las decisiones más críticas es <strong>elegir el tipo de empresa correcto</strong>. Cada estructura tiene sus propias ventajas, desventajas, requisitos de capital y obligaciones fiscales.</p>

<h2>1. Autónomo</h2>
<p><strong>Autónomo</strong> es la forma más simple y rápida de comenzar para quienes desean realizar actividades comerciales individuales en España. Similar al trabajador por cuenta propia.</p>

<h3>Ventajas:</h3>
<ul>
  <li>Configuración rápida: Puede comenzar a operar en pocos días</li>
  <li>Bajo costo inicial: Sin requisito de capital mínimo</li>
  <li>Contabilidad simple: Menos carga burocrática</li>
</ul>

<h3>Desventajas:</h3>
<ul>
  <li>Responsabilidad personal ilimitada</li>
  <li>Impuesto sobre la renta progresivo: 19% a 47%</li>
</ul>

<h2>2. SL (Sociedad Limitada)</h2>
<p><strong>Sociedad Limitada</strong> es el tipo de empresa más utilizado en España, similar a una sociedad de responsabilidad limitada.</p>

<h3>Ventajas:</h3>
<ul>
  <li>Responsabilidad limitada: Los socios solo son responsables de su aportación de capital</li>
  <li>Capital mínimo bajo: €3.000</li>
  <li>Impuesto de sociedades: Tasa fija del 25%</li>
</ul>

<h2>3. SA (Sociedad Anónima)</h2>
<p><strong>Sociedad Anónima</strong> se prefiere para proyectos a gran escala, empresas que buscan OPV o emprendimientos que atraen inversiones significativas.</p>

<h2>¿Qué Estructura Elegir?</h2>
<ul>
  <li><strong>Autónomo:</strong> Bajo riesgo, proveedores de servicios individuales</li>
  <li><strong>SL:</strong> PYMEs, estructuras de asociación, inversores extranjeros - opción ideal</li>
  <li><strong>SA:</strong> Proyectos a gran escala, rondas de inversión, objetivos de OPV</li>
</ul>

<p><em>En Nova Iberian, le guiamos para determinar la estructura empresarial más adecuada para su modelo de negocio y objetivos.</em></p>
      `
    }
  },
  'ispanyada-yabanci-olarak-sirket-acma-tam-rehber': {
    id: 'ispanyada-yabanci-olarak-sirket-acma-tam-rehber',
    slugs: {
      tr: 'ispanyada-yabanci-olarak-sirket-acma-tam-rehber',
      en: 'starting-company-spain-as-foreigner-complete-guide',
      es: 'abrir-empresa-espana-como-extranjero-guia-completa'
    },
    tag: { tr: 'Şirket Kurulumu', en: 'Company Formation', es: 'Constitución de Empresa' },
    title: {
      tr: '<em>İspanya\'da Yabancı Olarak</em> Şirket Açma: Tam Rehber',
      en: '<em>Starting a Company in Spain</em> as a Foreigner: Complete Guide',
      es: '<em>Abrir una Empresa en España</em> como Extranjero: Guía Completa'
    },
    metaTitle: {
      tr: 'İspanya\'da Yabancı Olarak Şirket Açma: Eksiksiz Rehber (2025) | Nova Iberian',
      en: 'Starting a Company in Spain as a Foreigner: Complete Guide (2025) | Nova Iberian',
      es: 'Abrir una Empresa en España como Extranjero: Guía Completa (2025) | Nova Iberian'
    },
    metaDescription: {
      tr: 'İspanya\'da yabancı olarak şirket kurmak için gereken belgeler, NIE başvurusu, adım adım süreç, maliyetler ve dikkat edilmesi gerekenler. Türk girişimciler için kapsamlı rehber.',
      en: 'Documents required to start a company in Spain as a foreigner, NIE application, step by step process, costs and things to consider.',
      es: 'Documentos necesarios para abrir una empresa en España como extranjero, solicitud de NIE, proceso paso a paso.'
    },
    category: { tr: 'İspanya\'da Şirket Kurma', en: 'Starting a Company in Spain', es: 'Crear Empresa en España' },
    tags: ['İspanya\'da yabancı şirket kurma', 'İspanya NIE', 'İspanya şirket açma rehber', 'Türk girişimci İspanya', 'İspanya ikamet izni', 'İspanya yatırım'],
    excerpt: {
      tr: 'Türk vatandaşları için İspanya\'da şirket kurma sürecinin A\'dan Z\'ye rehberi. NIE alma, banka hesabı açma, vergi kaydı ve tüm prosedürler.',
      en: 'A to Z guide for Turkish citizens on the company formation process in Spain. NIE application, bank account opening, tax registration and all procedures.',
      es: 'Guía de la A a la Z para ciudadanos turcos sobre el proceso de constitución de empresa en España.'
    },
    date: '2026-04-16',
    readTime: { tr: '18 dk okuma', en: '18 min read', es: '18 min lectura' },
    content: {
      tr: `
<p>İspanya, yabancı girişimciler için Avrupa'nın en cazip pazarlarından biri olmaya devam ediyor. Güçlü turizm sektörü, stratejik coğrafi konumu, AB üyeliğinin sağladığı pazar erişimi ve nispeten uygun yaşam maliyetleri, her yıl binlerce yabancı yatırımcıyı bu ülkeye çekiyor. Ancak İspanya'da yabancı olarak şirket kurmak, yerel vatandaşlara kıyasla bazı ek adımlar ve dikkat gerektiren noktalar içerir.</p>

<p>Bu rehberde, İspanya'da yabancı olarak şirket kurma sürecini baştan sona ele alacağız. NIE numarası almaktan şirket tescil işlemlerine, banka hesabı açmaktan vergi yükümlülüklerine kadar bilmeniz gereken her şeyi bulacaksınız.</p>

<h2>Yabancılar İspanya'da Şirket Kurabilir mi?</h2>

<p>Evet, İspanya hukuku yabancıların şirket kurmasına veya mevcut şirketlere ortak olmasına izin verir. AB vatandaşları ve AB dışından gelen kişiler arasında şirket kurma hakkı açısından önemli bir fark yoktur. Her iki grup da SL (Sociedad Limitada), SA (Sociedad Anónima) veya autónomo olarak faaliyet gösterebilir.</p>

<p>Ancak burada önemli bir ayrım vardır: şirket kurmak ile İspanya'da fiziksel olarak çalışmak veya yaşamak farklı şeylerdir. Bir yabancı, İspanya'da oturmadan da şirket kurabilir ve şirketin ortağı olabilir. Fakat şirketin yöneticisi olarak günlük operasyonlarda görev alacaksa veya İspanya'da fiziksel olarak çalışacaksa, ikamet ve çalışma izni gerekir.</p>

<p>AB/AEA vatandaşları için durum daha basittir. Bu kişiler serbest dolaşım hakkı kapsamında İspanya'da serbestçe çalışabilir ve iş kurabilir. Sadece üç aydan fazla kalacaklarsa NIE almaları ve "Certificado de Registro de Ciudadano de la Unión" kaydı yaptırmaları yeterlidir.</p>

<p>AB dışından gelen vatandaşlar (Türk vatandaşları dahil) için ise süreç biraz daha karmaşıktır ve ikamet izni gerektirebilir. Ancak tekrar belirtelim: sırf şirket kurmak ve ortak olmak için ikamet izni zorunlu değildir. İzin, İspanya'da fiziksel olarak yaşamak ve çalışmak istediğinizde devreye girer.</p>

<h2>Adım 1: NIE (Número de Identidad de Extranjero) Almak</h2>

<p>NIE, İspanya'da herhangi bir mali veya hukuki işlem yapmak isteyen her yabancının sahip olması gereken kimlik numarasıdır. Şirket kurmak, banka hesabı açmak, mülk satın almak veya vergi beyannamesi vermek gibi işlemler NIE olmadan yapılamaz.</p>

<h3>NIE Nasıl Alınır?</h3>

<p>NIE başvurusu iki farklı şekilde yapılabilir.</p>

<p>Birincisi, İspanya'daki Yabancılar Ofisi (Oficina de Extranjería) veya polis karakoluna (Comisaría de Policía) bizzat başvurmaktır. Bunun için önce cita previa (randevu) almanız gerekir. Randevu almak, özellikle büyük şehirlerde (Madrid, Barcelona) oldukça zor olabilir; haftalar hatta aylar öncesinden planlamak gerekebilir.</p>

<p>İkincisi, kendi ülkenizdeki İspanya Konsolosluğu aracılığıyla başvurmaktır. Türkiye'de İstanbul veya Ankara'daki İspanya Başkonsolosluğu'na başvuru yapabilirsiniz. Bu yöntem, İspanya'ya gitmeden önce NIE almanıza olanak tanır.</p>

<h3>NIE Başvurusunda Gereken Belgeler</h3>

<p>Geçerli pasaport ve fotokopisi gereklidir. EX-15 formu doldurulmalıdır; bu form İspanya İçişleri Bakanlığı'nın web sitesinden indirilebilir. NIE'ye neden ihtiyaç duyduğunuzu açıklayan bir dilekçe yazılmalıdır; şirket kurmak yeterli bir gerekçedir. Başvuru harcı (tasa) ödeme makbuzu getirilmelidir; bu tutar yaklaşık 12-15 Euro civarındadır. Konsolosluk başvurusunda ek olarak apostilli belgeler istenebilir.</p>

<h3>NIE ve İkamet İzni Farkı</h3>

<p>NIE sadece bir kimlik numarasıdır ve tek başına ikamet veya çalışma hakkı vermez. İkamet izni ayrı bir süreçtir. Ancak NIE numarası, ikamet izniniz olmasa bile geçerlidir ve şirket kurma işlemlerinde kullanılabilir.</p>

<h2>Adım 2: Şirket Türünü Belirlemek</h2>

<p>Yabancı girişimcilerin büyük çoğunluğu SL (Sociedad Limitada) tercih eder. Bunun başlıca nedenleri şunlardır:</p>

<ul>
  <li>Sınırlı sorumluluk sayesinde kişisel varlıklar korunur</li>
  <li>Minimum sermaye sadece 3.000 Euro'dur</li>
  <li>Kurumsal yapı, müşteriler ve tedarikçiler nezdinde güvenilirlik sağlar</li>
  <li>Yabancı ortaklar kolayca dahil edilebilir</li>
  <li>Kâr transferi ve uluslararası vergi planlaması için uygun yapı sunar</li>
</ul>

<p>Autónomo statüsü ise İspanya'da ikamet eden ve bireysel olarak hizmet verecek yabancılar için uygundur. Ancak ikamet izni olmayan bir yabancının autónomo olarak kaydolması pratikte mümkün değildir çünkü sosyal güvenlik kaydı için geçerli bir ikamet izni gereklidir.</p>

<h2>Adım 3: Şirket Adı Onayı (Certificación Negativa)</h2>

<p>Şirket kurmadan önce tercih ettiğiniz şirket adının müsait olduğunu teyit ettirmeniz gerekir. Bu işlem Merkez Ticaret Sicili'ne (Registro Mercantil Central) başvurularak yapılır.</p>

<p>Başvuruda en fazla beş farklı isim önerebilirsiniz; öncelik sırasına göre değerlendirilir. Onay süresi genellikle birkaç iş günüdür ancak yoğun dönemlerde uzayabilir. Onaylanan isim üç ay süreyle sizin adınıza rezerve edilir.</p>

<p>Şirket adı, mevcut bir şirketle aynı veya çok benzer olmamalıdır. İspanyolca veya diğer resmi dillerde anlamlı olması zorunlu değildir; yabancı dilde isim kullanılabilir. Şirket adının sonuna "S.L." veya "Sociedad Limitada" eklenmesi zorunludur.</p>

<h2>Adım 4: Banka Hesabı Açmak ve Sermaye Yatırmak</h2>

<p>SL kurmak için minimum 3.000 Euro sermaye bir İspanya bankasına yatırılmalıdır. Bu aşamada şirket henüz kurulmadığı için hesap "constitución" (kuruluş) amacıyla açılır.</p>

<h3>Yabancılar İçin Banka Hesabı Zorlukları</h3>

<p>Bu aşama yabancı girişimcilerin en çok zorlandığı adımlardan biridir. İspanya bankaları, para aklama düzenlemeleri (KYC/AML) nedeniyle yabancılara hesap açarken ek belgeler ve inceleme talep edebilir. Bazı bankalar yabancılara hesap açmayı reddetmektedir.</p>

<p>Hesap açmak için genellikle şunlar gerekir: pasaport, NIE belgesi, İspanya'da adres beyanı (bazı bankalar için), gelir kaynağı belgesi, iş planı veya faaliyet açıklaması ve bazı bankalarda kişisel referans.</p>

<p>Önerimiz, bu sürece bir danışman veya avukat eşliğinde başlamanızdır. Deneyimli bir danışman, yabancı müşterilerle çalışmaya alışkın bankaları bilir ve süreci hızlandırır.</p>

<p>Sermaye hesaba yatırıldıktan sonra banka tarafından "certificado de depósito" adlı bir sermaye yatırma belgesi düzenlenir. Bu belge noter işlemi için zorunludur.</p>

<h2>Adım 5: Şirket Ana Sözleşmesinin Hazırlanması</h2>

<p>Ana sözleşme (estatutos sociales), şirketin temel kurallarını belirleyen hukuki belgedir. Bu belge bir avukat tarafından hazırlanmalı ve şu bilgileri içermelidir:</p>

<p>Şirketin tam adı ve ticari unvanı belirtilir. Şirketin merkez adresi (domicilio social) İspanya'da olmalıdır; bu adres şirketin yasal adresidir. Şirketin faaliyet konusu (objeto social) geniş tutulmalıdır ki ileride faaliyet alanı değişikliği için sözleşme tadili gerekmez. Sermaye tutarı ve dağılımı, ortakların pay oranları açıkça yazılmalıdır. Yönetim şekli belirlenmelidir: tek yönetici (administrador único), birden fazla yönetici (administradores mancomunados/solidarios) veya yönetim kurulu (consejo de administración) seçenekleri mevcuttur. Kâr dağıtım kuralları ve şirketin süresi (genellikle süresiz) de sözleşmede yer alır.</p>

<p>Yabancı girişimciler için önemli bir not: yönetici olarak atanan kişinin İspanya'da ikamet etmesi zorunlu değildir. Yurt dışından yöneticilik yapılabilir ancak pratikte bazı işlemler (vergi beyannameleri, resmi başvurular) için İspanya'da bir temsilci veya vekil gerekebilir.</p>

<h2>Adım 6: Noter İşlemleri (Escritura Pública)</h2>

<p>Tüm ortaklar ve yönetici(ler) noterde hazır bulunarak ana sözleşmeyi imzalar. Ortaklar İspanya'da değilse, kendi ülkelerindeki bir noterde apostilli vekaletname düzenleyerek bir temsilciyi yetkilendirebilir.</p>

<p>Noter işlemi için gereken belgeler şunlardır: ortakların pasaportları ve NIE belgeleri, şirket adı onay belgesi (Certificación Negativa), banka sermaye yatırma belgesi (certificado de depósito), hazırlanan ana sözleşme taslağı ve varsa vekaletnameler (apostilli ve yeminli tercümeli) gereklidir.</p>

<p>Yabancı dilde düzenlenmiş belgeler, yeminli tercüman (traductor jurado) tarafından İspanyolcaya çevrilmelidir. Apostil tasdiki bazı belgeler için gerekli olabilir.</p>

<p>Noter işlemi tamamlandığında "escritura de constitución" adlı kuruluş senedi düzenlenir. Bu belge şirketin resmi doğum belgesidir.</p>

<h2>Adım 7: CIF (Vergi Kimlik Numarası) Başvurusu</h2>

<p>Noter işleminden sonra İspanya Vergi Dairesi'ne (Agencia Tributaria – Hacienda) başvurarak şirket vergi kimlik numarası olan CIF alınır. Başvuru Modelo 036 formu ile yapılır.</p>

<p>İlk başvuruda geçici bir CIF verilir. Ticaret sicili tescili tamamlandıktan sonra kesin CIF'e dönüştürülür. CIF, şirketin tüm mali işlemlerinde (faturalama, vergi beyannameleri, banka işlemleri) kullanılır.</p>

<p>Bu aşamada şirketin vergisel yükümlülükleri de belirlenir: KDV mükellefiyet kaydı, IAE (ekonomik faaliyet vergisi) kaydı ve çalışan istihdam edilecekse sosyal güvenlik işveren kaydı yapılır.</p>

<h2>Adım 8: Ticaret Sicili Tescili</h2>

<p>Son adım olarak şirket, bulunduğu ilin Ticaret Sicili'ne (Registro Mercantil Provincial) tescil edilir. Bu işlem için noter tarafından düzenlenen kuruluş senedi ve CIF başvuru belgesi sunulur.</p>

<p>Tescil süresi genellikle 1 ila 3 hafta arasındadır. Tescil tamamlandığında şirket hukuki olarak tam yetkili hale gelir. Tescil belgesi (nota registral) bankaya sunularak geçici hesap tam operasyonel hesaba dönüştürülür.</p>

<h2>Yabancı Girişimciler İçin İkamet İzni Seçenekleri</h2>

<p>Şirket kurmak ile İspanya'da yaşamak farklı konulardır. Eğer İspanya'da ikamet etmeyi planlıyorsanız, aşağıdaki ikamet izni türlerinden biri size uygun olabilir.</p>

<ul>
  <li><strong>Girişimci Vizesi (Visa de Emprendedor):</strong> İnovatif bir iş planı ile başvurulur</li>
  <li><strong>Yatırımcı Vizesi (Golden Visa):</strong> İspanya'da 500.000 Euro ve üzeri gayrimenkul yatırımı karşılığında ikamet izni sağlar</li>
  <li><strong>Kendi Hesabına Çalışma İzni (Trabajo por Cuenta Propia):</strong> AB dışından gelen kişilerin İspanya'da autónomo olarak çalışabilmesi için gereken izindir</li>
  <li><strong>Şirket İçi Transfer (ICT):</strong> Çok uluslu şirketlerin çalışanlarını İspanya'ya transfer etmesi için kullanılan izin türüdür</li>
  <li><strong>Dijital Göçebe Vizesi:</strong> Uzaktan çalışan profesyoneller için 2023'te yürürlüğe giren yeni vize türüdür</li>
</ul>

<h2>Yabancı Girişimcilerin Dikkat Etmesi Gereken Konular</h2>

<h3>Vergi Rezidansı</h3>

<p>İspanya'da yılda 183 günden fazla kalırsanız İspanya vergi mukimi sayılırsınız. Bu durumda dünya genelindeki tüm gelirleriniz üzerinden İspanya'da vergi ödersiniz. Çifte vergilendirme anlaşmaları (Türkiye ile İspanya arasında mevcuttur) bu yükü hafifletebilir ancak vergi planlaması mutlaka bir uzman eşliğinde yapılmalıdır.</p>

<h3>Çifte Vergilendirme Anlaşması</h3>

<p>Türkiye ile İspanya arasındaki çifte vergilendirme anlaşması, her iki ülkede de vergi ödenmesini önlemeye yönelik düzenlemeler içerir. Kâr payları, faiz gelirleri ve telif hakları gibi gelir türleri için özel oranlar belirlenmiştir.</p>

<h3>Para Transferleri</h3>

<p>İspanya'ya ve İspanya'dan yapılan büyük para transferleri, İspanya Merkez Bankası'na (Banco de España) bildirilmelidir. 10.000 Euro ve üzerindeki nakit taşımacılığı gümrükte beyan edilmelidir. Bu kurallar para aklama önleme mevzuatı kapsamındadır.</p>

<h3>Dil Engeli</h3>

<p>İspanya'da resmi işlemler büyük ölçüde İspanyolca yürütülür. Vergi dairesi, ticaret sicili, noter ve belediye gibi kurumlar genellikle İspanyolca dışında hizmet vermez. Bu nedenle İspanyolca bilmeyen yabancı girişimcilerin yerel bir danışman veya avukatla çalışması neredeyse zorunludur.</p>

<h3>Dijital Sertifika</h3>

<p>İspanya'da birçok resmi işlem (vergi beyannameleri, sosyal güvenlik bildirimleri, ticaret sicili sorgulamaları) elektronik olarak yapılır. Bunun için dijital sertifika (certificado digital) gereklidir. Şirket adına ve yönetici adına ayrı ayrı dijital sertifika alınmalıdır. Başvuru FNMT (Fábrica Nacional de Moneda y Timbre) web sitesi üzerinden başlatılır ve kimlik doğrulaması için İspanya'da bir kuruma (Hacienda, Seguridad Social) bizzat gidilmesi gerekir.</p>

<h2>Sürecin Tahmini Maliyetleri</h2>

<p>Bir SL kurulumu için toplam maliyetler yaklaşık şu şekildedir:</p>

<div class="blog-stats-box">
  <div class="stat-item"><span class="stat-number">12-15€</span><span class="stat-label">NIE başvuru harcı</span></div>
  <div class="stat-item"><span class="stat-number">400-800€</span><span class="stat-label">Noter ücreti</span></div>
  <div class="stat-item"><span class="stat-number">800-2.000€</span><span class="stat-label">Avukat ve danışmanlık ücreti</span></div>
  <div class="stat-item"><span class="stat-number">3.000€</span><span class="stat-label">Minimum sermaye (geri alınabilir)</span></div>
</div>

<p>Toplam kuruluş maliyeti (sermaye hariç) yaklaşık 1.500 ila 3.500 Euro arasında değişir. Bu rakamlar şehre, avukat ücretlerine ve işlemin karmaşıklığına göre farklılık gösterebilir.</p>

<h2>Sürecin Tahmini Zaman Çizelgesi</h2>

<p>Tüm süreç, belgelerin hazır olması ve randevuların sorunsuz alınması durumunda yaklaşık 4 ila 8 hafta sürer. Ancak NIE randevusu almanın zorlukları, banka hesabı açma sürecindeki gecikmeler veya belge eksiklikleri süreci uzatabilir.</p>

<p>Aşama bazında tahmini süreler şöyledir: NIE başvurusu 1-4 hafta (randevu bekleme dahil), şirket adı onayı 3-5 iş günü, banka hesabı açma 1-2 hafta, noter ve tescil işlemleri 2-4 hafta şeklindedir.</p>

<p>Profesyonel danışmanlık hizmeti alarak bu süreyi optimize edebilir ve olası gecikmeleri en aza indirebilirsiniz.</p>

<h2>Sık Yapılan Hatalar</h2>

<p>Yabancı girişimcilerin İspanya'da şirket kurarken en sık düştüğü hatalar şunlardır:</p>

<p><strong>NIE randevusunu hafife almak:</strong> Özellikle Madrid ve Barcelona gibi büyük şehirlerde NIE randevusu almak haftalar hatta aylar sürebilir. Online randevu sistemi (cita previa) çok hızlı dolar. Bu adımı mümkün olduğunca erken başlatmak gerekir.</p>

<p><strong>Banka hesabı sürecini küçümsemek:</strong> İspanya bankaları yabancılara hesap açarken çok titiz davranabilir. Para aklama düzenlemeleri kapsamında ek belgeler, gelir kaynağı açıklaması ve hatta kişisel referanslar istenebilir.</p>

<p><strong>Yöneticinin autónomo kaydını ihmal etmek:</strong> SL yöneticisi aynı zamanda yüzde 25 veya daha fazla paya sahipse, autónomo kaydı yaptırması ve aylık sosyal güvenlik primi ödemesi zorunludur.</p>

<p><strong>Vergi rezidansı planlaması yapmamak:</strong> İspanya'da 183 günden fazla kalmak sizi İspanya vergi mukimi yapar. Bu durumda dünya genelindeki tüm gelirlerinizi İspanya'da beyan etmeniz gerekir.</p>

<p><strong>Belgelerin tercüme ve apostil işlemlerini geciktirmek:</strong> Türkiye'den getirilen belgelerin yeminli tercüme ve apostil tasdik işlemleri zaman alır. Bu işlemler paralel olarak başlatılmalıdır.</p>

<h2>Sonuç</h2>

<p>İspanya'da yabancı olarak şirket kurmak, doğru planlama ve profesyonel rehberlik ile oldukça yönetilebilir bir süreçtir. Anahtar, her adımı doğru sırada ve eksiksiz belgelerle tamamlamaktır. NIE almak, doğru şirket yapısını seçmek, güvenilir bir banka ile çalışmak ve yerel mevzuata hakim bir danışman ekibine sahip olmak başarının temel taşlarıdır.</p>

<p>Nova Iberian olarak, Türk ve uluslararası girişimcilere İspanya'da şirket kurma sürecinin her aşamasında destek veriyoruz. İlk danışmanlıktan şirketin faaliyete geçmesine kadar tüm bürokratik süreçleri sizin adınıza yönetiyoruz.</p>

<p><strong>İspanya'da iş kurmayı mı düşünüyorsunuz?</strong> Ücretsiz ön değerlendirme görüşmesi için bizimle iletişime geçin.</p>

<p><em>Bu içerik genel bilgilendirme amaçlıdır ve hukuki danışmanlık yerine geçmez. Mevzuat değişikliklerine bağlı olarak güncellenmiş bilgiler için profesyonel destek almanızı öneririz.</em></p>
      `,
      en: `
<h2>Starting a Company in Spain as a Foreigner</h2>
<p>Spain continues to be one of the most attractive markets in Europe for foreign entrepreneurs. Its strong tourism sector, strategic geographical location, EU membership market access, and relatively affordable cost of living attract thousands of foreign investors to this country every year.</p>

<h2>Can Foreigners Start a Company in Spain?</h2>
<p>Yes, Spanish law allows foreigners to establish companies or become partners in existing companies. There is no significant difference in the right to establish a company between EU citizens and non-EU citizens.</p>

<h2>Step 1: Getting an NIE Number</h2>
<p>NIE is the identification number that every foreigner must have to conduct any financial or legal transaction in Spain.</p>

<h2>Step 2: Determining the Company Type</h2>
<p>The vast majority of foreign entrepreneurs prefer SL (Sociedad Limitada). The main reasons are:</p>
<ul>
  <li>Limited liability protects personal assets</li>
  <li>Minimum capital is only €3,000</li>
  <li>Corporate structure provides credibility</li>
  <li>Foreign partners can be easily included</li>
</ul>

<h2>Step 3: Company Name Approval</h2>
<p>Before establishing a company, you need to confirm that your preferred company name is available by applying to the Central Commercial Registry.</p>

<h2>Steps 4-8: Banking, Notary, and Registration</h2>
<ol>
  <li>Open a bank account and deposit minimum capital (€3,000)</li>
  <li>Prepare articles of association</li>
  <li>Complete notary procedures</li>
  <li>Apply for CIF (tax identification number)</li>
  <li>Commercial Registry registration</li>
</ol>

<h2>Estimated Timeline and Costs</h2>
<p>The entire process takes approximately 4 to 8 weeks. Total formation cost (excluding capital) ranges from approximately €1,500 to €3,500.</p>

<p><em>At Nova Iberian, we support Turkish and international entrepreneurs at every stage of the company formation process in Spain.</em></p>
      `,
      es: `
<h2>Abrir una Empresa en España como Extranjero</h2>
<p>España sigue siendo uno de los mercados más atractivos de Europa para emprendedores extranjeros. Su fuerte sector turístico, ubicación geográfica estratégica y acceso al mercado de la UE atraen a miles de inversores extranjeros cada año.</p>

<h2>¿Pueden los Extranjeros Crear una Empresa en España?</h2>
<p>Sí, la ley española permite a los extranjeros establecer empresas o convertirse en socios de empresas existentes.</p>

<h2>Paso 1: Obtener el Número NIE</h2>
<p>El NIE es el número de identificación que todo extranjero debe tener para realizar cualquier transacción financiera o legal en España.</p>

<h2>Paso 2: Determinar el Tipo de Empresa</h2>
<p>La gran mayoría de emprendedores extranjeros prefieren la SL (Sociedad Limitada).</p>

<h2>Pasos 3-8: Registro y Constitución</h2>
<ol>
  <li>Aprobación del nombre de la empresa</li>
  <li>Abrir cuenta bancaria y depositar capital</li>
  <li>Preparar estatutos sociales</li>
  <li>Procedimientos notariales</li>
  <li>Solicitar CIF</li>
  <li>Inscripción en el Registro Mercantil</li>
</ol>

<p><em>En Nova Iberian, apoyamos a emprendedores turcos e internacionales en cada etapa del proceso de constitución de empresa en España.</em></p>
      `
    }
  },
  'ispanya-girisimci-vizesi-ile-sirket-kurma-adim-adim': {
    id: 'ispanya-girisimci-vizesi-ile-sirket-kurma-adim-adim',
    slugs: {
      tr: 'ispanya-girisimci-vizesi-ile-sirket-kurma-adim-adim',
      en: 'spain-entrepreneur-visa-company-formation-guide',
      es: 'visa-emprendedor-espana-guia-crear-empresa'
    },
    tag: { tr: 'Vize', en: 'Visa', es: 'Visa' },
    title: {
      tr: '<em>İspanya Girişimci Vizesi</em> ile Şirket Kurma Rehberi',
      en: '<em>Spain Entrepreneur Visa</em> Company Formation Guide',
      es: '<em>Visa de Emprendedor España:</em> Guía para Crear Empresa'
    },
    metaTitle: {
      tr: 'İspanya Girişimci Vizesi (Visa de Emprendedor) ile Şirket Kurma Rehberi | Nova Iberian',
      en: 'Spain Entrepreneur Visa (Visa de Emprendedor) Company Formation Guide | Nova Iberian',
      es: 'Visa de Emprendedor España: Guía Completa para Crear Empresa | Nova Iberian'
    },
    metaDescription: {
      tr: 'İspanya girişimci vizesi başvuru şartları, iş planı hazırlama, süreç adımları ve şirket kurma rehberi. ENISA değerlendirmesi, gerekli belgeler ve avantajlar.',
      en: 'Spain entrepreneur visa application requirements, business plan preparation, process steps and company formation guide.',
      es: 'Requisitos de solicitud de visa de emprendedor de España, preparación del plan de negocios, pasos del proceso y guía de formación de empresa.'
    },
    category: { tr: 'İspanya Vizeler ve İkamet', en: 'Spain Visas and Residence', es: 'Visas y Residencia en España' },
    tags: ['İspanya girişimci vizesi', 'Visa de Emprendedor', 'İspanya iş vizesi', 'İspanya startup vizesi', 'Ley de Emprendedores', 'İspanya ikamet izni', 'İspanya\'da yaşamak'],
    excerpt: {
      tr: 'Girişimci vizesi ile İspanya\'da şirket kurarak oturum izni almanın yolu. Başvuru şartları, süreç ve avantajlar.',
      en: 'The path to residency in Spain by starting a company with an entrepreneur visa. Application requirements, process and advantages.',
      es: 'El camino a la residencia en España creando una empresa con visa de emprendedor.'
    },
    date: '2026-04-19',
    readTime: { tr: '16 dk okuma', en: '16 min read', es: '16 min lectura' },
    content: {
      tr: `
<p>İspanya, AB dışından gelen girişimcilere kapılarını açan çeşitli ikamet izni seçenekleri sunmaktadır. Bunların arasında en dikkat çekici olanı Girişimci Vizesi, yani Visa de Emprendedor'dur. Bu vize, yenilikçi bir iş projesi ile İspanya'da şirket kurmak ve oturum izni almak isteyen girişimciler için tasarlanmıştır.</p>

<p>Bu rehberde, İspanya girişimci vizesinin ne olduğunu, kimler için uygun olduğunu, başvuru sürecini adım adım ve şirket kurma ile nasıl birleştirildiğini detaylı olarak ele alacağız.</p>

<h2>Girişimci Vizesi (Visa de Emprendedor) Nedir?</h2>

<p>Girişimci Vizesi, İspanya'nın 2013 yılında yürürlüğe giren Girişimcileri Destekleme Yasası (Ley 14/2013, Ley de Emprendedores) kapsamında oluşturulan bir oturum izni türüdür. 2023 yılında kabul edilen Startup Yasası (Ley de Startups) ile bu vize türüne önemli kolaylıklar ve avantajlar eklenmiştir.</p>

<p>Bu vize, AB/AEA vatandaşı olmayan kişilerin İspanya'da inovatif bir iş projesi geliştirmek amacıyla ikamet etmelerine olanak tanır. Vize sahipleri, İspanya'da şirket kurabilir, çalışabilir ve yaşayabilir.</p>

<h2>Girişimci Vizesi Kimler İçin Uygun?</h2>

<p>Bu vize türü, özellikle şu profillere sahip girişimciler için tasarlanmıştır:</p>

<ul>
  <li>Yenilikçi veya ölçeklenebilir bir iş fikri olan kişiler</li>
  <li>Teknoloji, yazılım, biyoteknoloji gibi inovasyon odaklı sektörlerde faaliyet göstermek isteyenler</li>
  <li>Mevcut bir işi İspanya'ya taşımak isteyen uluslararası girişimciler</li>
  <li>AB pazarına açılmak isteyen startup kurucuları</li>
  <li>İspanya'da yaşamak ve çalışmak isteyen dijital girişimciler</li>
</ul>

<p>Girişimci vizesi, sıradan ticari faaliyetler için değil, inovatif ve katma değerli projeler için tasarlanmıştır. Bu nedenle, geleneksel sektörlerde (örneğin standart perakende veya lokanta) iş açmak isteyen girişimciler için bu vize uygun olmayabilir; bu kişiler için Kendi Hesabına Çalışma İzni (Cuenta Propia) daha uygun bir seçenek olabilir.</p>

<h2>Girişimci Vizesinin Avantajları</h2>

<p>Girişimci vizesi, diğer ikamet izni türlerine kıyasla önemli avantajlar sunar:</p>

<p><strong>Hızlı İşlem Süresi:</strong> Başvurular 20 iş günü içinde sonuçlandırılır. Diğer vize türlerine göre çok daha hızlı bir süreçtir.</p>

<p><strong>Aile Birleşimi:</strong> Vize sahibi, eşini ve 18 yaş altı çocuklarını da İspanya'ya getirebilir. Aile üyeleri de oturum ve çalışma izni alır.</p>

<p><strong>Çalışma İzni:</strong> Vize sahibi, kendi şirketinde çalışma hakkına sahiptir. Ayrıca başka bir işte de çalışabilir.</p>

<p><strong>Vergi Avantajları:</strong> 2023 Startup Yasası kapsamında, startup olarak tescil edilen şirketler için kurumlar vergisi oranı ilk 4 yıl boyunca yüzde 15'e düşürülmüştür (standart oran yüzde 25). Ayrıca Beckham Yasası kapsamında kişisel gelir vergisi avantajları da uygulanabilir.</p>

<p><strong>Schengen Dolaşım Hakkı:</strong> Vize sahibi, tüm Schengen bölgesinde (26 ülke) vize olmadan seyahat edebilir.</p>

<p><strong>Uzun Vadeli İkamet Yolu:</strong> İlk vize genellikle 1 yıllık verilir ve 2'şer yıllık dönemlerle yenilenebilir. 5 yıl sonunda kalıcı oturum iznine (residencia de larga duración) başvurulabilir.</p>

<h2>Başvuru Şartları</h2>

<p>Girişimci vizesi başvurusunda karşılanması gereken temel şartlar şunlardır:</p>

<p><strong>İnovatif İş Projesi:</strong> Başvurunun en kritik unsuru, İspanya ekonomisine katkı sağlayacak yenilikçi bir iş projesidir. Bu proje, bir iş planı aracılığıyla detaylı şekilde sunulmalıdır.</p>

<p><strong>ENISA Olumlu Raporu:</strong> İş projenizin yenilikçilik ve ekonomik potansiyeli, ENISA (Empresa Nacional de Innovación) tarafından değerlendirilir. ENISA, İspanya Sanayi Bakanlığı'na bağlı bir kuruluştur ve girişimci vizesi başvurularında referans raporu hazırlar. Olumlu rapor almak başvuru için zorunludur. Değerlendirme genellikle 15-20 iş günü içinde tamamlanır.</p>

<p><strong>Yeterli Finansal Kaynak:</strong> Başvuru sahibi, İspanya'da yaşamını sürdürebileceğini gösteren finansal belgelere sahip olmalıdır. Genel olarak aylık yaklaşık 2.000-3.000 Euro gelir veya karşılığında banka hesabı bakiyesi beklenir. Aile üyeleri için ek finansal kaynak gereklidir.</p>

<p><strong>Temiz Adli Sicil:</strong> Son 5 yıl içinde ikamet edilen ülkelerden apostilli sabıka kaydı belgesi gereklidir. İspanya'da herhangi bir yasal engel bulunmamalıdır.</p>

<p><strong>Sağlık Sigortası:</strong> İspanya'da geçerli, kapsamlı özel sağlık sigortası zorunludur. Sigorta, en az başvuru süresi boyunca geçerli olmalı ve İspanya'da faaliyet gösteren bir sigorta şirketinden alınmalıdır.</p>

<p><strong>Geçerli Pasaport:</strong> Pasaportun geçerlilik süresi, talep edilen oturum süresinden en az bir yıl fazla olmalıdır.</p>

<h2>Başvuru Süreci: Adım Adım</h2>

<h3>Adım 1: İş Planı Hazırlama</h3>

<p>Başarılı bir girişimci vizesi başvurusunun temeli, ikna edici ve detaylı bir iş planıdır. Bu plan şunları içermelidir:</p>

<ul>
  <li>Projenin genel tanımı ve inovatif yönleri</li>
  <li>Hedef pazar analizi</li>
  <li>Rekabet analizi</li>
  <li>İş modeli ve gelir kaynakları</li>
  <li>3-5 yıllık mali projeksiyonlar</li>
  <li>İstihdam planı (kaç kişi çalıştırılacak)</li>
  <li>Kurucuların özgeçmişleri ve deneyimleri</li>
  <li>Neden İspanya'nın seçildiği ve ülke ekonomisine katkı</li>
</ul>

<p>İş planı İspanyolca veya İngilizce hazırlanabilir. Ancak İspanyolca hazırlanması değerlendirme sürecini hızlandırabilir.</p>

<h3>Adım 2: ENISA Başvurusu</h3>

<p>İş planı hazırlandıktan sonra ENISA'ya online başvuru yapılır. ENISA, projenizi şu kriterlere göre değerlendirir:</p>

<ul>
  <li>Yenilikçilik düzeyi</li>
  <li>İspanya ekonomisine potansiyel katkı</li>
  <li>Kurucuların profili ve deneyimi</li>
  <li>Projenin uygulanabilirliği</li>
</ul>

<p>ENISA değerlendirmesi ücretsizdir ve sonuç genellikle 15-20 iş günü içinde açıklanır. Olumlu rapor, vize başvurusuna eklenmesi gereken kritik bir belgedir.</p>

<h3>Adım 3: Belgelerin Hazırlanması</h3>

<p>Vize başvurusu için gereken belgeler şunlardır:</p>

<ul>
  <li>Doldurulmuş vize başvuru formu</li>
  <li>Pasaport ve fotokopisi</li>
  <li>2 adet vesikalık fotoğraf</li>
  <li>ENISA olumlu raporu</li>
  <li>İş planı</li>
  <li>Finansal yeterlilik belgesi (banka hesap özeti, gelir belgesi vb.)</li>
  <li>Apostilli ve yeminli tercümeli sabıka kaydı</li>
  <li>Sağlık sigortası poliçesi</li>
  <li>Üniversite diploması veya mesleki deneyim belgesi (varsa)</li>
  <li>Vize başvuru ücreti makbuzu</li>
</ul>

<p>Yabancı dildeki tüm belgeler yeminli tercüman (traductor jurado) tarafından İspanyolcaya çevrilmelidir.</p>

<h3>Adım 4: Vize Başvurusu</h3>

<p>Başvuru, iki farklı şekilde yapılabilir.</p>

<p>İspanya Dışından Başvuru (Vize): Kendi ülkenizdeki İspanya Konsolosluğu'na başvurursunuz. Bu durumda önce 1 yıllık vize alır, İspanya'ya giriş yaptıktan sonra TIE (Tarjeta de Identidad de Extranjero) oturum kartına başvurursunuz.</p>

<p>İspanya İçinden Başvuru (Doğrudan Oturum İzni): Halihazırda İspanya'da yasal olarak bulunuyorsanız (örneğin turist vizesiyle veya başka bir oturum izniyle), doğrudan UGE (Unidad de Grandes Empresas y Colectivos Estratégicos) aracılığıyla oturum iznine başvurabilirsiniz.</p>

<h3>Adım 5: Vize Onayı ve İspanya'ya Giriş</h3>

<p>Başvuru onaylandıktan sonra pasaportunuza vize yapıştırılır. Bu vize, İspanya'ya giriş yapmanızı sağlar. İspanya'ya girdikten sonra 1 ay içinde TIE kartı başvurusu yapmanız gerekir.</p>

<h3>Adım 6: TIE Kartı Başvurusu</h3>

<p>İspanya'ya vardıktan sonra yerel Yabancılar Ofisi'nden (Oficina de Extranjería) TIE kartı randevusu alınır. Bu randevuda parmak izi kaydı yapılır ve fiziksel oturum kartınız hazırlanır. Kart genellikle başvurudan 30-45 gün sonra teslim alınır.</p>

<h2>Girişimci Vizesi ile Şirket Kurma</h2>

<p>Girişimci vizesi aldıktan sonra İspanya'da şirket kurma süreci başlar. Bu süreç diğer yabancıların şirket kurma süreciyle aynıdır:</p>

<ol>
  <li>NIE numarası alma (vize sürecinde zaten alınmış olabilir)</li>
  <li>Şirket adı onayı (Registro Mercantil Central)</li>
  <li>Banka hesabı açma ve sermaye yatırma</li>
  <li>Noter işlemleri (escritura de constitución)</li>
  <li>CIF başvurusu (Agencia Tributaria)</li>
  <li>Ticaret Sicili tescili</li>
</ol>

<p>Girişimci vizesi sahipleri genellikle SL (Sociedad Limitada) tercih eder. Ancak 2023 Startup Yasası kapsamında "startup" statüsü almak için ek bir başvuru gereklidir. Bu statü, vergi avantajları ve diğer kolaylıklardan yararlanmak için önemlidir.</p>

<h2>Startup Statüsü (Ley de Startups)</h2>

<p>2023 yılında yürürlüğe giren Startup Yasası, yenilikçi şirketlere önemli avantajlar sunmaktadır. Girişimci vizesiyle İspanya'ya gelen girişimciler, şirketlerini "startup" olarak tescil ettirerek bu avantajlardan yararlanabilir.</p>

<p>Startup statüsü için şu kriterler aranır:</p>

<ul>
  <li>Şirketin 5 yıldan (biyoteknoloji için 7 yıl) eski olmaması</li>
  <li>Yıllık cironun 10 milyon Euro'yu aşmaması</li>
  <li>Projenin inovatif veya ölçeklenebilir nitelikte olması</li>
  <li>Kâr dağıtımı yapmamış olması</li>
  <li>Başka bir şirketin birleşme/devralma sonucu oluşmamış olması</li>
</ul>

<p>Startup statüsü, ENISA tarafından değerlendirilir ve onaylanır. Onay süreci yaklaşık 3 ay sürebilir.</p>

<h2>Vize Yenileme</h2>

<p>İlk girişimci vizesi genellikle 1 yıllık verilir. Bu süre sonunda, projenizin devam ettiğini ve ilerleme kaydettiğini göstererek 2 yıllık uzatma başvurusu yapabilirsiniz.</p>

<p>Yenileme başvurusunda şunlar değerlendirilir:</p>

<ul>
  <li>Şirketin faal olması</li>
  <li>Vergi ve sosyal güvenlik yükümlülüklerinin yerine getirilmesi</li>
  <li>İş planında belirtilen hedeflere yönelik ilerleme</li>
  <li>Finansal sürdürülebilirlik</li>
</ul>

<p>5 yıl kesintisiz ikamet ettikten sonra kalıcı oturum iznine (residencia de larga duración) başvurabilirsiniz. 10 yıl sonunda ise İspanya vatandaşlığına başvuru hakkı doğar.</p>

<h2>Sık Sorulan Sorular</h2>

<h3>Girişimci vizesi için asgari yatırım tutarı var mı?</h3>
<p>Hayır, Golden Visa gibi belirli bir minimum yatırım tutarı yoktur. Ancak şirket sermayesi (SL için 3.000 Euro) ve yaşam giderlerini karşılayacak finansal kaynak gösterilmelidir.</p>

<h3>İş planım reddedilirse ne olur?</h3>
<p>ENISA değerlendirmesi olumsuz sonuçlanırsa, iş planınızı revize ederek tekrar başvurabilirsiniz. Ret gerekçeleri incelenerek proje güçlendirilebilir.</p>

<h3>Girişimci vizesiyle İspanya dışında çalışabilir miyim?</h3>
<p>Evet, İspanya'da ikamet ettiğiniz sürece uzaktan çalışabilir veya yurt dışı seyahatleri yapabilirsiniz. Ancak yılda 183 günden fazla İspanya'da kalmanız beklenir.</p>

<h3>Ailem de çalışabilir mi?</h3>
<p>Evet, aile birleşimi kapsamında gelen eş ve çocuklar da çalışma iznine sahiptir.</p>

<h2>Sonuç</h2>

<p>İspanya girişimci vizesi, yenilikçi iş fikirleri olan girişimciler için Avrupa pazarına açılmanın en etkili yollarından biridir. Hızlı işlem süresi, vergi avantajları, aile birleşimi imkânı ve Schengen dolaşım hakkı ile oldukça cazip bir seçenektir.</p>

<p>Başarılı bir başvuru için iyi hazırlanmış bir iş planı, ENISA'dan olumlu rapor ve eksiksiz belgeler kritik öneme sahiptir. Sürecin karmaşıklığı göz önüne alındığında, profesyonel danışmanlık almak başvurunuzun başarı şansını önemli ölçüde artırır.</p>

<p>Nova Iberian olarak, İspanya girişimci vizesi başvurularında iş planı hazırlığından şirket kurulumuna, vize başvurusundan startup tescilne kadar tüm süreçlerde yanınızdayız.</p>

<p><strong>Girişimci vizeniz için ücretsiz ön değerlendirme görüşmesi talep edin.</strong></p>

<p><em>Bu içerik genel bilgilendirme amaçlıdır ve hukuki danışmanlık yerine geçmez. Mevzuat farklılık gösterebilir; güncel bilgi için profesyonel destek almanızı öneririz.</em></p>
      `,
      en: `
<h2>What is the Spain Entrepreneur Visa?</h2>
<p>The Entrepreneur Visa (Visa de Emprendedor) is a residence permit created under Spain's Entrepreneur Support Law (Ley 14/2013) that came into force in 2013. The 2023 Startup Law added significant benefits to this visa type.</p>

<p>This visa allows non-EU/EEA citizens to reside in Spain to develop an innovative business project. Visa holders can establish companies, work, and live in Spain.</p>

<h2>Who is the Entrepreneur Visa For?</h2>
<ul>
  <li>People with innovative or scalable business ideas</li>
  <li>Those wanting to operate in innovation-focused sectors like technology, software, biotechnology</li>
  <li>International entrepreneurs wanting to move their existing business to Spain</li>
  <li>Startup founders wanting to access the EU market</li>
</ul>

<h2>Advantages of the Entrepreneur Visa</h2>
<ul>
  <li><strong>Fast Processing:</strong> Applications are processed within 20 business days</li>
  <li><strong>Family Reunification:</strong> Spouse and children under 18 can also come to Spain</li>
  <li><strong>Work Permit:</strong> Visa holders have the right to work in their own company</li>
  <li><strong>Tax Benefits:</strong> Under the 2023 Startup Law, corporate tax rate is reduced to 15% for the first 4 years</li>
  <li><strong>Schengen Travel:</strong> Visa holders can travel freely throughout the Schengen area</li>
</ul>

<h2>Application Process</h2>
<ol>
  <li>Prepare a detailed business plan</li>
  <li>Apply to ENISA for innovation assessment</li>
  <li>Gather required documents</li>
  <li>Submit visa application at Spanish Consulate or UGE</li>
  <li>Receive visa approval and enter Spain</li>
  <li>Apply for TIE residence card</li>
</ol>

<p><em>At Nova Iberian, we support you throughout the entrepreneur visa application process, from business plan preparation to company formation.</em></p>
      `,
      es: `
<h2>¿Qué es la Visa de Emprendedor de España?</h2>
<p>La Visa de Emprendedor es un permiso de residencia creado bajo la Ley de Apoyo a Emprendedores de España (Ley 14/2013). La Ley de Startups de 2023 añadió beneficios significativos a este tipo de visa.</p>

<p>Esta visa permite a ciudadanos no pertenecientes a la UE/EEE residir en España para desarrollar un proyecto empresarial innovador.</p>

<h2>¿Para Quién es la Visa de Emprendedor?</h2>
<ul>
  <li>Personas con ideas de negocio innovadoras o escalables</li>
  <li>Quienes desean operar en sectores centrados en la innovación</li>
  <li>Emprendedores internacionales que quieren trasladar su negocio a España</li>
  <li>Fundadores de startups que quieren acceder al mercado de la UE</li>
</ul>

<h2>Ventajas de la Visa de Emprendedor</h2>
<ul>
  <li><strong>Procesamiento Rápido:</strong> Las solicitudes se procesan en 20 días hábiles</li>
  <li><strong>Reunificación Familiar:</strong> El cónyuge e hijos menores de 18 años también pueden venir</li>
  <li><strong>Permiso de Trabajo:</strong> Los titulares de visa tienen derecho a trabajar en su propia empresa</li>
  <li><strong>Beneficios Fiscales:</strong> Tasa de impuesto de sociedades reducida al 15% durante los primeros 4 años</li>
</ul>

<p><em>En Nova Iberian, le apoyamos durante todo el proceso de solicitud de visa de emprendedor.</em></p>
      `
    }
  },
  'ispanyada-restoran-kafe-otel-acmak-lisans-ve-izinler': {
    id: 'ispanyada-restoran-kafe-otel-acmak-lisans-ve-izinler',
    slugs: {
      tr: 'ispanyada-restoran-kafe-otel-acmak-lisans-ve-izinler',
      en: 'opening-restaurant-cafe-hotel-spain-licenses-permits',
      es: 'abrir-restaurante-cafe-hotel-espana-licencias-permisos'
    },
    tag: { tr: 'İş Kurma', en: 'Business Setup', es: 'Crear Negocio' },
    title: {
      tr: '<em>İspanya\'da Restoran, Kafe, Otel Açmak:</em> Lisans ve İzinler',
      en: '<em>Opening a Restaurant, Cafe, Hotel in Spain:</em> Licenses and Permits',
      es: '<em>Abrir Restaurante, Cafetería, Hotel en España:</em> Licencias y Permisos'
    },
    metaTitle: {
      tr: 'İspanya\'da Restoran, Kafe, Otel Açmak: Gerekli Lisanslar ve İzinler | Nova Iberian',
      en: 'Opening a Restaurant, Cafe, Hotel in Spain: Required Licenses and Permits | Nova Iberian',
      es: 'Abrir Restaurante, Cafetería, Hotel en España: Licencias y Permisos Requeridos | Nova Iberian'
    },
    metaDescription: {
      tr: 'İspanya\'da restoran, kafe veya otel açmak için gereken tüm lisanslar, izinler, sağlık kuralları ve prosedürler. HoReCa sektörü rehberi.',
      en: 'All licenses, permits, health regulations and procedures required to open a restaurant, cafe or hotel in Spain. HoReCa sector guide.',
      es: 'Todas las licencias, permisos, normativas sanitarias y procedimientos necesarios para abrir un restaurante, cafetería u hotel en España.'
    },
    category: { tr: 'İspanya\'da Sektörel Rehberler', en: 'Sectoral Guides in Spain', es: 'Guías Sectoriales en España' },
    tags: ['İspanya restoran açma', 'İspanya kafe açma', 'İspanya otel açma', 'licencia de apertura', 'İspanya gıda lisansı', 'İspanya turizm lisansı', 'İspanya işletme izni', 'İspanya konaklama'],
    excerpt: {
      tr: 'İspanya\'da yiyecek-içecek veya konaklama sektöründe iş açmak isteyenler için gerekli lisanslar, izinler ve prosedürler hakkında kapsamlı rehber.',
      en: 'Comprehensive guide on required licenses, permits and procedures for those wanting to open a food & beverage or hospitality business in Spain.',
      es: 'Guía completa sobre licencias, permisos y procedimientos necesarios para abrir un negocio de hostelería en España.'
    },
    date: '2026-04-22',
    readTime: { tr: '18 dk okuma', en: '18 min read', es: '18 min lectura' },
    content: {
      tr: `
<p>İspanya, yıllık 80 milyonu aşan turist sayısıyla Avrupa'nın en popüler destinasyonlarından biridir. Bu durum, yiyecek-içecek ve konaklama sektörünü son derece çekici kılmaktadır. Ancak İspanya'da restoran, kafe veya otel açmak, diğer iş türlerine göre çok daha fazla lisans, izin ve düzenlemeye tabidir.</p>

<p>Bu rehberde, İspanya'da HoReCa (Hotel, Restaurant, Café) sektöründe iş açmak isteyen girişimcilerin bilmesi gereken tüm lisans ve izin süreçlerini detaylı olarak ele alacağız.</p>

<h2>HoReCa Sektörünün İspanya'daki Önemi</h2>

<p>İspanya ekonomisinde turizm ve ona bağlı sektörler kritik bir rol oynamaktadır. Ülke GSYİH'sının yaklaşık yüzde 12'si doğrudan turizm ve konaklama sektöründen gelmektedir. Barcelona, Madrid, Sevilla, Valencia, Malaga gibi şehirler ve Balear Adaları, Kanarya Adaları, Costa del Sol gibi turistik bölgeler, yoğun restoran ve otel talebiyle dikkat çeker.</p>

<p>Ancak bu fırsatların yanında ciddi düzenlemeler de mevcuttur. İspanya'da HoReCa sektörü, hem ulusal hem de bölgesel (Özerk Topluluk) düzeyinde sıkı kurallara tabidir. Her şehrin ve hatta bazı ilçelerin kendine özgü ek düzenlemeleri olabilir. Bu nedenle lisans sürecine başlamadan önce yerel mevzuatı araştırmak hayati önem taşır.</p>

<h2>Restoran veya Kafe Açmak İçin Gerekli Lisanslar</h2>

<p>İspanya'da bir restoran veya kafe açabilmek için bir dizi lisans ve izin almanız gerekmektedir. Bu süreç genellikle 3 ila 6 ay sürer ve maliyetler bölgeye göre değişir.</p>

<h3>1. Licencia de Actividad (Faaliyet Lisansı)</h3>

<p>Bu lisans, işletmenizin bulunduğu mekânın planlanan faaliyet için uygun olduğunu onaylar. Belediyeden (Ayuntamiento) alınır. Başvuru sırasında mekânın teknik projeleri, mimar veya mühendis tarafından hazırlanan planlar ve faaliyet tanımı sunulur.</p>

<p>Faaliyet lisansları iki ana kategoriye ayrılır. Actividades Inocuas (Zararsız Faaliyetler) küçük ölçekli, düşük riskli işletmeler içindir ve süreç daha basittir. Actividades Clasificadas (Sınıflandırılmış Faaliyetler) ise gürültü, duman, koku veya çevresel etki riski taşıyan faaliyetler içindir. Mutfaklı restoranlar genellikle bu kategoriye girer.</p>

<h3>2. Licencia de Apertura (Açılış Lisansı)</h3>

<p>Tüm teknik gereksinimler karşılandıktan ve mekân denetimden geçtikten sonra belediye tarafından verilen resmi açılış iznidir. Bu lisans olmadan işletme faaliyete geçemez.</p>

<p>Birçok bölgede Declaración Responsable (Sorumluluk Beyanı) adlı basitleştirilmiş bir prosedür de uygulanmaktadır. Bu sistemde işletme sahibi, tüm gereksinimleri karşıladığını beyan eder ve kontrol sonradan yapılır. Bu sayede açılış süreci hızlanabilir, ancak beyan yanlış veya eksikse ciddi yaptırımlar uygulanır.</p>

<h3>3. Registro Sanitario (Sağlık Kaydı)</h3>

<p>Gıda işletmeleri, yerel sağlık otoritesine (Consejería de Sanidad) kayıt yaptırmak zorundadır. Bu kayıt, gıda güvenliği ve hijyen standartlarının karşılandığını belgeler.</p>

<p>Kayıt için APPCC (HACCP) planı zorunludur. APPCC (Análisis de Peligros y Puntos Críticos de Control), gıda güvenliğini sağlamak için kullanılan uluslararası bir sistemdir. Bu plan, mutfakta olası tehlike noktalarını ve bunların nasıl kontrol edileceğini belirler.</p>

<h3>4. Manipulador de Alimentos (Gıda İşleyici Belgesi)</h3>

<p>Gıda ile temas eden tüm çalışanların bu sertifikaya sahip olması zorunludur. Online veya yüz yüze kurslarla alınabilir. Maliyet yaklaşık 20-50 Euro arasındadır. Her çalışan için ayrı ayrı gereklidir.</p>

<h3>5. Licencia de Terraza (Teras/Dış Alan Lisansı)</h3>

<p>Kaldırım veya açık alanda masa-sandalye koymak istiyorsanız, belediyeden ayrı bir teras lisansı almanız gerekir. Bu lisans genellikle yıllık olarak yenilenir ve metrekare başına ücret alınır. Özellikle turistik bölgelerde teras lisansı almak hem maliyetli hem de rekabetçi olabilir. Bazı belediyelerde teras kapasitesi sınırlıdır ve bekleme listesi mevcuttur.</p>

<h3>6. Licencia de Música (Müzik Lisansı)</h3>

<p>İşletmenizde arka plan müziği çalacaksanız, SGAE (Sociedad General de Autores y Editores) gibi telif hakkı kuruluşlarından lisans almanız gerekir. Yıllık ücretler işletme büyüklüğüne göre değişir.</p>

<h3>7. Cartel de Horario (Çalışma Saatleri Tabelası)</h3>

<p>İşletme giriş kapısında çalışma saatlerini gösteren resmi bir tabela bulundurulması zorunludur. Kapanış saatleri bölgeye ve işletme türüne göre düzenlenir; örneğin bazı bölgelerde restoranlar en geç 01:00'de kapanmalıdır.</p>

<h3>8. Hojas de Reclamación (Şikâyet Defteri)</h3>

<p>Tüm işletmelerde müşterilerin şikâyetlerini yazılı olarak iletebileceği resmi şikâyet formları bulundurulması zorunludur. Bu formlar tüketici koruma otoritesine iletilebilir.</p>

<h2>Otel veya Konaklama Tesisi Açmak İçin Gerekli Lisanslar</h2>

<p>Otel, hostel, pansion, tatil evi (apartamento turístico) veya kırsal turizm tesisi açmak, restoranlara göre daha kapsamlı bir lisans sürecini gerektirir.</p>

<h3>1. Registro de Turismo (Turizm Kaydı)</h3>

<p>Konaklama tesisleri, faaliyet gösterdikleri Özerk Topluluk'un turizm müdürlüğüne kayıt yaptırmalıdır. Bu kayıt, tesisin sınıflandırılmasını (otel, hostel, pansion vb.) ve yıldız derecesini belirler.</p>

<h3>2. Clasificación y Categoría (Sınıflandırma ve Kategori)</h3>

<p>Oteller yıldız sistemiyle derecelendirilir (1'den 5'e kadar). Her yıldız kategorisi için karşılanması gereken minimum standartlar vardır: oda büyüklüğü, banyo tesisleri, resepsiyon saatleri, sunulan hizmetler vb. Yıldız sayısı arttıkça gereksinimler de artar.</p>

<h3>3. Libro de Registro de Viajeros (Misafir Kayıt Defteri)</h3>

<p>Tüm konaklama tesisleri, misafir bilgilerini (kimlik, geliş-gidiş tarihleri) kayıt altına almak ve bu bilgileri polis ile paylaşmak zorundadır. Bu, güvenlik ve göç kontrolü amaçlıdır. Bilgiler 24 saat içinde polis sistemine (SES - Sistema de Entrada de Viajeros) bildirilmelidir.</p>

<h3>4. Seguro de Responsabilidad Civil (Mesleki Sorumluluk Sigortası)</h3>

<p>Konaklama tesisleri, misafirlere veya üçüncü taraflara karşı oluşabilecek zararları kapsayan sigorta yaptırmak zorundadır. Minimum teminat tutarı bölgeye ve tesis türüne göre değişir.</p>

<h3>5. Certificado de Eficiencia Energética (Enerji Verimliliği Sertifikası)</h3>

<p>Tüm ticari mülkler için zorunlu olan bu sertifika, binanın enerji verimliliğini değerlendirir. Sertifika yetkili bir teknisyen tarafından hazırlanır ve bölgesel enerji dairesine kaydedilir.</p>

<h3>6. Plan de Autoprotección (Acil Durum Planı)</h3>

<p>Belirli kapasitelerin üzerindeki konaklama tesisleri (genellikle 200 kişi ve üzeri), detaylı bir acil durum ve tahliye planı hazırlamak zorundadır. Bu plan, yangın, deprem ve diğer acil durumlar için prosedürleri içerir.</p>

<h2>Özel Durumlar ve Ek Lisanslar</h2>

<h3>Alkol Satış Lisansı</h3>

<p>İspanya'da alkol satışı genel olarak serbest olsa da, bazı bölgelerde veya belirli saatlerde ek kısıtlamalar uygulanabilir. Gece kulübü, bar veya diskoteklerin ayrı lisans alması gerekir.</p>

<h3>Çevresel İzinler</h3>

<p>Yüksek gürültü seviyesi veya çevresel etki riski taşıyan işletmeler (özellikle canlı müzik mekanları) için ek çevresel değerlendirme ve izinler gerekebilir.</p>

<h3>Tarihi Binalarda Faaliyet</h3>

<p>Tarihi veya koruma altındaki binalarda iş açmak, ek izinler ve kısıtlamalar gerektirir. Dış cephe değişiklikleri, tabela boyutları ve renkleri bile onaya tabi olabilir.</p>

<h3>Tatil Evi (Vivienda de Uso Turístico)</h3>

<p>Kısa süreli kiralama amacıyla konut kullanımı, son yıllarda İspanya genelinde sıkı düzenlemelere tabi tutulmuştur. Barcelona, Madrid, Balear Adaları gibi bölgelerde yeni tatil evi lisansları almak oldukça zorlaşmış, hatta bazı bölgelerde tamamen durdurulmuştur.</p>

<h2>Lisans Sürecinin Tahmini Zaman Çizelgesi</h2>

<p>Süreçler bölgeye ve işletme türüne göre değişmekle birlikte, genel bir zaman çizelgesi şöyledir:</p>

<div class="blog-stats-box">
  <div class="stat-item"><span class="stat-number">1-2 Ay</span><span class="stat-label">Teknik proje hazırlığı</span></div>
  <div class="stat-item"><span class="stat-number">2-4 Ay</span><span class="stat-label">Belediye lisans başvurusu ve onayı</span></div>
  <div class="stat-item"><span class="stat-number">1-2 Ay</span><span class="stat-label">Sağlık ve turizm kayıtları</span></div>
  <div class="stat-item"><span class="stat-number">3-6 Ay</span><span class="stat-label">Toplam süre (iyi koşullarda)</span></div>
</div>

<p>Mekân tadilat gerektiriyorsa veya bölgede izin yoğunluğu varsa bu süreler uzayabilir.</p>

<h2>Tahmini Maliyetler</h2>

<p>Lisans ve izin maliyetleri bölgeye ve işletme türüne göre önemli farklılıklar gösterir. Genel bir tahmin şöyle verilebilir:</p>

<ul>
  <li>Teknik proje hazırlığı: 2.000 - 5.000 Euro</li>
  <li>Faaliyet lisansı başvuru ücreti: 500 - 2.000 Euro</li>
  <li>Açılış lisansı: 300 - 1.500 Euro</li>
  <li>Sağlık kaydı: 100 - 500 Euro</li>
  <li>Teras lisansı (yıllık): Metrekare başına 50 - 500 Euro</li>
  <li>Danışmanlık ve avukat ücretleri: 1.000 - 3.000 Euro</li>
</ul>

<p>Toplam olarak, orta ölçekli bir restoran için lisans maliyetleri 5.000 - 15.000 Euro arasında değişebilir. Otel veya büyük konaklama tesisleri için bu rakam çok daha yüksek olabilir.</p>

<h2>Dikkat Edilmesi Gereken Noktalar</h2>

<p><strong>Mekân Seçimi:</strong> Lisans sürecine başlamadan önce seçtiğiniz mekânın planlanan faaliyet için uygun olup olmadığını kontrol edin. Bazı lokasyonlarda belirli faaliyetler (örneğin gece müziği) tamamen yasaktır.</p>

<p><strong>Bölgesel Farklılıklar:</strong> İspanya'da her Özerk Topluluk'un (Comunidad Autónoma) kendi düzenlemeleri vardır. Katalonya'daki kurallar Endülüs'ten, Madrid'dekiler Valencia'dan farklı olabilir. Yerel mevzuatı araştırın.</p>

<p><strong>Komşu İzni:</strong> Bazı belediyelerde, özellikle gürültü potansiyeli olan işletmeler için komşuların yazılı izni veya en azından bilgilendirilmesi gerekebilir.</p>

<p><strong>Devir Alım:</strong> Mevcut bir restoran veya otel devralıyorsanız, lisansların devredilebilir olup olmadığını kontrol edin. Bazı lisanslar kişiye veya şirkete özeldir ve yeni işletmeci için sıfırdan başvuru gerektirir.</p>

<p><strong>Profesyonel Destek:</strong> HoReCa lisans süreçleri karmaşık ve zaman alıcıdır. Yerel düzenlemelere hakim bir avukat veya danışmanla çalışmak, hem zaman hem de maliyet açısından büyük tasarruf sağlar.</p>

<h2>Sık Sorulan Sorular</h2>

<h3>Lisans almadan önce mekânı kiralamalı mıyım?</h3>
<p>Evet, lisans başvurusu için geçerli bir kira sözleşmesi veya mülkiyet belgesi gereklidir. Ancak kira sözleşmesine "lisans alınamama durumunda fesih" maddesi ekletmeniz önerilir.</p>

<h3>Yabancılar İspanya'da restoran veya otel açabilir mi?</h3>
<p>Evet, lisans süreçlerinde vatandaşlık kısıtlaması yoktur. Ancak İspanya'da yaşamak ve çalışmak için uygun vize veya oturum izni gereklidir.</p>

<h3>Lisanssız faaliyet göstermenin cezası nedir?</h3>
<p>Ciddi para cezaları (5.000 Euro'dan 300.000 Euro'ya kadar), işletmenin mühürlenmesi ve hatta cezai kovuşturma söz konusu olabilir.</p>

<h2>Sonuç</h2>

<p>İspanya'da restoran, kafe veya otel açmak, doğru planlama ve profesyonel destekle son derece kârlı bir yatırım olabilir. Ancak lisans ve izin süreçlerini hafife almamak gerekir. Erken aşamada doğru adımları atmak, ileride olası sorunları ve gecikmeleri önler.</p>

<p>Nova Iberian olarak, İspanya'da HoReCa sektöründe yatırım yapmak isteyen girişimcilere kapsamlı danışmanlık hizmeti sunuyoruz. Mekân seçiminden lisans başvurularına, şirket kurulumundan operasyonel süreçlere kadar her aşamada yanınızdayız.</p>

<p><strong>Ücretsiz ön değerlendirme için bizimle iletişime geçin.</strong></p>

<p><em>Bu içerik genel bilgilendirme amaçlıdır ve hukuki danışmanlık yerine geçmez. Bölgesel düzenlemeler farklılık gösterebilir; güncel bilgi için profesyonel destek almanızı öneririz.</em></p>
      `,
      en: `
<h2>HoReCa Sector in Spain</h2>
<p>Spain, with over 80 million tourists annually, is one of Europe's most popular destinations. This makes the food & beverage and hospitality sector extremely attractive. However, opening a restaurant, cafe, or hotel in Spain is subject to many more licenses, permits, and regulations than other business types.</p>

<h2>Required Licenses for Restaurants and Cafes</h2>

<h3>1. Activity License (Licencia de Actividad)</h3>
<p>This license confirms that the premises are suitable for the planned activity. Obtained from the municipality.</p>

<h3>2. Opening License (Licencia de Apertura)</h3>
<p>Official opening permit issued by the municipality after all technical requirements are met.</p>

<h3>3. Health Registration (Registro Sanitario)</h3>
<p>Food establishments must register with the local health authority. HACCP (APPCC) plan is mandatory.</p>

<h3>4. Terrace License</h3>
<p>If you want to place tables and chairs on the sidewalk or outdoor area, you need a separate terrace license.</p>

<h2>Required Licenses for Hotels</h2>

<h3>1. Tourism Registration</h3>
<p>Accommodation facilities must register with the tourism department of their Autonomous Community.</p>

<h3>2. Star Classification</h3>
<p>Hotels are rated using a star system (1 to 5). Each category has minimum standards.</p>

<h3>3. Guest Registration</h3>
<p>All accommodation facilities must record guest information and share it with police within 24 hours.</p>

<h2>Estimated Timeline and Costs</h2>
<p>The total process usually takes 3 to 6 months. License costs for a medium-sized restaurant can range from €5,000 to €15,000.</p>

<p><em>At Nova Iberian, we provide comprehensive consulting services for entrepreneurs wanting to invest in the HoReCa sector in Spain.</em></p>
      `,
      es: `
<h2>Sector HoReCa en España</h2>
<p>España, con más de 80 millones de turistas anuales, es uno de los destinos más populares de Europa. Esto hace que el sector de alimentación y hostelería sea extremadamente atractivo.</p>

<h2>Licencias Requeridas para Restaurantes y Cafeterías</h2>

<h3>1. Licencia de Actividad</h3>
<p>Esta licencia confirma que el local es adecuado para la actividad prevista. Se obtiene del Ayuntamiento.</p>

<h3>2. Licencia de Apertura</h3>
<p>Permiso oficial de apertura emitido por el municipio después de cumplir todos los requisitos técnicos.</p>

<h3>3. Registro Sanitario</h3>
<p>Los establecimientos de alimentación deben registrarse en la autoridad sanitaria local. El plan APPCC es obligatorio.</p>

<h2>Licencias Requeridas para Hoteles</h2>

<h3>1. Registro de Turismo</h3>
<p>Los establecimientos de alojamiento deben registrarse en el departamento de turismo de su Comunidad Autónoma.</p>

<h3>2. Clasificación por Estrellas</h3>
<p>Los hoteles se clasifican mediante un sistema de estrellas (1 a 5).</p>

<h2>Plazos y Costos Estimados</h2>
<p>El proceso total suele durar de 3 a 6 meses. Los costos de licencia para un restaurante mediano pueden variar entre €5.000 y €15.000.</p>

<p><em>En Nova Iberian, brindamos servicios de consultoría integral para emprendedores que desean invertir en el sector HoReCa en España.</em></p>
      `
    }
  },
  'ispanyada-sube-acmak-mi-yeni-sirket-mi': {
    id: 'ispanyada-sube-acmak-mi-yeni-sirket-mi',
    slugs: {
      tr: 'ispanyada-sube-acmak-mi-yeni-sirket-mi',
      en: 'opening-branch-spain-or-new-company',
      es: 'abrir-sucursal-espana-o-nueva-empresa'
    },
    tag: { tr: 'Şirket Kurulumu', en: 'Company Formation', es: 'Constitución de Empresa' },
    title: {
      tr: '<em>İspanya\'da Şube Açmak Mı,</em> Yeni Şirket Kurmak Mı?',
      en: '<em>Opening a Branch in Spain or</em> Establishing a New Company?',
      es: '<em>¿Abrir una Sucursal en España o</em> Establecer una Nueva Empresa?'
    },
    metaTitle: {
      tr: 'İspanya\'da Şube Açmak Mı, Yeni Şirket Kurmak Mı? Karşılaştırmalı Rehber | Nova Iberian',
      en: 'Opening a Branch in Spain or Establishing a New Company? Comparative Guide | Nova Iberian',
      es: '¿Abrir una Sucursal en España o Establecer una Nueva Empresa? Guía Comparativa | Nova Iberian'
    },
    metaDescription: {
      tr: 'İspanya\'da şube (sucursal) açmak ve yeni şirket kurmak arasındaki farklar. Vergi, sorumluluk, yönetim ve maliyet karşılaştırması.',
      en: 'Differences between opening a branch (sucursal) and establishing a new company in Spain. Comparison of tax, liability, management and costs.',
      es: 'Diferencias entre abrir una sucursal y establecer una nueva empresa en España. Comparación de impuestos, responsabilidad, gestión y costos.'
    },
    category: { tr: 'İspanya\'da Şirket Kurma', en: 'Starting a Company in Spain', es: 'Crear Empresa en España' },
    tags: ['İspanya şube açma', 'sucursal İspanya', 'İspanya\'da yabancı şirket', 'İspanya iştiraki', 'İspanya yatırım yapısı', 'İspanya ticaret sicili', 'İspanya vergi planlaması'],
    excerpt: {
      tr: 'Mevcut şirketinizi İspanya\'ya genişletirken şube mi yoksa yeni bir şirket mi kurmalısınız? Her iki seçeneğin avantaj ve dezavantajları.',
      en: 'When expanding your existing company to Spain, should you open a branch or establish a new company? Advantages and disadvantages of both options.',
      es: '¿Debería abrir una sucursal o establecer una nueva empresa al expandir su compañía a España?'
    },
    date: '2026-04-25',
    readTime: { tr: '17 dk okuma', en: '17 min read', es: '17 min lectura' },
    content: {
      tr: `
<p>Türkiye'de veya başka bir ülkede başarılı bir şirket yönetiyorsanız ve İspanya pazarına açılmayı düşünüyorsanız, önünüzde iki temel seçenek vardır: mevcut şirketinizin bir şubesini (sucursal) açmak veya tamamen yeni, bağımsız bir İspanyol şirketi kurmak. Her iki yaklaşımın da kendine özgü avantajları, dezavantajları, vergisel sonuçları ve stratejik etkileri vardır.</p>

<p>Bu rehberde, şube ve yavru şirket (iştiraki, subsidiary) arasındaki farkları detaylı olarak ele alacak, hangi durumda hangi yapının daha uygun olduğunu inceleyecek ve karar sürecinize yardımcı olacak pratik bilgiler sunacağız.</p>

<h2>Temel Kavramlar: Şube vs. Yavru Şirket</h2>

<h3>Şube (Sucursal) Nedir?</h3>

<p>Şube, ana şirketin İspanya'daki uzantısıdır. Hukuki olarak ayrı bir tüzel kişiliği yoktur; ana şirketin bir parçası olarak kabul edilir. İspanya'da faaliyet gösterir, yerel vergi yükümlülüklerine tabidir, ancak tüm hukuki sorumluluk ana şirkete aittir.</p>

<p>İspanyolcada "sucursal" olarak adlandırılan bu yapı, uluslararası şirketlerin sıklıkla kullandığı bir genişleme aracıdır.</p>

<h3>Yavru Şirket (Filial/Subsidiary) Nedir?</h3>

<p>Yavru şirket, İspanya hukuku uyarınca kurulan bağımsız bir tüzel kişiliktir. En yaygın formu SL (Sociedad Limitada) veya SA (Sociedad Anónima)'dır. Ana şirket, yavru şirketin ortağıdır (genellikle yüzde 100 pay sahibi), ancak hukuki olarak iki ayrı varlık söz konusudur.</p>

<p>İspanyolcada "filial" veya "sociedad participada" olarak adlandırılır. Türkçede "iştiraki" veya "bağlı şirket" terimleri de kullanılır.</p>

<h2>Şube (Sucursal) Açmanın Avantajları</h2>

<p><strong>1. Asgari Sermaye Gereksinimi Yok:</strong> SL kurmak için minimum 3.000 Euro sermaye gerekir. Şube açmak için böyle bir zorunluluk yoktur. Bu, başlangıç maliyetlerini önemli ölçüde düşürür.</p>

<p><strong>2. Daha Basit Kuruluş Süreci:</strong> Şube açmak, yeni şirket kurmaktan genellikle daha hızlı ve daha az bürokratiktir. Ancak ana şirket belgelerinin apostilli ve yeminli tercümeli olarak sunulması gerekir.</p>

<p><strong>3. Merkezi Kontrol:</strong> Şube, ana şirketin doğrudan kontrolü altındadır. Ayrı bir yönetim kurulu veya ortaklar toplantısı düzenlemeye gerek yoktur. Stratejik kararlar merkezi olarak alınır ve şube bunları uygular.</p>

<p><strong>4. Kar ve Zarar Konsolidasyonu:</strong> Şubenin gelir ve giderleri doğrudan ana şirketin mali tablolarına yansır. Bu, bazı durumlarda vergi planlaması açısından avantaj sağlayabilir; özellikle şube zarar ederken ana şirket kârlıysa, zararlar ana şirket düzeyinde mahsup edilebilir.</p>

<p><strong>5. Marka ve Kimlik Bütünlüğü:</strong> Şube, ana şirketin doğrudan temsilcisi olarak faaliyet gösterir. Kurumsal kimlik, itibar ve marka değeri doğrudan aktarılır.</p>

<h2>Şube (Sucursal) Açmanın Dezavantajları</h2>

<p><strong>1. Sınırsız Sorumluluk:</strong> Şubenin borçları, yükümlülükleri veya hukuki sorunları doğrudan ana şirkete yansır. Ana şirket, şubenin tüm borçlarından sınırsız olarak sorumludur. Bu, özellikle riskli sektörlerde ciddi bir dezavantajdır.</p>

<p><strong>2. Karmaşık Vergi Durumu:</strong> Şube, İspanya'da elde ettiği gelirler üzerinden İspanya kurumlar vergisine tabidir. Aynı zamanda ana şirketin bulunduğu ülkede de vergi yükümlülüğü doğabilir. Çifte vergilendirme anlaşmaları bu durumu düzenler, ancak vergi planlaması karmaşıklaşır.</p>

<p><strong>3. Belge ve Tercüme Yükü:</strong> Şube kuruluşu için ana şirketin kuruluş belgeleri, ana sözleşmesi, yönetim kurulu kararları ve yetkilendirmeleri apostilli ve yeminli tercümeli olarak İspanya'ya sunulmalıdır. Bu belgeler periyodik olarak güncellenmelidir.</p>

<p><strong>4. Yerel Algı:</strong> Bazı İspanyol müşteriler, tedarikçiler veya iş ortakları, şube yerine yerel bir şirketle çalışmayı tercih edebilir. Şube, "yabancı" algısını daha güçlü şekilde taşır.</p>

<p><strong>5. Finansman Zorlukları:</strong> Şubenin İspanya'da bağımsız olarak kredi veya finansman bulması daha zordur. Bankalar genellikle ana şirketin garantisini ister.</p>

<h2>Yeni Şirket (SL) Kurmanın Avantajları</h2>

<p><strong>1. Sınırlı Sorumluluk:</strong> Yavru şirket, ana şirketten hukuki olarak ayrı bir tüzel kişiliktir. Ana şirket, yavru şirketin borçlarından yalnızca koyduğu sermaye kadar sorumludur. Kişisel varlıklar ve ana şirket varlıkları korunur.</p>

<p><strong>2. Yerel Kimlik ve Güvenilirlik:</strong> "İspanyol şirketi" kimliği, yerel pazarda güven oluşturur. Müşteriler, tedarikçiler ve devlet kurumları nezdinde daha kabul gören bir yapıdır.</p>

<p><strong>3. Vergi Optimizasyonu:</strong> İspanya'da kurulan şirketler, İspanya vergi sisteminin sunduğu tüm avantajlardan yararlanabilir. Yeni kurulan şirketler için ilk 2 yıl yüzde 15 indirimli kurumlar vergisi, startup statüsü kapsamında ek avantajlar, çeşitli teşvik ve indirimler mevcuttur.</p>

<p><strong>4. Bağımsız Finansman:</strong> Yavru şirket, kendi adına banka hesabı açabilir, kredi kullanabilir, yatırımcı çekebilir. Bu, büyüme ve genişleme için önemli bir esneklik sağlar.</p>

<p><strong>5. Yerel Ortaklık İmkanı:</strong> İspanyol ortaklar veya yatırımcılar almak isterseniz, yavru şirket yapısı buna çok daha uygundur. Şube yapısında yerel ortaklık mümkün değildir.</p>

<p><strong>6. Esnek Kâr Dağıtımı:</strong> Yavru şirketin kârı İspanya'da tutulabilir, yeniden yatırıma yönlendirilebilir veya ana şirkete kâr payı olarak aktarılabilir. Bu, nakit akışı yönetimi için esneklik sağlar.</p>

<h2>Yeni Şirket (SL) Kurmanın Dezavantajları</h2>

<p><strong>1. Daha Yüksek Kuruluş Maliyeti:</strong> Minimum 3.000 Euro sermaye, noter ücretleri, ticaret sicili harçları, avukat masrafları dahil toplam kuruluş maliyeti 2.000-4.000 Euro arasında değişir.</p>

<p><strong>2. Daha Uzun Kuruluş Süreci:</strong> Şirket adı onayı, banka hesabı açma, noter işlemleri ve ticaret sicili tescili dahil süreç genellikle 4-6 hafta sürer.</p>

<p><strong>3. Ayrı Muhasebe ve Yönetim:</strong> Yavru şirket, bağımsız mali tablolar hazırlamak, yıllık hesap sunumu yapmak ve ayrı muhasebe kayıtları tutmak zorundadır. Bu, ek muhasebe maliyeti ve yönetim yükü getirir.</p>

<p><strong>4. Çifte Vergilendirme Riski:</strong> Yavru şirket kârı önce İspanya'da kurumlar vergisine tabi olur, ardından ana şirkete dağıtılan kâr payı üzerinden ek vergi ödenebilir. Çifte vergilendirme anlaşmaları ve AB direktifleri bu yükü azaltır, ancak planlama gerektirir.</p>

<h2>Vergisel Karşılaştırma</h2>

<h3>Şube Vergilendirmesi</h3>

<p>Şube, İspanya'da elde ettiği kârlar üzerinden yüzde 25 oranında İspanya kurumlar vergisine tabidir. Ayrıca, kârların ana şirkete transferinde "branch tax" (şube vergisi) uygulanabilir, ancak Türkiye-İspanya çifte vergilendirme anlaşması bu vergiyi genellikle ortadan kaldırır veya sınırlar.</p>

<p>Şube zararları, çifte vergilendirme anlaşmasının izin verdiği ölçüde, ana şirket kârından mahsup edilebilir. Bu, özellikle yeni pazara giriş döneminde önemli bir avantaj olabilir.</p>

<h3>Yavru Şirket Vergilendirmesi</h3>

<p>Yavru şirket, İspanya kurumlar vergisine (yüzde 25, yeni şirketler için ilk 2 yıl yüzde 15) tabidir. Kâr payı dağıtımında, AB Ana Şirket-Yavru Şirket Direktifi kapsamında stopaj vergisi genellikle sıfırlanır veya minimize edilir.</p>

<p>AB üyesi olmayan ülkelerdeki (Türkiye gibi) ana şirketlere yapılan kâr payı ödemelerinde, çifte vergilendirme anlaşmasına göre stopaj uygulanabilir. Türkiye-İspanya anlaşması kapsamında bu oran genellikle yüzde 15 ile sınırlıdır.</p>

<h2>Hangi Durumda Şube Tercih Edilmeli?</h2>

<ul>
  <li>İspanya pazarını test etmek istiyorsanız ve uzun vadeli planlarınız belirsizse</li>
  <li>Kısa vadeli veya proje bazlı faaliyet planlıyorsanız</li>
  <li>Ana şirketle tam operasyonel entegrasyon önemliyse</li>
  <li>Başlangıç sermayesini minimize etmek istiyorsanız</li>
  <li>Şube zararlarını ana şirket kârından mahsup etmek stratejik açıdan önemliyse</li>
  <li>İspanya'da yerel ortaklık planlamıyorsanız</li>
</ul>

<h2>Hangi Durumda Yavru Şirket Tercih Edilmeli?</h2>

<ul>
  <li>İspanya'da kalıcı ve büyüyen bir varlık oluşturmak istiyorsanız</li>
  <li>Sorumluluk riskini sınırlamak öncelikliyse</li>
  <li>Yerel ortaklar, yatırımcılar veya çalışan pay sahipliği planlanıyorsa</li>
  <li>İspanya vergi avantajlarından tam olarak yararlanmak istiyorsanız</li>
  <li>Yerel finansman ve bankacılık ilişkileri önemliyse</li>
  <li>Müşteriler ve iş ortakları nezdinde "yerel şirket" algısı kritikse</li>
</ul>

<h2>Pratik Bir Karar Matrisi</h2>

<div class="blog-stats-box">
  <div class="stat-item"><span class="stat-number">Şube</span><span class="stat-label">Pazar testi | Düşük başlangıç maliyeti | Geçici projeler | Merkezi kontrol</span></div>
  <div class="stat-item"><span class="stat-number">Yeni SL</span><span class="stat-label">Kalıcı varlık | Sınırlı sorumluluk | Yerel ortaklık | Vergi optimizasyonu</span></div>
</div>

<h2>Karma Yaklaşım: Önce Şube, Sonra Şirket</h2>

<p>Bazı şirketler, İspanya pazarına önce şube ile giriş yapar, pazarı test eder ve başarılı olduklarında şubeyi kapatıp yerel bir yavru şirket kurar. Bu yaklaşım, başlangıç riskini azaltır ve pazar koşullarını anladıktan sonra daha kalıcı bir yapıya geçişi mümkün kılar.</p>

<p>Ancak bu dönüşüm sürecinde dikkatli planlama gerekir. Şube faaliyetlerinin, müşteri sözleşmelerinin, çalışanların ve varlıkların yeni şirkete aktarılması özel prosedürler gerektirir.</p>

<h2>Temsilcilik Ofisi (Oficina de Representación) Alternatifi</h2>

<p>Eğer İspanya'da doğrudan ticari faaliyet yapmayacak, sadece pazar araştırması, tanıtım, iş geliştirme veya irtibat faaliyetleri yürütecekseniz, temsilcilik ofisi üçüncü bir alternatif olabilir.</p>

<p>Temsilcilik ofisi, gelir getirici faaliyet yapamaz, fatura kesemez ve doğrudan satış gerçekleştiremez. Ancak kuruluşu çok daha basit ve maliyetler minimumdur. Pazar araştırması aşamasında tercih edilebilir.</p>

<h2>Kuruluş Süreci Karşılaştırması</h2>

<h3>Şube Kuruluş Adımları</h3>

<ol>
  <li>Ana şirket yönetim kurulunun şube açma kararı</li>
  <li>Ana şirket belgelerinin apostillenmesi ve yeminli tercümesi</li>
  <li>Şube temsilcisinin atanması ve vekaletname düzenlenmesi</li>
  <li>İspanya'da noter işlemleri</li>
  <li>Ticaret Sicili'ne tescil</li>
  <li>CIF (vergi kimlik numarası) alınması</li>
</ol>

<p>Tahmini süre: 3-5 hafta. Tahmini maliyet: 1.500-3.000 Euro.</p>

<h3>Yavru Şirket (SL) Kuruluş Adımları</h3>

<ol>
  <li>Şirket adı onayı (Certificación Negativa)</li>
  <li>Banka hesabı açılması ve sermaye yatırılması</li>
  <li>Ana sözleşme hazırlığı</li>
  <li>Noter işlemleri (Escritura de Constitución)</li>
  <li>CIF başvurusu</li>
  <li>Ticaret Sicili tescili</li>
</ol>

<p>Tahmini süre: 4-6 hafta. Tahmini maliyet: 2.000-4.000 Euro (3.000 Euro sermaye hariç).</p>

<h2>Sonuç</h2>

<p>Şube ve yavru şirket arasındaki seçim, stratejik hedeflerinize, risk toleransınıza, vergi planlamanıza ve İspanya'daki uzun vadeli vizyonunuza bağlıdır. Her iki yapının da belirgin avantajları ve dezavantajları vardır; "doğru" seçim, sizin özgün koşullarınıza göre değişir.</p>

<p>Genel olarak, kısa vadeli veya test amaçlı girişimler için şube, kalıcı ve büyüme odaklı yatırımlar için yavru şirket (SL) daha uygun olma eğilimindedir. Ancak her durum benzersizdir ve profesyonel danışmanlık almak, maliyetli hatalardan kaçınmanızı sağlar.</p>

<p>Nova Iberian olarak, Türk şirketlerinin İspanya'ya açılmasında her iki yapı için de kapsamlı danışmanlık hizmeti sunuyoruz. Stratejik analiz, vergi planlaması, kuruluş süreçleri ve operasyonel yönetim konularında uzman ekibimizle yanınızdayız.</p>

<p><strong>İspanya'da şube mi açmalısınız, şirket mi kurmalısınız? Ücretsiz ön değerlendirme için bizimle iletişime geçin.</strong></p>

<p><em>Bu içerik genel bilgilendirme amaçlıdır ve hukuki veya vergisel danışmanlık yerine geçmez. Kişiye özel değerlendirme için profesyonel destek almanızı öneririz.</em></p>
      `,
      en: `
<h2>Branch vs. Subsidiary: Basic Concepts</h2>

<h3>What is a Branch (Sucursal)?</h3>
<p>A branch is an extension of the parent company in Spain. It has no separate legal personality; it is considered part of the parent company. It operates in Spain and is subject to local tax obligations, but all legal responsibility belongs to the parent company.</p>

<h3>What is a Subsidiary (Filial)?</h3>
<p>A subsidiary is an independent legal entity established under Spanish law. The most common forms are SL (Sociedad Limitada) or SA (Sociedad Anónima). The parent company is a shareholder (usually 100%) but they are legally separate entities.</p>

<h2>Advantages of Opening a Branch</h2>
<ul>
  <li>No minimum capital requirement</li>
  <li>Simpler establishment process</li>
  <li>Centralized control</li>
  <li>Profit and loss consolidation</li>
</ul>

<h2>Advantages of Establishing a Subsidiary</h2>
<ul>
  <li>Limited liability</li>
  <li>Local identity and credibility</li>
  <li>Tax optimization opportunities</li>
  <li>Independent financing</li>
  <li>Local partnership possibilities</li>
</ul>

<h2>Decision Matrix</h2>
<ul>
  <li><strong>Choose Branch:</strong> Market testing, low initial cost, temporary projects, centralized control</li>
  <li><strong>Choose Subsidiary:</strong> Permanent presence, limited liability, local partnerships, tax optimization</li>
</ul>

<p><em>At Nova Iberian, we help determine the most suitable structure for your company's expansion to Spain.</em></p>
      `,
      es: `
<h2>Sucursal vs. Filial: Conceptos Básicos</h2>

<h3>¿Qué es una Sucursal?</h3>
<p>Una sucursal es una extensión de la empresa matriz en España. No tiene personalidad jurídica propia; se considera parte de la empresa matriz.</p>

<h3>¿Qué es una Filial?</h3>
<p>Una filial es una entidad legal independiente establecida bajo la ley española. Las formas más comunes son SL (Sociedad Limitada) o SA (Sociedad Anónima).</p>

<h2>Ventajas de Abrir una Sucursal</h2>
<ul>
  <li>Sin requisito de capital mínimo</li>
  <li>Proceso de establecimiento más simple</li>
  <li>Control centralizado</li>
  <li>Consolidación de pérdidas y ganancias</li>
</ul>

<h2>Ventajas de Establecer una Filial</h2>
<ul>
  <li>Responsabilidad limitada</li>
  <li>Identidad local y credibilidad</li>
  <li>Oportunidades de optimización fiscal</li>
  <li>Financiación independiente</li>
</ul>

<h2>Matriz de Decisión</h2>
<ul>
  <li><strong>Elija Sucursal:</strong> Prueba de mercado, bajo costo inicial, proyectos temporales</li>
  <li><strong>Elija Filial:</strong> Presencia permanente, responsabilidad limitada, socios locales</li>
</ul>

<p><em>En Nova Iberian, le ayudamos a determinar la estructura más adecuada para la expansión de su empresa a España.</em></p>
      `
    }
  },
  'ees-sistemi-nedir': {
    id: 'ees-sistemi-nedir',
    slugs: {
      tr: 'ees-sistemi-nedir',
      en: 'what-is-ees-system',
      es: 'que-es-sistema-ees'
    },
    tag: { tr: 'Seyahat', en: 'Travel', es: 'Viaje' },
    title: {
      tr: '<em>EES</em> Nedir? Avrupa\'nın Yeni Giriş/Çıkış Sistemi Hakkında Bilmeniz Gereken Her Şey',
      en: 'What is <em>EES</em>? Everything You Need to Know About Europe\'s New Entry/Exit System',
      es: '¿Qué es el <em>EES</em>? Todo lo que Necesitas Saber sobre el Nuevo Sistema de Entrada/Salida de Europa'
    },
    excerpt: {
      tr: 'Avrupa Birliği\'nin yeni EES sistemi pasaport damgalarını tarihe karıştırdı. Türk vatandaşları için neler değişti?',
      en: 'The EU\'s new EES system has made passport stamps history. What has changed for travelers?',
      es: 'El nuevo sistema EES de la UE ha convertido los sellos de pasaporte en historia. ¿Qué ha cambiado para los viajeros?'
    },
    date: '2026-05-20',
    readTime: { tr: '5 dk okuma', en: '5 min read', es: '5 min lectura' },
    content: {
      tr: `
<h2><em>EES Sistemi</em> Nedir ve Neden Getirildi?</h2>
<p>Avrupa Birliği, sınır yönetiminde köklü bir dönüşüm başlattı. <strong>12 Ekim 2025</strong>'te kademeli olarak devreye giren ve <strong>10 Nisan 2026</strong> itibarıyla tüm Schengen sınır noktalarında tam olarak faaliyete geçen <strong>EES (Entry/Exit System – Giriş/Çıkış Sistemi)</strong>, pasaporta damga vurma uygulamasını tarihe karıştırdı.</p>

<p>EES, AB vatandaşı olmayan ve Schengen Bölgesi'ne kısa süreli seyahat eden kişilerin giriş ve çıkışlarını dijital ortamda kaydeden merkezi bir bilgi teknolojisi sistemidir. Onlarca yıldır kullanılan pasaport damgalama yöntemi, sahteciliğe açık olması, damgaların zamanla silinmesi ve manuel takibin zorluğu gibi nedenlerle yetersiz kalıyordu.</p>

<h2>Sistemin Temel Hedefleri</h2>
<ul>
  <li><strong>Sınır güvenliğinin güçlendirilmesi</strong></li>
  <li><strong>Düzensiz göçün önlenmesi</strong></li>
  <li><strong>Kimlik sahteciliğinin tespit edilmesi</strong></li>
  <li><strong>Yasal kalış süresini aşan kişilerin belirlenmesi</strong></li>
</ul>

<p>AB Komisyonu verilerine göre, sistemin kademeli kullanıma açıldığı Ekim 2025'ten bu yana <em>45 milyondan fazla</em> sınır geçişi kayıt altına alındı. Aynı dönemde <em>24.000'den fazla</em> kişinin girişi reddedildi.</p>

<h2>EES Nasıl Çalışır? Sınırda Sizi Neler Bekliyor?</h2>
<p>Schengen Bölgesi'ne ilk kez giriş yapan AB dışı vatandaşlar, sınır noktasındaki self-servis kiosklar veya sınır kontrol kabinlerinde tam bir kayıt sürecinden geçiyor:</p>

<ol>
  <li><strong>Yolcunun adı ve pasaport bilgileri</strong> kaydediliyor</li>
  <li><strong>Parmak izi</strong> alınıyor</li>
  <li><strong>Yüz görüntüsü</strong> kaydediliyor</li>
  <li><strong>Giriş ve çıkış tarihi ile yeri</strong> dijital olarak işleniyor</li>
</ol>

<p>İlk kayıt tamamlandıktan sonra, sonraki seyahatlerde süreç çok daha hızlı ilerliyor. Veriler, <strong>üç yıl</strong> boyunca sistemde saklanıyor.</p>

<h2>90/180 Gün Kuralı Otomatik Takibi</h2>
<p>Sistem ayrıca <strong>90/180 gün kuralını</strong> otomatik olarak hesaplıyor. Schengen Bölgesi'nde her 180 günlük dönem içinde en fazla 90 gün kalma hakkına sahip olan yolcuların kalan süreleri artık dijital ortamda takip ediliyor.</p>

<h2>EES Hangi Ülkelerde Geçerli?</h2>
<p>EES, tüm Schengen üye devletleri ve Schengen ile ilişkili ülkelerde uygulanıyor. Toplam <strong>29 Avrupa ülkesi</strong> kapsamında:</p>

<ul>
  <li>Almanya, Fransa, İtalya, İspanya</li>
  <li>Hollanda, Yunanistan, Portekiz, Avusturya</li>
  <li>Belçika, İsveç, Finlandiya, Danimarka</li>
  <li>Norveç, İsviçre, İzlanda, Lihtenştayn</li>
</ul>

<p><em>Not: İrlanda ve Güney Kıbrıs EES kapsamı dışındadır.</em></p>

<h2>EES Türk Vatandaşlarını Nasıl Etkiliyor?</h2>
<p>Türkiye'den Avrupa'ya seyahat edenler için EES <strong>doğrudan geçerli</strong>. Bordo (umuma mahsus) pasaport sahipleri Schengen vizesiyle seyahat etmeye devam ediyor ve bu vizeli yolcular da sınır geçişlerinde EES kaydına tabi tutuluyor.</p>

<p><strong>Artık pasaport damgası yok;</strong> yerine parmak izi ve yüz görüntüsü kaydı yapılıyor.</p>

<h2>EES ve ETIAS Farkı</h2>
<p>EES ile sıklıkla karıştırılan <strong>ETIAS</strong> (Avrupa Seyahat Bilgi ve Yetkilendirme Sistemi) ise Türk vatandaşlarını doğrudan <em>etkilemiyor</em>. ETIAS, yalnızca vizeden muaf ülke vatandaşları için bir seyahat ön izni mekanizmasıdır. Türkiye vizeden muaf bir ülke olmadığından, bordo pasaport sahiplerinin ETIAS başvurusu yapmasına <strong>gerek bulunmuyor</strong>.</p>

<h2>Hazırlık İçin Dikkat Edilmesi Gerekenler</h2>
<ul>
  <li><strong>Pasaport geçerliliği:</strong> Seyahat tarihlerini ve planlanan kalış süresini kapsamalı</li>
  <li><strong>Pasaport fotoğrafı:</strong> Güncel ve biyometrik standartlara uygun olmalı</li>
  <li><strong>Seyahat sigortası:</strong> Yeterli kapsamda bulunmalı</li>
  <li><strong>Travel to Europe uygulaması:</strong> Pasaport bilgilerinizi seyahatten 72 saat önce ön kayıt yaptırabilirsiniz</li>
</ul>

<h2>Seyahat Öncesi Yapmanız Gerekenler</h2>
<p>İlk seyahatinizde sınır geçişinin normalden biraz daha uzun sürebileceğini göz önünde bulundurarak havalimanında <strong>ekstra zaman</strong> ayırmanız faydalı olacaktır. Ancak bir kez kayıt yaptırdıktan sonra, <strong>üç yıl boyunca</strong> veya pasaportunuz yenilenene kadar sonraki geçişleriniz çok daha hızlı gerçekleşecektir.</p>

<p><em>Bu yazı Mayıs 2026 itibarıyla güncel bilgiler içermektedir.</em></p>
      `,
      en: `
<h2>What is the <em>EES System</em> and Why Was It Introduced?</h2>
<p>The European Union has launched a fundamental transformation in border management. The <strong>EES (Entry/Exit System)</strong>, which was gradually rolled out on <strong>October 12, 2025</strong> and became fully operational at all Schengen border points as of <strong>April 10, 2026</strong>, has made passport stamping a thing of the past.</p>

<p>EES is a centralized information technology system that digitally records the entry and exit of non-EU citizens traveling to the Schengen Area for short stays. The passport stamping method used for decades was inadequate due to its vulnerability to forgery, stamps fading over time, and difficulty in manual tracking.</p>

<h2>Main Objectives of the System</h2>
<ul>
  <li><strong>Strengthening border security</strong></li>
  <li><strong>Preventing irregular migration</strong></li>
  <li><strong>Detecting identity fraud</strong></li>
  <li><strong>Identifying overstayers</strong></li>
</ul>

<p>According to EU Commission data, more than <em>45 million</em> border crossings have been recorded since the system's gradual rollout in October 2025. During the same period, more than <em>24,000</em> people were refused entry.</p>

<h2>How Does EES Work? What to Expect at the Border?</h2>
<p>Non-EU citizens entering the Schengen Area for the first time undergo a full registration process at self-service kiosks or border control booths:</p>

<ol>
  <li><strong>Traveler's name and passport details</strong> are recorded</li>
  <li><strong>Fingerprints</strong> are taken</li>
  <li><strong>Facial image</strong> is captured</li>
  <li><strong>Entry and exit date and location</strong> are digitally processed</li>
</ol>

<p>Once the initial registration is complete, subsequent travels are much faster. Data is stored in the system for <strong>three years</strong>.</p>

<h2>Automatic 90/180 Day Rule Tracking</h2>
<p>The system also automatically calculates the <strong>90/180 day rule</strong>. Travelers' remaining days in the Schengen Area (maximum 90 days within any 180-day period) are now tracked digitally.</p>

<h2>Where is EES Valid?</h2>
<p>EES applies to all Schengen member states and Schengen-associated countries. A total of <strong>29 European countries</strong> are covered:</p>

<ul>
  <li>Germany, France, Italy, Spain</li>
  <li>Netherlands, Greece, Portugal, Austria</li>
  <li>Belgium, Sweden, Finland, Denmark</li>
  <li>Norway, Switzerland, Iceland, Liechtenstein</li>
</ul>

<p><em>Note: Ireland and Cyprus are outside the EES scope.</em></p>

<h2>How Does EES Affect Turkish Citizens?</h2>
<p>EES <strong>directly applies</strong> to travelers from Turkey to Europe. Regular (burgundy) passport holders continue to travel with a Schengen visa, and these visa holders are also subject to EES registration at border crossings.</p>

<p><strong>No more passport stamps;</strong> instead, fingerprints and facial images are recorded.</p>

<h2>EES vs ETIAS: What's the Difference?</h2>
<p><strong>ETIAS</strong> (European Travel Information and Authorization System), often confused with EES, does <em>not directly affect</em> Turkish citizens. ETIAS is a pre-travel authorization mechanism only for citizens of visa-exempt countries. Since Turkey is not visa-exempt, burgundy passport holders <strong>do not need</strong> to apply for ETIAS.</p>

<h2>Preparation Checklist</h2>
<ul>
  <li><strong>Passport validity:</strong> Should cover travel dates and planned stay</li>
  <li><strong>Passport photo:</strong> Must be current and meet biometric standards</li>
  <li><strong>Travel insurance:</strong> Should have adequate coverage</li>
  <li><strong>Travel to Europe app:</strong> You can pre-register your passport details up to 72 hours before travel</li>
</ul>

<h2>What to Do Before Your Trip</h2>
<p>For your first trip, allow <strong>extra time</strong> at the airport as border crossing may take slightly longer than usual. However, once you've registered, subsequent crossings will be much faster for <strong>three years</strong> or until your passport is renewed.</p>

<p><em>This article contains current information as of May 2026.</em></p>
      `,
      es: `
<h2>¿Qué es el <em>Sistema EES</em> y Por Qué Se Introdujo?</h2>
<p>La Unión Europea ha lanzado una transformación fundamental en la gestión de fronteras. El <strong>EES (Entry/Exit System – Sistema de Entrada/Salida)</strong>, que se implementó gradualmente el <strong>12 de octubre de 2025</strong> y se puso en pleno funcionamiento en todos los puntos fronterizos Schengen a partir del <strong>10 de abril de 2026</strong>, ha dejado obsoleto el sellado de pasaportes.</p>

<p>EES es un sistema centralizado de tecnología de la información que registra digitalmente la entrada y salida de ciudadanos no comunitarios que viajan a la Zona Schengen para estancias cortas.</p>

<h2>Objetivos Principales del Sistema</h2>
<ul>
  <li><strong>Fortalecer la seguridad fronteriza</strong></li>
  <li><strong>Prevenir la migración irregular</strong></li>
  <li><strong>Detectar fraude de identidad</strong></li>
  <li><strong>Identificar personas que exceden su estancia</strong></li>
</ul>

<p>Según datos de la Comisión Europea, se han registrado más de <em>45 millones</em> de cruces fronterizos desde la implementación gradual del sistema en octubre de 2025. Durante el mismo período, se rechazó la entrada a más de <em>24.000</em> personas.</p>

<h2>¿Cómo Funciona EES? ¿Qué Esperar en la Frontera?</h2>
<p>Los ciudadanos no comunitarios que ingresan por primera vez a la Zona Schengen pasan por un proceso de registro completo en quioscos de autoservicio o cabinas de control fronterizo:</p>

<ol>
  <li>Se registran el <strong>nombre y datos del pasaporte</strong> del viajero</li>
  <li>Se toman las <strong>huellas dactilares</strong></li>
  <li>Se captura la <strong>imagen facial</strong></li>
  <li>La <strong>fecha y lugar de entrada y salida</strong> se procesan digitalmente</li>
</ol>

<p>Una vez completado el registro inicial, los viajes posteriores son mucho más rápidos. Los datos se almacenan en el sistema durante <strong>tres años</strong>.</p>

<h2>Seguimiento Automático de la Regla 90/180 Días</h2>
<p>El sistema también calcula automáticamente la <strong>regla de 90/180 días</strong>. Los días restantes de los viajeros en la Zona Schengen (máximo 90 días dentro de cualquier período de 180 días) ahora se rastrean digitalmente.</p>

<h2>¿Dónde es Válido el EES?</h2>
<p>EES se aplica a todos los estados miembros de Schengen y países asociados. En total, <strong>29 países europeos</strong> están cubiertos:</p>

<ul>
  <li>Alemania, Francia, Italia, España</li>
  <li>Países Bajos, Grecia, Portugal, Austria</li>
  <li>Bélgica, Suecia, Finlandia, Dinamarca</li>
  <li>Noruega, Suiza, Islandia, Liechtenstein</li>
</ul>

<p><em>Nota: Irlanda y Chipre están fuera del alcance del EES.</em></p>

<h2>¿Cómo Afecta el EES a los Ciudadanos Turcos?</h2>
<p>El EES se <strong>aplica directamente</strong> a los viajeros de Turquía a Europa. Los titulares de pasaportes regulares (burdeos) continúan viajando con visa Schengen, y estos titulares de visa también están sujetos al registro EES en los cruces fronterizos.</p>

<p><strong>Ya no hay sellos de pasaporte;</strong> en su lugar, se registran huellas dactilares e imágenes faciales.</p>

<h2>EES vs ETIAS: ¿Cuál es la Diferencia?</h2>
<p>El <strong>ETIAS</strong> (Sistema Europeo de Información y Autorización de Viajes), a menudo confundido con EES, <em>no afecta directamente</em> a los ciudadanos turcos. ETIAS es un mecanismo de autorización de viaje previo solo para ciudadanos de países exentos de visa. Como Turquía no está exenta de visa, los titulares de pasaportes burdeos <strong>no necesitan</strong> solicitar ETIAS.</p>

<h2>Lista de Preparación</h2>
<ul>
  <li><strong>Validez del pasaporte:</strong> Debe cubrir las fechas de viaje y la estancia planificada</li>
  <li><strong>Foto del pasaporte:</strong> Debe ser actual y cumplir con los estándares biométricos</li>
  <li><strong>Seguro de viaje:</strong> Debe tener cobertura adecuada</li>
  <li><strong>App Travel to Europe:</strong> Puede prerregistrar los datos de su pasaporte hasta 72 horas antes del viaje</li>
</ul>

<h2>Qué Hacer Antes de su Viaje</h2>
<p>Para su primer viaje, reserve <strong>tiempo extra</strong> en el aeropuerto ya que el cruce fronterizo puede tomar un poco más de lo habitual. Sin embargo, una vez que se haya registrado, los cruces posteriores serán mucho más rápidos durante <strong>tres años</strong> o hasta que se renueve su pasaporte.</p>

<p><em>Este artículo contiene información actualizada a mayo de 2026.</em></p>
      `
    }
  },
  'ispanya-egitim-sistemi': {
    id: 'ispanya-egitim-sistemi',
    slugs: {
      tr: 'ispanya-egitim-sistemi',
      en: 'spain-education-system-guide',
      es: 'sistema-educativo-espana-guia'
    },
    tag: { tr: 'Yaşam', en: 'Living', es: 'Vida' },
    title: {
      tr: 'İspanya\'ya Taşınan Ailelerin En Çok Sorduğu Konu: <em>Eğitim Sistemi</em>',
      en: 'The Most Asked Question by Families Moving to Spain: <em>Education System</em>',
      es: 'La Pregunta Más Frecuente de las Familias que se Mudan a España: <em>Sistema Educativo</em>'
    },
    excerpt: {
      tr: 'Okul türleri, şehir seçimi, kayıt süreci ve çocuklu yaşam. İspanya eğitim sisteminin tüm detayları.',
      en: 'School types, city selection, enrollment process and family life. All details of the Spanish education system.',
      es: 'Tipos de escuelas, selección de ciudad, proceso de inscripción y vida familiar. Todos los detalles del sistema educativo español.'
    },
    date: '2026-05-23',
    readTime: { tr: '8 dk okuma', en: '8 min read', es: '8 min lectura' },
    content: {
      tr: `
<h2>İspanya'da Çocuk Yetiştirmek Neden Farklı Hissettiriyor?</h2>
<p>İspanya'ya taşınmayı düşünen ailelerin bize en sık sorduğu konu genellikle oturum izni değil, <strong>eğitim sistemi</strong> oluyor. Ama konuşmalar ilerledikçe mesele çoğu zaman okulun ötesine geçiyor:</p>

<ul>
  <li>Çocuk hangi dilde büyüyecek?</li>
  <li>Günlük hayat nasıl hissedilecek?</li>
  <li>Mahalle kültürü nasıl?</li>
  <li>Kendi başına yürüyerek eve dönebilecek mi?</li>
  <li>Okuldan sonra nasıl bir sosyal hayatı olacak?</li>
</ul>

<p>İspanya'daki eğitim sistemi Türkiye'de alışılan daha sınav odaklı yapıdan farklı olarak, burada <strong>sosyal gelişim</strong>, iletişim becerileri, grup çalışmaları ve günlük yaşamla kurulan ilişki eğitim sürecinin doğal bir parçası gibi ilerliyor.</p>

<p><em>"Burada çocuklar biraz daha çocuk gibi büyüyor."</em> - Türkiye'den gelen aileler</p>

<h2>İspanya Eğitim Sistemi Nasıl İşliyor?</h2>
<p>İspanya'da zorunlu eğitim <strong>6–16 yaş</strong> arasında ücretsiz ilerliyor. Sistem genel olarak Avrupa Birliği standartlarına oldukça uyumlu.</p>

<h3>Educación Infantil (0–6 Yaş)</h3>
<p>Bu dönem okul öncesi eğitim süreci. 0-3 yaş arası özel kreşler, 3–6 yaş arasında devlet destekli ücretsiz okul öncesi seçenekleri bulunuyor. Zorunlu değil ama çoğu aile çocuklarını erken yaşta sisteme dahil ediyor.</p>

<ul>
  <li>Oyun temelli öğrenme</li>
  <li>Sosyal iletişim ve grup ilişkileri</li>
  <li>Yaratıcılık, hareket ve keşif</li>
</ul>

<h3>Educación Primaria (6-12 Yaş)</h3>
<p>İlkokul süreci 6 yıl sürüyor. Matematik, fen, sosyal bilimler, sanat, spor ve yabancı dil temel alanlar.</p>

<p>Örneğin Barcelona'da çocuklar çoğu zaman <strong>İspanyolca, Katalanca ve İngilizce</strong> üçlüsüyle büyüyor.</p>

<h3>ESO (12-16 Yaş) - Zorunlu Ortaöğretim</h3>
<p>Türkiye'deki sistemden farklı olarak yalnızca sınav başarısı değil:</p>
<ul>
  <li>Proje üretimi</li>
  <li>Grup çalışmaları</li>
  <li>İletişim becerileri</li>
  <li>Araştırma odaklı ödevler</li>
</ul>

<h3>Bachillerato (16–18 Yaş)</h3>
<p>Üniversite hazırlık süreci. Öğrenciler fen, sosyal bilimler, sanat veya teknoloji alanlarına yöneliyor. İspanya diplomaları <strong>AB içinde geniş ölçüde tanınıyor</strong>.</p>

<h2>Devlet Okulu mu Özel Okul mu?</h2>
<p>İspanya'da üç ana okul modeli bulunuyor:</p>

<h3>Devlet Okulları (Colegio Público)</h3>
<ul>
  <li>Ücretsiz eğitim</li>
  <li>Yabancı öğrenciler için dil destek sınıfları</li>
  <li>Yerel yaşamla hızlı bağ kurma imkanı</li>
</ul>
<p><em>Not: Okul kalitesi bölgeden bölgeye değişebiliyor.</em></p>

<h3>Concertado Okullar (Yarı Özel)</h3>
<ul>
  <li>Devlet destekli, özel yönetimli hibrit yapı</li>
  <li>Daha erişilebilir ücretler</li>
  <li>Düzenli akademik yapı ve kontrollü sosyal ortam</li>
</ul>

<h3>Uluslararası Okullar</h3>
<ul>
  <li>İngilizce eğitim, IB sistemi</li>
  <li>Cambridge, Amerikan veya İngiliz müfredatı</li>
  <li>Global üniversite planı için ideal</li>
</ul>
<p><em>Ücretler şehir ve okula göre ciddi değişkenlik gösterebiliyor.</em></p>

<h2>Çocuklar Dili Ne Kadar Sürede Öğreniyor?</h2>
<p>Özellikle <strong>3–8 yaş</strong> arasındaki çocuklarda adaptasyon beklenenden hızlı ilerliyor. Oyun, sosyal ilişki ve günlük tekrar sayesinde dil süreci oldukça doğal gelişebiliyor.</p>

<p>Birçok aile birkaç ay sonra çocuklarının eve İspanyolca kelimelerle dönmesine şaşırdığını söylüyor.</p>

<h2>Barcelona mı Valencia mı?</h2>

<h3>Barcelona</h3>
<ul>
  <li>Uluslararası, çok dilli yapı</li>
  <li>Yaratıcı sektörler ve Avrupa bağlantıları güçlü</li>
  <li>Yaşam maliyeti ve kira fiyatları yüksek</li>
</ul>

<h3>Valencia</h3>
<ul>
  <li>Daha sakin tempo, deniz erişimi</li>
  <li>Dengeli yaşam maliyeti</li>
  <li>Uzaktan çalışan aileler için ideal</li>
</ul>

<h3>Madrid</h3>
<ul>
  <li>Büyük şehir ritmi, iş ağı</li>
  <li>Güçlü ulaşım ve bilingual okul seçenekleri</li>
  <li>Metropolitan yaşam isteyenler için</li>
</ul>

<h3>Malaga</h3>
<ul>
  <li>Yavaş tempolu Akdeniz hissi</li>
  <li>İklim ve sakin yaşam</li>
  <li>Büyüyen teknoloji ekosistemi</li>
</ul>

<h2>Okul Kayıt Süreci</h2>
<p>Genellikle şu belgeler isteniyor:</p>
<ul>
  <li>Pasaport</li>
  <li>NIE numarası</li>
  <li>Adres kaydı (empadronamiento)</li>
  <li>Sağlık belgeleri ve aşı kartı</li>
  <li>Eski okul kayıtları</li>
</ul>

<p><strong>Önemli:</strong> Devlet okullarında adres büyük önem taşıyor çünkü yerleştirme sistemi çoğu zaman mahalle bazlı ilerliyor.</p>

<h2>Ailelerin En Sık Yaptığı Hata</h2>
<p>Birçok aile ilk etapta yalnızca okul listelerine odaklanıyor. Ama süreç ilerledikçe şunu fark ediyorlar: <strong>Günlük hayatı belirleyen şey çoğu zaman okuldan çok yaşam ritmi oluyor.</strong></p>

<p>Doğru planlama genellikle "En iyi okul hangisi?" sorusundan çok, <em>"Nasıl bir hayat istiyoruz?"</em> sorusuyla başlıyor.</p>

<h2><em>Nova Iberian</em> Nasıl Yardımcı Olur?</h2>
<p>İspanya'daki eğitim ve yaşam planınızı yalnızca okul kaydı üzerinden değil; günlük hayat, şehir seçimi ve uzun vadeli adaptasyon süreciyle birlikte ele alıyoruz.</p>
      `,
      en: `
<h2>Why Does Raising Children in Spain Feel Different?</h2>
<p>The most frequently asked question by families considering moving to Spain is usually not about residence permits, but about the <strong>education system</strong>. But as conversations progress, the matter often goes beyond school:</p>

<ul>
  <li>What language will the child grow up speaking?</li>
  <li>What will daily life feel like?</li>
  <li>What's the neighborhood culture like?</li>
  <li>Will they be able to walk home alone?</li>
  <li>What kind of social life will they have after school?</li>
</ul>

<p>Unlike the more exam-focused structure in Turkey, the Spanish education system emphasizes <strong>social development</strong>, communication skills, group work, and connection with daily life as natural parts of education.</p>

<p><em>"Here, children grow up a bit more like children."</em> - Families from Turkey</p>

<h2>How Does the Spanish Education System Work?</h2>
<p>In Spain, compulsory education is free between ages <strong>6–16</strong>. The system is largely aligned with European Union standards.</p>

<h3>Educación Infantil (Ages 0–6)</h3>
<p>Pre-school education period. Private nurseries for ages 0-3, state-supported free pre-school options for ages 3-6. Not compulsory but most families enroll their children early.</p>

<ul>
  <li>Play-based learning</li>
  <li>Social communication and group relationships</li>
  <li>Creativity, movement and exploration</li>
</ul>

<h3>Educación Primaria (Ages 6-12)</h3>
<p>Primary school lasts 6 years. Mathematics, science, social studies, art, sports and foreign language are core subjects.</p>

<p>For example, in Barcelona children often grow up with <strong>Spanish, Catalan and English</strong> together.</p>

<h3>ESO (Ages 12-16) - Compulsory Secondary Education</h3>
<p>Unlike Turkey's system, it's not just about exam success:</p>
<ul>
  <li>Project creation</li>
  <li>Group work</li>
  <li>Communication skills</li>
  <li>Research-focused assignments</li>
</ul>

<h3>Bachillerato (Ages 16–18)</h3>
<p>University preparation period. Students focus on science, social sciences, arts or technology. Spanish diplomas are <strong>widely recognized within the EU</strong>.</p>

<h2>Public or Private School?</h2>
<p>There are three main school models in Spain:</p>

<h3>Public Schools (Colegio Público)</h3>
<ul>
  <li>Free education</li>
  <li>Language support classes for foreign students</li>
  <li>Quick connection with local life</li>
</ul>
<p><em>Note: School quality can vary from region to region.</em></p>

<h3>Concertado Schools (Semi-Private)</h3>
<ul>
  <li>State-supported, privately managed hybrid structure</li>
  <li>More accessible fees</li>
  <li>Organized academic structure and controlled social environment</li>
</ul>

<h3>International Schools</h3>
<ul>
  <li>English education, IB system</li>
  <li>Cambridge, American or British curriculum</li>
  <li>Ideal for global university plans</li>
</ul>
<p><em>Fees can vary significantly by city and school.</em></p>

<h2>How Long Does It Take Children to Learn the Language?</h2>
<p>Especially for children aged <strong>3–8</strong>, adaptation progresses faster than expected. Through play, social relationships and daily repetition, language development can happen quite naturally.</p>

<p>Many families are surprised when their children start coming home with Spanish words after just a few months.</p>

<h2>Barcelona or Valencia?</h2>

<h3>Barcelona</h3>
<ul>
  <li>International, multilingual structure</li>
  <li>Strong creative sectors and European connections</li>
  <li>High cost of living and rent prices</li>
</ul>

<h3>Valencia</h3>
<ul>
  <li>Calmer pace, beach access</li>
  <li>Balanced cost of living</li>
  <li>Ideal for remote-working families</li>
</ul>

<h3>Madrid</h3>
<ul>
  <li>Big city rhythm, business network</li>
  <li>Strong transport and bilingual school options</li>
  <li>For those wanting metropolitan life</li>
</ul>

<h3>Malaga</h3>
<ul>
  <li>Slow-paced Mediterranean feel</li>
  <li>Climate and calm living</li>
  <li>Growing tech ecosystem</li>
</ul>

<h2>School Enrollment Process</h2>
<p>Generally required documents:</p>
<ul>
  <li>Passport</li>
  <li>NIE number</li>
  <li>Address registration (empadronamiento)</li>
  <li>Health documents and vaccination card</li>
  <li>Previous school records</li>
</ul>

<p><strong>Important:</strong> In public schools, address is very important as the placement system often works on a neighborhood basis.</p>

<h2>The Most Common Mistake Families Make</h2>
<p>Many families initially focus only on school lists. But as the process progresses, they realize: <strong>What determines daily life is often the rhythm of life rather than the school.</strong></p>

<p>Proper planning usually starts not with "Which is the best school?" but with <em>"What kind of life do we want?"</em></p>

<h2>How <em>Nova Iberian</em> Helps?</h2>
<p>We approach your education and life plan in Spain not just through school enrollment, but together with daily life, city selection and long-term adaptation process.</p>
      `,
      es: `
<h2>¿Por Qué Criar Hijos en España Se Siente Diferente?</h2>
<p>La pregunta más frecuente de las familias que consideran mudarse a España no suele ser sobre permisos de residencia, sino sobre el <strong>sistema educativo</strong>. Pero a medida que avanzan las conversaciones, el tema a menudo va más allá de la escuela:</p>

<ul>
  <li>¿En qué idioma crecerá el niño?</li>
  <li>¿Cómo se sentirá la vida diaria?</li>
  <li>¿Cómo es la cultura del barrio?</li>
  <li>¿Podrá volver a casa caminando solo?</li>
  <li>¿Qué tipo de vida social tendrá después de la escuela?</li>
</ul>

<p>A diferencia de la estructura más centrada en exámenes de Turquía, el sistema educativo español enfatiza el <strong>desarrollo social</strong>, las habilidades de comunicación, el trabajo en grupo y la conexión con la vida diaria como partes naturales de la educación.</p>

<p><em>"Aquí, los niños crecen un poco más como niños."</em> - Familias de Turquía</p>

<h2>¿Cómo Funciona el Sistema Educativo Español?</h2>
<p>En España, la educación obligatoria es gratuita entre los <strong>6 y 16 años</strong>. El sistema está ampliamente alineado con los estándares de la Unión Europea.</p>

<h3>Educación Infantil (0–6 Años)</h3>
<p>Período de educación preescolar. Guarderías privadas para 0-3 años, opciones preescolares gratuitas con apoyo estatal para 3-6 años. No es obligatorio pero la mayoría de las familias inscriben a sus hijos temprano.</p>

<ul>
  <li>Aprendizaje basado en el juego</li>
  <li>Comunicación social y relaciones grupales</li>
  <li>Creatividad, movimiento y exploración</li>
</ul>

<h3>Educación Primaria (6-12 Años)</h3>
<p>La escuela primaria dura 6 años. Matemáticas, ciencias, estudios sociales, arte, deportes e idioma extranjero son materias básicas.</p>

<p>Por ejemplo, en Barcelona los niños a menudo crecen con <strong>español, catalán e inglés</strong> juntos.</p>

<h3>ESO (12-16 Años) - Educación Secundaria Obligatoria</h3>
<p>A diferencia del sistema turco, no se trata solo del éxito en los exámenes:</p>
<ul>
  <li>Creación de proyectos</li>
  <li>Trabajo en grupo</li>
  <li>Habilidades de comunicación</li>
  <li>Tareas centradas en la investigación</li>
</ul>

<h3>Bachillerato (16–18 Años)</h3>
<p>Período de preparación universitaria. Los estudiantes se enfocan en ciencias, ciencias sociales, artes o tecnología. Los diplomas españoles están <strong>ampliamente reconocidos dentro de la UE</strong>.</p>

<h2>¿Escuela Pública o Privada?</h2>
<p>Hay tres modelos principales de escuelas en España:</p>

<h3>Escuelas Públicas (Colegio Público)</h3>
<ul>
  <li>Educación gratuita</li>
  <li>Clases de apoyo lingüístico para estudiantes extranjeros</li>
  <li>Conexión rápida con la vida local</li>
</ul>
<p><em>Nota: La calidad de las escuelas puede variar de una región a otra.</em></p>

<h3>Colegios Concertados (Semi-Privados)</h3>
<ul>
  <li>Estructura híbrida con apoyo estatal y gestión privada</li>
  <li>Tarifas más accesibles</li>
  <li>Estructura académica organizada y ambiente social controlado</li>
</ul>

<h3>Colegios Internacionales</h3>
<ul>
  <li>Educación en inglés, sistema IB</li>
  <li>Currículo Cambridge, americano o británico</li>
  <li>Ideal para planes universitarios globales</li>
</ul>
<p><em>Las tarifas pueden variar significativamente según la ciudad y la escuela.</em></p>

<h2>¿Cuánto Tiempo Tardan los Niños en Aprender el Idioma?</h2>
<p>Especialmente para niños de <strong>3 a 8 años</strong>, la adaptación progresa más rápido de lo esperado. A través del juego, las relaciones sociales y la repetición diaria, el desarrollo del idioma puede ocurrir de forma bastante natural.</p>

<p>Muchas familias se sorprenden cuando sus hijos empiezan a volver a casa con palabras en español después de solo unos meses.</p>

<h2>¿Barcelona o Valencia?</h2>

<h3>Barcelona</h3>
<ul>
  <li>Estructura internacional y multilingüe</li>
  <li>Fuertes sectores creativos y conexiones europeas</li>
  <li>Alto costo de vida y precios de alquiler</li>
</ul>

<h3>Valencia</h3>
<ul>
  <li>Ritmo más tranquilo, acceso a la playa</li>
  <li>Costo de vida equilibrado</li>
  <li>Ideal para familias que trabajan en remoto</li>
</ul>

<h3>Madrid</h3>
<ul>
  <li>Ritmo de gran ciudad, red de negocios</li>
  <li>Fuerte transporte y opciones de escuelas bilingües</li>
  <li>Para quienes quieren vida metropolitana</li>
</ul>

<h3>Málaga</h3>
<ul>
  <li>Ambiente mediterráneo de ritmo lento</li>
  <li>Clima y vida tranquila</li>
  <li>Ecosistema tecnológico en crecimiento</li>
</ul>

<h2>Proceso de Inscripción Escolar</h2>
<p>Documentos generalmente requeridos:</p>
<ul>
  <li>Pasaporte</li>
  <li>Número NIE</li>
  <li>Registro de dirección (empadronamiento)</li>
  <li>Documentos de salud y cartilla de vacunación</li>
  <li>Registros escolares anteriores</li>
</ul>

<p><strong>Importante:</strong> En las escuelas públicas, la dirección es muy importante ya que el sistema de asignación a menudo funciona por barrio.</p>

<h2>El Error Más Común que Cometen las Familias</h2>
<p>Muchas familias inicialmente se centran solo en las listas de escuelas. Pero a medida que avanza el proceso, se dan cuenta: <strong>Lo que determina la vida diaria es a menudo el ritmo de vida más que la escuela.</strong></p>

<p>La planificación adecuada generalmente no comienza con "¿Cuál es la mejor escuela?" sino con <em>"¿Qué tipo de vida queremos?"</em></p>

<h2>¿Cómo Ayuda <em>Nova Iberian</em>?</h2>
<p>Abordamos su plan educativo y de vida en España no solo a través de la inscripción escolar, sino junto con la vida diaria, la selección de ciudad y el proceso de adaptación a largo plazo.</p>
      `
    }
  }
};

export default blogPosts;
